import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReferenceType<T extends {__typename?: string; id?: string | number}> = { __typename: T['__typename'], id: T['id'] }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date in ISO-8601 format */
  Date: { input: any; output: any; }
  /** DateTime in ISO-8601 format always in UTC time zone */
  DateTime: { input: Date; output: Date; }
};

export type AcceleratePress = {
  __typename?: 'AcceleratePress';
  distance?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
};

export enum ActionType {
  LOAD = 'LOAD',
  UNLOAD = 'UNLOAD'
}

export type ActivateDriverAppInputType = {
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateDriverAppMutationType = {
  __typename?: 'ActivateDriverAppMutationType';
  clientId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  fcmRegistrationToken?: Maybe<Scalars['String']['output']>;
  googleUserId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  linkedAt?: Maybe<Scalars['DateTime']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ApiAccounts = {
  __typename?: 'ApiAccounts';
  /** API account for Gbox Authorization type */
  gboxAuthorization?: Maybe<GboxAuthorizationAccount>;
  /** API account for partner type */
  partner?: Maybe<PartnerAccount>;
};


export type ApiAccountsPartnerArgs = {
  prefix?: InputMaybe<PartnerAccountPrefix>;
};

export type ApiAccountsModule = {
  __typename?: 'ApiAccountsModule';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  partner?: Maybe<Scalars['Boolean']['output']>;
};

export type Auth = {
  __typename?: 'Auth';
  /** Get Here token basing on authorization */
  hereToken?: Maybe<AuthHereTokenType>;
};

export type AuthHereTokenType = {
  __typename?: 'AuthHereTokenType';
  accessToken?: Maybe<Scalars['String']['output']>;
};

export type CancelEtaLightTaskMutationType = {
  __typename?: 'CancelEtaLightTaskMutationType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  eta?: Maybe<Eta>;
  id?: Maybe<Scalars['String']['output']>;
  plannedArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<EtaLightTaskStatus>;
  target?: Maybe<TargetType>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  vehicleId?: Maybe<Scalars['Int']['output']>;
};

export type CargoEvent = {
  __typename?: 'CargoEvent';
  action?: Maybe<ActionType>;
  cargoId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  registeredAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<UnloadType>;
  unloadId?: Maybe<Scalars['String']['output']>;
};

export type CargoEventListPageInfo = {
  __typename?: 'CargoEventListPageInfo';
  pageCount?: Maybe<Scalars['Int']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
};

export type CargoEvents = {
  __typename?: 'CargoEvents';
  edges: Array<Maybe<CargoEvent>>;
  pageInfo: CargoEventListPageInfo;
};

export type CargoMutationType = {
  __typename?: 'CargoMutationType';
  /** Create cargo loading */
  createLoading?: Maybe<CreateCargoLoadingMutationType>;
  /** Create cargo unloading */
  createUnloading?: Maybe<CreateCargoUnloadingMutationType>;
};


export type CargoMutationTypeCreateLoadingArgs = {
  cargoId: Scalars['String']['input'];
  payload: CreateCargoLoadingInputType;
};


export type CargoMutationTypeCreateUnloadingArgs = {
  cargoId: Scalars['String']['input'];
  payload: CreateCargoUnloadingInputType;
};

export type Client = {
  __typename?: 'Client';
  /** API accounts for client */
  apiAccounts?: Maybe<ApiAccounts>;
  /** Aggregate data related with auth */
  auth?: Maybe<Auth>;
  /** List of drivers */
  drivers?: Maybe<Array<Maybe<Driver>>>;
  /** Virtual aggregator for eco-driving types */
  ecoDriving?: Maybe<EcoDrivingType>;
  /** Virtual aggregator for EtaLight types */
  etaLight?: Maybe<EtaLightType>;
  /**
   * List of tasks light
   * @deprecated You should use client.etaLight.tasks leaf instead of this one.
   */
  etaLightTasks?: Maybe<Array<Maybe<EtaLightTask>>>;
  /** Clients feature flags */
  featureFlags?: Maybe<FeatureFlagsType>;
  /** Client's company full name */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Client's id */
  id?: Maybe<Scalars['Int']['output']>;
  /** If client is internal */
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  /** If panel belongs to two or more companies */
  isJoint?: Maybe<Scalars['Boolean']['output']>;
  /** Client's name */
  name?: Maybe<Scalars['String']['output']>;
  /** List of order tasks */
  orderTasks?: Maybe<Array<Maybe<OrderTask>>>;
  /** Settings for client */
  settings?: Maybe<Settings>;
  /** TachoRemote data for client */
  tachoRemote?: Maybe<TachoRemoteType>;
  /** List of drivers tasks */
  tasks?: Maybe<Array<Maybe<Task>>>;
  /** List of vehicle types */
  vehicleTypes?: Maybe<Array<Maybe<VehicleType>>>;
  /** List of vehicles */
  vehicles?: Maybe<Array<Maybe<Vehicle>>>;
  /** List of vehicles groups */
  vehiclesGroups?: Maybe<Array<Maybe<VehicleGroupType>>>;
};


export type ClientDriversArgs = {
  applicationLinkStatus?: InputMaybe<DriverApplicationLinkStatus>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ClientEtaLightTasksArgs = {
  status?: InputMaybe<EtaLightTaskStatus>;
  statuses?: InputMaybe<Array<InputMaybe<EtaLightTaskStatus>>>;
};


export type ClientOrderTasksArgs = {
  legacy?: InputMaybe<LegacyTaskFilter>;
  status?: InputMaybe<TaskStatus>;
};


export type ClientTasksArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TaskStatus>;
};


export type ClientVehiclesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type Client4Trans = {
  __typename?: 'Client4Trans';
  /** List of cargo load/unload events gathered from Driver App */
  cargoEvents?: Maybe<CargoEvents>;
  /** List of drivers */
  drivers?: Maybe<Array<Maybe<Driver>>>;
};


export type Client4TransCargoEventsArgs = {
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from: Scalars['DateTime']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  to: Scalars['DateTime']['input'];
};


export type Client4TransDriversArgs = {
  applicationLinkStatus?: InputMaybe<DriverApplicationLinkStatus>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Coordinate = {
  __typename?: 'Coordinate';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type CreateCargoLoadingInputType = {
  country?: InputMaybe<Scalars['String']['input']>;
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateCargoLoadingMutationType = {
  __typename?: 'CreateCargoLoadingMutationType';
  country?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  registeredAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CreateCargoUnloadingInputType = {
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<UnloadType>;
};

export type CreateCargoUnloadingMutationType = {
  __typename?: 'CreateCargoUnloadingMutationType';
  cargoId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  registeredAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CreateDriverInputType = {
  driverCard: DriverCardInputType;
  driverIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone: DriverPhoneInputType;
  pin?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  workNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDriverMutationType = {
  __typename?: 'CreateDriverMutationType';
  clientId?: Maybe<Scalars['Int']['output']>;
  driverCard?: Maybe<DriverCard>;
  driverIdentificationNumber?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<DriverPhone>;
  pin?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  workNumber?: Maybe<Scalars['String']['output']>;
};

export type CreateEtaLightTaskCoordsInput = {
  /** Coords latitude */
  lat: Scalars['Float']['input'];
  /** Coords longitude */
  lng: Scalars['Float']['input'];
};

export type CreateEtaLightTaskInput = {
  /** Planned arrival time when driver should be in the place (optional) */
  plannedArrivalTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Task destination details */
  target: CreateEtaLightTaskTargetInput;
  /** Vehicle ID for which task will be created */
  vehicleId: Scalars['Int']['input'];
};

export type CreateEtaLightTaskMutationType = {
  __typename?: 'CreateEtaLightTaskMutationType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  eta?: Maybe<Eta>;
  id?: Maybe<Scalars['String']['output']>;
  plannedArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<EtaLightTaskStatus>;
  target?: Maybe<TargetType>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  vehicleId?: Maybe<Scalars['Int']['output']>;
};

export type CreateEtaLightTaskTargetInput = {
  /** Task destination address */
  address: Scalars['String']['input'];
  /** Task destination coords */
  coords: CreateEtaLightTaskCoordsInput;
};

export type CreateGboxAuthorizationAccountMutationType = {
  __typename?: 'CreateGboxAuthorizationAccountMutationType';
  id?: Maybe<Scalars['Int']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CreatePartnerAccountMutationType = {
  __typename?: 'CreatePartnerAccountMutationType';
  id?: Maybe<Scalars['Int']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CruiseControl = {
  __typename?: 'CruiseControl';
  distance?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
};

export type Customer = {
  __typename?: 'Customer';
  companyName?: Maybe<Scalars['String']['output']>;
};

export type CustomerArea = {
  __typename?: 'CustomerArea';
  /** Contracts list */
  contracts?: Maybe<CustomerAreaContractsResponse>;
  /** Payments list */
  payments?: Maybe<Array<CustomerAreaPayment>>;
};


export type CustomerAreaPaymentsArgs = {
  since: Scalars['Date']['input'];
};

export type CustomerAreaContract = {
  __typename?: 'CustomerAreaContract';
  /** Contract features */
  features: Array<Scalars['String']['output']>;
  /** Details of the licence for the contract */
  licence: CustomerAreaContractLicence;
  /** Vehicle registration number */
  registrationNumber: Scalars['String']['output'];
  /** Contract state */
  state: CustomerAreaContractState;
  /** Contract type */
  type: Scalars['String']['output'];
  /** Vehicle ID */
  vehicleId: Scalars['Int']['output'];
};

export type CustomerAreaContractLicence = {
  __typename?: 'CustomerAreaContractLicence';
  /** Payment amount */
  amount: Scalars['Float']['output'];
  /** Payment currency */
  currency: Scalars['String']['output'];
  /** Licence name */
  name: Scalars['String']['output'];
};

export enum CustomerAreaContractState {
  ACTIVE = 'ACTIVE',
  ACTIVE_WITHOUT_INSTALLATION = 'ACTIVE_WITHOUT_INSTALLATION',
  BEFORE_ACTIVATION = 'BEFORE_ACTIVATION',
  IN_TERMINATION = 'IN_TERMINATION',
  NONE = 'NONE',
  SUSPENDED = 'SUSPENDED',
  TERMINATED = 'TERMINATED',
  UNKNOWN = 'UNKNOWN'
}

export type CustomerAreaContractsResponse = {
  __typename?: 'CustomerAreaContractsResponse';
  /** List of contracts */
  data?: Maybe<Array<CustomerAreaContract>>;
};

export type CustomerAreaPayment = {
  __typename?: 'CustomerAreaPayment';
  /** Payment amount */
  amount: CustomerAreaPaymentAmount;
  /** Issue date */
  date: Scalars['Date']['output'];
  /** Document number */
  number: Scalars['String']['output'];
  /** Payment status */
  status: CustomerAreaPaymentStatus;
  /** Payment term */
  term: Scalars['Date']['output'];
};

export type CustomerAreaPaymentAmount = {
  __typename?: 'CustomerAreaPaymentAmount';
  /** Payment currency */
  currency: Scalars['String']['output'];
  /** Gross amount */
  gross: Scalars['Float']['output'];
  /** Net amount */
  net: Scalars['Float']['output'];
};

export enum CustomerAreaPaymentStatus {
  AWAITING = 'AWAITING',
  NOT_SUBJECT = 'NOT_SUBJECT',
  PAID = 'PAID',
  PARTIALLY_PAID = 'PARTIALLY_PAID'
}

export type DailyData = {
  __typename?: 'DailyData';
  acceleratePressed?: Maybe<AcceleratePress>;
  accelerateReleased?: Maybe<AcceleratePress>;
  accelerateUnknown?: Maybe<AcceleratePress>;
  avgFuelConsumption?: Maybe<Scalars['Float']['output']>;
  avgRPM?: Maybe<Scalars['Int']['output']>;
  avgSpeed?: Maybe<Scalars['Float']['output']>;
  cruiseControl?: Maybe<CruiseControl>;
  date?: Maybe<Scalars['Date']['output']>;
  distance?: Maybe<Scalars['Int']['output']>;
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
  speedExceeds?: Maybe<Scalars['Int']['output']>;
  stopOnEngine?: Maybe<StopOnEngine>;
};

export type DateRangeData = {
  __typename?: 'DateRangeData';
  from?: Maybe<Scalars['Date']['output']>;
  to?: Maybe<Scalars['Date']['output']>;
};

export type DeactivateDriverAppMutationType = {
  __typename?: 'DeactivateDriverAppMutationType';
  id: Scalars['String']['output'];
};

export type DeactivateDriverMutationType = {
  __typename?: 'DeactivateDriverMutationType';
  id: Scalars['String']['output'];
};

export type DeprecatedEcoDrivingSettings = {
  __typename?: 'DeprecatedEcoDrivingSettings';
  fuelUsageNorm?: Maybe<Scalars['Float']['output']>;
  maxAllowedSpeed?: Maybe<Scalars['Int']['output']>;
  maxRPM?: Maybe<Scalars['Int']['output']>;
  minRPM?: Maybe<Scalars['Int']['output']>;
};

export type Driver = {
  __typename?: 'Driver';
  applicationLinkStatus?: Maybe<DriverApplicationLinkStatus>;
  clientId?: Maybe<Scalars['Int']['output']>;
  driverCard?: Maybe<DriverCard>;
  driverIdentificationNumber?: Maybe<Scalars['String']['output']>;
  driverState?: Maybe<DriverState>;
  /** Driver's eco-driving statistics */
  ecoDriving?: Maybe<EcoDrivingDriverStatistics>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  identificationId?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isAuthorized?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<DriverPhone>;
  pin?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  /** Driver's current vehicle */
  vehicle?: Maybe<Vehicle>;
  workNumber?: Maybe<Scalars['String']['output']>;
};


export type DriverEcoDrivingArgs = {
  driverIdentification: Scalars['String']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};

export type DriverAppModule = {
  __typename?: 'DriverAppModule';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export enum DriverApplicationLinkStatus {
  CONNECTED = 'CONNECTED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_CONNECTED = 'NOT_CONNECTED'
}

export type DriverCard = {
  __typename?: 'DriverCard';
  countryCode?: Maybe<Scalars['Int']['output']>;
  countryCodeLabel?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type DriverCardInputType = {
  countryCode?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export enum DriverCardReadingSource {
  GBOXREADER = 'GBOXREADER',
  TACHOREMOTE = 'TACHOREMOTE'
}

export type DriverMutationType = {
  __typename?: 'DriverMutationType';
  /** Activate driver app */
  activateDriverApp?: Maybe<ActivateDriverAppMutationType>;
  /** Create driver */
  create?: Maybe<CreateDriverMutationType>;
  /** Deactivate driver */
  deactivate?: Maybe<DeactivateDriverMutationType>;
  /** Deactivate driver app */
  deactivateDriverApp?: Maybe<DeactivateDriverAppMutationType>;
  /** Update driver */
  update?: Maybe<UpdateDriverMutationType>;
};


export type DriverMutationTypeActivateDriverAppArgs = {
  id: Scalars['String']['input'];
  payload: ActivateDriverAppInputType;
};


export type DriverMutationTypeCreateArgs = {
  payload: CreateDriverInputType;
};


export type DriverMutationTypeDeactivateArgs = {
  id: Scalars['String']['input'];
};


export type DriverMutationTypeDeactivateDriverAppArgs = {
  id: Scalars['String']['input'];
};


export type DriverMutationTypeUpdateArgs = {
  id: Scalars['String']['input'];
  payload: UpdateDriverInputType;
};

export type DriverPhone = {
  __typename?: 'DriverPhone';
  number?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
};

export type DriverPhoneInputType = {
  number?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
};

export enum DriverState {
  IDENTIFIED = 'IDENTIFIED',
  NO_DATA = 'NO_DATA',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNRECOGNIZED_ID_NUMBER = 'UNRECOGNIZED_ID_NUMBER'
}

export type DriverStatusType = {
  __typename?: 'DriverStatusType';
  date?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DriverUnknown = {
  __typename?: 'DriverUnknown';
  driverCardNumber?: Maybe<Scalars['String']['output']>;
  driverState?: Maybe<DriverState>;
  identificationId?: Maybe<Scalars['String']['output']>;
  isAuthorized?: Maybe<Scalars['Boolean']['output']>;
};

export type DriverVehicleInfo = {
  __typename?: 'DriverVehicleInfo';
  boxId?: Maybe<Scalars['Int']['output']>;
  registerNumber?: Maybe<Scalars['String']['output']>;
};

export type EtollModule = {
  __typename?: 'ETOLLModule';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type EcoDrivingAttachVehiclesToVehiclesGroupInputType = {
  vehiclesIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type EcoDrivingAttachVehiclesToVehiclesGroupMutationType = {
  __typename?: 'EcoDrivingAttachVehiclesToVehiclesGroupMutationType';
  vehiclesIds: Array<Maybe<Scalars['Int']['output']>>;
};

export type EcoDrivingCompanyMonthlyDataType = {
  __typename?: 'EcoDrivingCompanyMonthlyDataType';
  avgFuelConsumption?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  distance?: Maybe<Scalars['Int']['output']>;
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
};

export type EcoDrivingCompanyStatisticsType = {
  __typename?: 'EcoDrivingCompanyStatisticsType';
  avgFuelConsumption?: Maybe<Scalars['Float']['output']>;
  monthlyData?: Maybe<Array<Maybe<EcoDrivingCompanyMonthlyDataType>>>;
  rpmDistribution?: Maybe<RpmDistribution>;
  totalDistance?: Maybe<Scalars['Int']['output']>;
  totalFuelConsumption?: Maybe<Scalars['Float']['output']>;
};

export type EcoDrivingCreateVehiclesGroupInputType = {
  clientId: Scalars['Int']['input'];
  fuelUsageNorm: Scalars['Float']['input'];
  fuelUsageNormForEmpty: Scalars['Float']['input'];
  maxAllowedSpeed: Scalars['Int']['input'];
  maxRPM: Scalars['Int']['input'];
  minRPM: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  stepFuelConsumptionPerTon: Scalars['Float']['input'];
  tractorWeight: Scalars['Float']['input'];
};

export type EcoDrivingCreateVehiclesGroupMutationType = {
  __typename?: 'EcoDrivingCreateVehiclesGroupMutationType';
  clientId?: Maybe<Scalars['Int']['output']>;
  fuelUsageNorm?: Maybe<Scalars['Float']['output']>;
  fuelUsageNormForEmpty?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  maxAllowedSpeed?: Maybe<Scalars['Int']['output']>;
  maxRPM?: Maybe<Scalars['Int']['output']>;
  minRPM?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stepFuelConsumptionPerTon?: Maybe<Scalars['Float']['output']>;
  tractorWeight?: Maybe<Scalars['Float']['output']>;
  vehiclesIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type EcoDrivingDeleteVehiclesGroupMutationType = {
  __typename?: 'EcoDrivingDeleteVehiclesGroupMutationType';
  id?: Maybe<Scalars['Int']['output']>;
};

export type EcoDrivingDetachVehiclesToVehiclesGroupInputType = {
  vehiclesIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type EcoDrivingDetachVehiclesToVehiclesGroupMutationType = {
  __typename?: 'EcoDrivingDetachVehiclesToVehiclesGroupMutationType';
  vehiclesIds: Array<Maybe<Scalars['Int']['output']>>;
};

export type EcoDrivingDriverRankingParametersType = {
  tonnage: EcoDrivingDriverRankingTonnageParameterType;
};

export enum EcoDrivingDriverRankingTonnageParameterType {
  ALL = 'all',
  AXLELOAD = 'axleLoad',
  DEFAULT = 'default',
  NONE = 'none',
  TOTALLOAD = 'totalLoad'
}

export type EcoDrivingDriverRankingType = {
  __typename?: 'EcoDrivingDriverRankingType';
  avgFuelConsumption?: Maybe<Scalars['Float']['output']>;
  cruiseControl?: Maybe<CruiseControl>;
  distance?: Maybe<Scalars['Int']['output']>;
  driver?: Maybe<Driver>;
  driverIdentification?: Maybe<Scalars['String']['output']>;
  fuelSaving?: Maybe<Scalars['Float']['output']>;
  grade?: Maybe<Scalars['Float']['output']>;
  loadPart?: Maybe<LoadPart>;
  vehicles?: Maybe<Array<Maybe<DriverVehicleInfo>>>;
};

export type EcoDrivingDriverStatistics = {
  __typename?: 'EcoDrivingDriverStatistics';
  avgFuelConsumption?: Maybe<Scalars['Float']['output']>;
  avgRPM?: Maybe<Scalars['Float']['output']>;
  avgSpeed?: Maybe<Scalars['Float']['output']>;
  dailyData?: Maybe<Array<Maybe<DailyData>>>;
  fuelSaving?: Maybe<Scalars['Float']['output']>;
  rpmDistribution?: Maybe<RpmDistribution>;
  totalAcceleratePressed?: Maybe<AcceleratePress>;
  totalAccelerateReleased?: Maybe<AcceleratePress>;
  totalAccelerateUnknown?: Maybe<AcceleratePress>;
  totalCruiseControl?: Maybe<CruiseControl>;
  totalDistance?: Maybe<Scalars['Int']['output']>;
  totalFuelConsumption?: Maybe<Scalars['Float']['output']>;
  totalSpeedExceeds?: Maybe<Scalars['Int']['output']>;
  totalStopOnEngine?: Maybe<StopOnEngine>;
  vehicleData?: Maybe<Array<Maybe<VehicleData>>>;
};

export type EcoDrivingGroup = {
  __typename?: 'EcoDrivingGroup';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type EcoDrivingModule = {
  __typename?: 'EcoDrivingModule';
  cruiseControl?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  groups?: Maybe<Scalars['Boolean']['output']>;
  pdfExport?: Maybe<Scalars['Boolean']['output']>;
  ranking?: Maybe<Scalars['Boolean']['output']>;
  retarder?: Maybe<Scalars['Boolean']['output']>;
  tonnage?: Maybe<Scalars['Boolean']['output']>;
};

export type EcoDrivingMutationType = {
  __typename?: 'EcoDrivingMutationType';
  /** Attach vehicles to vehicles group for EcoDriving */
  attachVehiclesToVehiclesGroup?: Maybe<EcoDrivingAttachVehiclesToVehiclesGroupMutationType>;
  /** Create vehicles group for EcoDriving */
  createVehiclesGroup?: Maybe<EcoDrivingCreateVehiclesGroupMutationType>;
  /** Delete vehicles group for EcoDriving */
  deleteVehiclesGroup?: Maybe<EcoDrivingDeleteVehiclesGroupMutationType>;
  /** Detach vehicles from vehicles group for EcoDriving */
  detachVehiclesFromVehiclesGroup?: Maybe<EcoDrivingDetachVehiclesToVehiclesGroupMutationType>;
  /** Update EcoDriving settings for company */
  updateSettings?: Maybe<EcoDrivingUpdateSettingsMutationType>;
  /** Update vehicles group for EcoDriving */
  updateVehiclesGroup?: Maybe<EcoDrivingUpdateVehiclesGroupMutationType>;
};


export type EcoDrivingMutationTypeAttachVehiclesToVehiclesGroupArgs = {
  id: Scalars['Int']['input'];
  payload: EcoDrivingAttachVehiclesToVehiclesGroupInputType;
};


export type EcoDrivingMutationTypeCreateVehiclesGroupArgs = {
  payload: EcoDrivingCreateVehiclesGroupInputType;
};


export type EcoDrivingMutationTypeDeleteVehiclesGroupArgs = {
  id: Scalars['Int']['input'];
};


export type EcoDrivingMutationTypeDetachVehiclesFromVehiclesGroupArgs = {
  payload: EcoDrivingDetachVehiclesToVehiclesGroupInputType;
};


export type EcoDrivingMutationTypeUpdateSettingsArgs = {
  payload: EcoDrivingUpdateSettingsInputType;
};


export type EcoDrivingMutationTypeUpdateVehiclesGroupArgs = {
  id: Scalars['Int']['input'];
  payload: EcoDrivingUpdateVehiclesGroupInputType;
};

export type EcoDrivingSettingsType = {
  __typename?: 'EcoDrivingSettingsType';
  fuelUsageNorm?: Maybe<Scalars['Float']['output']>;
  fuelUsageNormForEmpty?: Maybe<Scalars['Float']['output']>;
  maxAllowedSpeed?: Maybe<Scalars['Int']['output']>;
  maxRPM?: Maybe<Scalars['Int']['output']>;
  minRPM?: Maybe<Scalars['Int']['output']>;
  stepFuelConsumptionPerTon?: Maybe<Scalars['Float']['output']>;
  tractorWeight?: Maybe<Scalars['Float']['output']>;
};

export type EcoDrivingType = {
  __typename?: 'EcoDrivingType';
  /** EcoDriving drivers ranking for company */
  driversRanking?: Maybe<Array<Maybe<EcoDrivingDriverRankingType>>>;
  /** EcoDriving settings */
  settings?: Maybe<EcoDrivingSettingsType>;
  /** EcoDriving statistics for company */
  statistics?: Maybe<EcoDrivingCompanyStatisticsType>;
  /** EcoDriving vehicle groups */
  vehiclesGroups?: Maybe<Array<Maybe<EcoDrivingVehicleGroupType>>>;
};


export type EcoDrivingTypeDriversRankingArgs = {
  from: Scalars['Date']['input'];
  parameters?: InputMaybe<EcoDrivingDriverRankingParametersType>;
  to: Scalars['Date']['input'];
};


export type EcoDrivingTypeStatisticsArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};

export type EcoDrivingUpdateSettingsInputType = {
  clientId: Scalars['Int']['input'];
  fuelUsageNorm: Scalars['Float']['input'];
  maxAllowedSpeed: Scalars['Int']['input'];
  maxRPM: Scalars['Int']['input'];
  minRPM: Scalars['Int']['input'];
};

export type EcoDrivingUpdateSettingsMutationType = {
  __typename?: 'EcoDrivingUpdateSettingsMutationType';
  fuelUsageNorm?: Maybe<Scalars['Float']['output']>;
  maxAllowedSpeed?: Maybe<Scalars['Int']['output']>;
  maxRPM?: Maybe<Scalars['Int']['output']>;
  minRPM?: Maybe<Scalars['Int']['output']>;
};

export type EcoDrivingUpdateVehiclesGroupInputType = {
  clientId: Scalars['Int']['input'];
  fuelUsageNorm: Scalars['Float']['input'];
  fuelUsageNormForEmpty: Scalars['Float']['input'];
  maxAllowedSpeed: Scalars['Int']['input'];
  maxRPM: Scalars['Int']['input'];
  minRPM: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  stepFuelConsumptionPerTon: Scalars['Float']['input'];
  tractorWeight: Scalars['Float']['input'];
};

export type EcoDrivingUpdateVehiclesGroupMutationType = {
  __typename?: 'EcoDrivingUpdateVehiclesGroupMutationType';
  clientId?: Maybe<Scalars['Int']['output']>;
  fuelUsageNorm?: Maybe<Scalars['Float']['output']>;
  fuelUsageNormForEmpty?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  maxAllowedSpeed?: Maybe<Scalars['Int']['output']>;
  maxRPM?: Maybe<Scalars['Int']['output']>;
  minRPM?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stepFuelConsumptionPerTon?: Maybe<Scalars['Float']['output']>;
  tractorWeight?: Maybe<Scalars['Float']['output']>;
  vehiclesIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type EcoDrivingVehicleGroupType = {
  __typename?: 'EcoDrivingVehicleGroupType';
  clientId?: Maybe<Scalars['Int']['output']>;
  fuelUsageNorm?: Maybe<Scalars['Float']['output']>;
  fuelUsageNormForEmpty?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  maxAllowedSpeed?: Maybe<Scalars['Int']['output']>;
  maxRPM?: Maybe<Scalars['Int']['output']>;
  minRPM?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stepFuelConsumptionPerTon?: Maybe<Scalars['Float']['output']>;
  tractorWeight?: Maybe<Scalars['Float']['output']>;
  vehiclesIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type Eta = {
  __typename?: 'Eta';
  arrival?: Maybe<EtaArrival>;
  /** @deprecated Not supported anymore */
  boxId?: Maybe<Scalars['Int']['output']>;
  calculatedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentRest?: Maybe<EtaCurrentRest>;
  departure?: Maybe<Scalars['DateTime']['output']>;
  distance?: Maybe<EtaDistance>;
  restsTaken?: Maybe<Array<Maybe<EtaRestTakenType>>>;
  status?: Maybe<TaskEtaStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Not supported anymore */
  workTimeActivities?: Maybe<Array<Maybe<WorkTimeActivity>>>;
};

export type EtaArrival = {
  __typename?: 'EtaArrival';
  fromRouting?: Maybe<Scalars['DateTime']['output']>;
  withWorkTime?: Maybe<Scalars['DateTime']['output']>;
};

export type EtaCurrentRest = {
  __typename?: 'EtaCurrentRest';
  period?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EtaDistance = {
  __typename?: 'EtaDistance';
  left?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type EtaLightModule = {
  __typename?: 'EtaLightModule';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  vehicles?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type EtaLightTask = EtaMonitor & {
  __typename?: 'EtaLightTask';
  cancelReason?: Maybe<TaskCancelReason>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  eta?: Maybe<Eta>;
  etaTimeStatus?: Maybe<EtaTimeStatus>;
  id?: Maybe<Scalars['Int']['output']>;
  isCalculated?: Maybe<Scalars['Boolean']['output']>;
  isCanceled?: Maybe<Scalars['Boolean']['output']>;
  isEndangered?: Maybe<Scalars['Boolean']['output']>;
  isEtaLightSource?: Maybe<Scalars['Boolean']['output']>;
  isExceeded?: Maybe<Scalars['Boolean']['output']>;
  isOk?: Maybe<Scalars['Boolean']['output']>;
  isOrderTaskSource?: Maybe<Scalars['Boolean']['output']>;
  isUnknown?: Maybe<Scalars['Boolean']['output']>;
  plannedArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EtaLightTaskStatus>;
  target?: Maybe<TargetType>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  vehicleId?: Maybe<Scalars['Int']['output']>;
};

export type EtaLightTaskMutationType = {
  __typename?: 'EtaLightTaskMutationType';
  /** Finish ETA Light task */
  cancel?: Maybe<CancelEtaLightTaskMutationType>;
  /** Create ETA Light task */
  create?: Maybe<CreateEtaLightTaskMutationType>;
};


export type EtaLightTaskMutationTypeCancelArgs = {
  id: Scalars['Int']['input'];
};


export type EtaLightTaskMutationTypeCreateArgs = {
  payload: CreateEtaLightTaskInput;
};

export enum EtaLightTaskStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NEW = 'NEW'
}

export type EtaLightType = {
  __typename?: 'EtaLightType';
  /** List of tasks light */
  tasks?: Maybe<Array<Maybe<EtaLightTask>>>;
  /** List of usage */
  usage?: Maybe<Array<Maybe<UsageType>>>;
};


export type EtaLightTypeTasksArgs = {
  status?: InputMaybe<EtaLightTaskStatus>;
  statuses?: InputMaybe<Array<InputMaybe<EtaLightTaskStatus>>>;
};


export type EtaLightTypeUsageArgs = {
  vehicleId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type EtaMonitor = {
  etaTimeStatus?: Maybe<EtaTimeStatus>;
  isCalculated?: Maybe<Scalars['Boolean']['output']>;
  isCanceled?: Maybe<Scalars['Boolean']['output']>;
  isEndangered?: Maybe<Scalars['Boolean']['output']>;
  isEtaLightSource?: Maybe<Scalars['Boolean']['output']>;
  isExceeded?: Maybe<Scalars['Boolean']['output']>;
  isOk?: Maybe<Scalars['Boolean']['output']>;
  isOrderTaskSource?: Maybe<Scalars['Boolean']['output']>;
  isUnknown?: Maybe<Scalars['Boolean']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  target?: Maybe<TargetType>;
};

export type EtaMonitorTask = EtaLightTask | OrderTask;

export type EtaRestTakenType = {
  __typename?: 'EtaRestTakenType';
  period?: Maybe<Scalars['Int']['output']>;
  questionable?: Maybe<Scalars['Boolean']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum EtaTimeStatus {
  ENDANGERED = 'ENDANGERED',
  EXCEEDED = 'EXCEEDED',
  OK = 'OK',
  UNKNOWN = 'UNKNOWN'
}

export type FeatureFlagsType = {
  __typename?: 'FeatureFlagsType';
  /** Display battery voltage */
  batteryVoltage?: Maybe<Scalars['Boolean']['output']>;
  /** Tacho remote module visibility */
  tachoRemote?: Maybe<Scalars['Boolean']['output']>;
};

export type FireTms = {
  __typename?: 'FireTms';
  boxes?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  driverApp?: Maybe<FireTmsDriverApp>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  hereMaps?: Maybe<Scalars['Boolean']['output']>;
};

export type FireTmsDriverApp = {
  __typename?: 'FireTmsDriverApp';
  hereMaps?: Maybe<Scalars['Boolean']['output']>;
  licenses?: Maybe<Scalars['Int']['output']>;
};

export type Fleet = {
  __typename?: 'Fleet';
  hadAssist?: Maybe<Scalars['Boolean']['output']>;
  hasAssist?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<FleetTypeType>;
};

export enum FleetType {
  GBOX = 'GBOX',
  OBU = 'OBU'
}

export enum FleetTypeType {
  GBOX = 'gbox',
  MIXED = 'mixed',
  OBU = 'obu'
}

export type FuelTankProbeType = {
  __typename?: 'FuelTankProbeType';
  voltage?: Maybe<Scalars['Int']['output']>;
  volume?: Maybe<Scalars['Int']['output']>;
};

export type FuelTankType = {
  __typename?: 'FuelTankType';
  bottom?: Maybe<FuelTankProbeType>;
  capacity?: Maybe<Scalars['Int']['output']>;
  top?: Maybe<FuelTankProbeType>;
};

export type FuelTanksType = {
  __typename?: 'FuelTanksType';
  boxId?: Maybe<Scalars['Int']['output']>;
  tank1?: Maybe<FuelTankType>;
  tank2?: Maybe<FuelTankType>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GboxAuthorizationAccount = {
  __typename?: 'GboxAuthorizationAccount';
  id?: Maybe<Scalars['Int']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GboxAuthorizationAccountMutationType = {
  __typename?: 'GboxAuthorizationAccountMutationType';
  /** Create API account for partner type */
  create?: Maybe<CreateGboxAuthorizationAccountMutationType>;
  /** Reset API account password for partner type */
  resetPassword?: Maybe<ResetGboxAuthorizationAccountPasswordMutationType>;
};

export type Incident = {
  __typename?: 'Incident';
  geoLat: Scalars['Float']['output'];
  geoLong: Scalars['Float']['output'];
  nrDrogi: Scalars['String']['output'];
  objazd: Scalars['String']['output'];
  position?: Maybe<Array<Scalars['Int']['output']>>;
  rodzaj?: Maybe<IncidentType>;
  type: Scalars['String']['output'];
};

export type IncidentType = {
  __typename?: 'IncidentType';
  poz: IncidentTypeKey;
};

export enum IncidentTypeKey {
  I02 = 'I02',
  I04 = 'I04',
  I05 = 'I05',
  I06 = 'I06',
  I07 = 'I07',
  I08 = 'I08',
  I09 = 'I09',
  I10 = 'I10',
  I11 = 'I11',
  I12 = 'I12',
  I13 = 'I13',
  K00 = 'K00',
  K01 = 'K01',
  K02 = 'K02',
  K03 = 'K03',
  K04 = 'K04',
  R00 = 'R00',
  R01 = 'R01',
  R02 = 'R02',
  R03 = 'R03',
  R04 = 'R04',
  R05 = 'R05',
  R06 = 'R06',
  R07 = 'R07',
  R08 = 'R08',
  R09 = 'R09',
  R10 = 'R10',
  R11 = 'R11',
  R12 = 'R12',
  R13 = 'R13',
  R14 = 'R14',
  S00 = 'S00',
  U27 = 'U27',
  U33 = 'U33',
  U42 = 'U42'
}

export type KeyValueType = {
  __typename?: 'KeyValueType';
  /** Object key */
  key?: Maybe<Scalars['String']['output']>;
  /** Object value */
  value?: Maybe<Scalars['String']['output']>;
};

export type Legacy = {
  __typename?: 'Legacy';
  /**
   * Return information about client fleet type
   * @deprecated You should use system->fleet->type leaf instead of this one.
   */
  fleetType?: Maybe<FleetTypeType>;
  /**
   * If client has Assist.
   * @deprecated You should use system->fleet->hasAssist leaf instead of this one.
   */
  hasAssist?: Maybe<Scalars['Boolean']['output']>;
  /** Client's licence plan value. */
  licencePlan?: Maybe<LicencePlanType>;
};

export type LegacyAlertsModule = {
  __typename?: 'LegacyAlertsModule';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type LegacyAssistModule = {
  __typename?: 'LegacyAssistModule';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type LegacyHistoryModule = {
  __typename?: 'LegacyHistoryModule';
  availabilityTime?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type LegacyReportsModule = {
  __typename?: 'LegacyReportsModule';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type LegacyTaskFilter = {
  orderId?: InputMaybe<Scalars['Int']['input']>;
  taskId?: InputMaybe<Scalars['Int']['input']>;
};

export type LegacyTemporaryLinksModule = {
  __typename?: 'LegacyTemporaryLinksModule';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export enum LicencePlanType {
  BASIC = 'basic',
  FULL = 'full',
  PROMO = 'promo'
}

export type LoadPart = {
  __typename?: 'LoadPart';
  avgAxleLoad?: Maybe<Scalars['Float']['output']>;
  avgTotalLoad?: Maybe<Scalars['Float']['output']>;
};

export type MapModuleClientSettings = {
  __typename?: 'MapModuleClientSettings';
  hiSpeedBig: Scalars['Int']['output'];
  hiSpeedSmall: Scalars['Int']['output'];
  layingLabels: Scalars['Boolean']['output'];
  lowSpeedBig: Scalars['Int']['output'];
  lowSpeedSmall: Scalars['Int']['output'];
  rosaVentorum: Scalars['Boolean']['output'];
  showStopAfter: Scalars['Int']['output'];
  transparentLblBgColor: Scalars['Int']['output'];
  unifyLabelsColor: Scalars['Boolean']['output'];
};

export type MapModuleClientSettingsResponse = {
  __typename?: 'MapModuleClientSettingsResponse';
  configuration?: Maybe<MapModuleClientSettings>;
};

export type MapModuleIncidentsListResponse = {
  __typename?: 'MapModuleIncidentsListResponse';
  trafficCongestion?: Maybe<Array<Incident>>;
};

export type MapModuleUserPointCreateInputType = {
  filepath: Scalars['String']['input'];
  name: Scalars['String']['input'];
  position?: InputMaybe<UserPointPositionInput>;
  type: Scalars['String']['input'];
};

export type MapModuleUserPointGroupsResponse = {
  __typename?: 'MapModuleUserPointGroupsResponse';
  userPointGroups?: Maybe<Array<UserPointGroup>>;
};

export type MapModuleUserPointsResponse = {
  __typename?: 'MapModuleUserPointsResponse';
  userPointGroup?: Maybe<UserPointGroup>;
};

export type MapModuleUserSettings = {
  __typename?: 'MapModuleUserSettings';
  list: MapModuleUserSettingsList;
};

export type MapModuleUserSettingsInputType = {
  list: MapModuleUserSettingsListInputType;
};

export type MapModuleUserSettingsList = {
  __typename?: 'MapModuleUserSettingsList';
  vehicleDetails: MapModuleUserSettingsListVehicleDetails;
  vehicleInfo: MapModuleUserSettingsListVehicleInfo;
  vehicleTitle: MapModuleUserSettingsListVehicleTitle;
};

export type MapModuleUserSettingsListInputType = {
  vehicleDetails: MapModuleUserSettingsListVehicleDetailsInputType;
  vehicleInfo: MapModuleUserSettingsListVehicleInfoInputType;
  vehicleTitle: MapModuleUserSettingsListVehicleTitleInputType;
};

export type MapModuleUserSettingsListVehicleDetails = {
  __typename?: 'MapModuleUserSettingsListVehicleDetails';
  address: Scalars['Boolean']['output'];
  currentEtaMonitor: Scalars['Boolean']['output'];
  driverName: Scalars['Boolean']['output'];
};

export type MapModuleUserSettingsListVehicleDetailsInputType = {
  address: Scalars['Boolean']['input'];
  currentEtaMonitor: Scalars['Boolean']['input'];
  driverName: Scalars['Boolean']['input'];
};

export type MapModuleUserSettingsListVehicleInfo = {
  __typename?: 'MapModuleUserSettingsListVehicleInfo';
  batteryVoltage: Scalars['Boolean']['output'];
  fuel: Scalars['Boolean']['output'];
  speed: Scalars['Boolean']['output'];
  totalLoad: Scalars['Boolean']['output'];
};

export type MapModuleUserSettingsListVehicleInfoInputType = {
  batteryVoltage: Scalars['Boolean']['input'];
  fuel: Scalars['Boolean']['input'];
  speed: Scalars['Boolean']['input'];
  totalLoad: Scalars['Boolean']['input'];
};

export type MapModuleUserSettingsListVehicleTitle = {
  __typename?: 'MapModuleUserSettingsListVehicleTitle';
  name: Scalars['Boolean']['output'];
  registration: Scalars['Boolean']['output'];
};

export type MapModuleUserSettingsListVehicleTitleInputType = {
  name: Scalars['Boolean']['input'];
  registration: Scalars['Boolean']['input'];
};

export type MapModuleUserSettingsResponse = {
  __typename?: 'MapModuleUserSettingsResponse';
  userSettings: MapModuleUserSettings;
};

export type MaybeUnknownDriver = Driver | DriverUnknown;

export type Me = {
  __typename?: 'Me';
  /** API accounts for current user */
  apiAccounts?: Maybe<ApiAccounts>;
  /** Aggregate data related with auth */
  auth?: Maybe<Auth>;
  customerArea?: Maybe<CustomerArea>;
  /** List of drivers */
  drivers?: Maybe<Array<Maybe<Driver>>>;
  /** Virtual aggregator for eco-driving types */
  ecoDriving?: Maybe<EcoDrivingType>;
  /** Virtual aggregator for EtaLight types */
  etaLight?: Maybe<EtaLightType>;
  /**
   * List of tasks light
   * @deprecated You should use me.etaLight.tasks leaf instead of this one.
   */
  etaLightTasks?: Maybe<Array<Maybe<EtaLightTask>>>;
  /** Clients feature flags */
  featureFlags?: Maybe<FeatureFlagsType>;
  /** Client's company full name */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Client's id */
  id?: Maybe<Scalars['Int']['output']>;
  /** If client is internal */
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  /** If panel belongs to two or more companies */
  isJoint?: Maybe<Scalars['Boolean']['output']>;
  /** Client's name */
  name?: Maybe<Scalars['String']['output']>;
  /** List of order tasks */
  orderTasks?: Maybe<Array<Maybe<OrderTask>>>;
  /** Settings for current logged user */
  settings?: Maybe<Settings>;
  /** TachoRemote data for client */
  tachoRemote?: Maybe<TachoRemoteType>;
  /** List of drivers tasks */
  tasks?: Maybe<Array<Maybe<Task>>>;
  /** Return single Vehicle */
  vehicle?: Maybe<VehicleExtended>;
  /** List of vehicle types */
  vehicleTypes?: Maybe<Array<Maybe<VehicleType>>>;
  /** List of vehicles for current user */
  vehicles?: Maybe<Array<Maybe<Vehicle>>>;
  /** List of vehicles groups */
  vehiclesGroups?: Maybe<Array<Maybe<VehicleGroupType>>>;
};


export type MeDriversArgs = {
  applicationLinkStatus?: InputMaybe<DriverApplicationLinkStatus>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MeEtaLightTasksArgs = {
  status?: InputMaybe<EtaLightTaskStatus>;
  statuses?: InputMaybe<Array<InputMaybe<EtaLightTaskStatus>>>;
};


export type MeOrderTasksArgs = {
  status?: InputMaybe<TaskStatus>;
};


export type MeTasksArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TaskStatus>;
};


export type MeVehicleArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MeVehiclesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type MobilityPackageModule = {
  __typename?: 'MobilityPackageModule';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  foreignWage?: Maybe<Scalars['Boolean']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Aggregate mutators for Cargo */
  cargo?: Maybe<CargoMutationType>;
  clientId: Scalars['Int']['output'];
  /** Aggregate mutators for Driver */
  driver?: Maybe<DriverMutationType>;
  /** Aggregate mutators for EcoDriving */
  ecoDriving?: Maybe<EcoDrivingMutationType>;
  /** Aggregate mutators for EtaLight task */
  etaLightTask?: Maybe<EtaLightTaskMutationType>;
  /** Aggregate mutators for Gbox Authorization account */
  gboxAuthorizationAccount?: Maybe<GboxAuthorizationAccountMutationType>;
  mapModuleSettings?: Maybe<NullResponse>;
  mapModuleUserPoints?: Maybe<NullResponse>;
  /** Aggregate mutators for partner account */
  partnerAccount?: Maybe<PartnerAccountMutationType>;
  /** Aggregate mutators for TachoRemote */
  tachoRemote?: Maybe<TachoRemoteMutationType>;
};


export type MutationMapModuleSettingsArgs = {
  settings: MapModuleUserSettingsInputType;
  settingsId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationMapModuleUserPointsArgs = {
  input: MapModuleUserPointCreateInputType;
};

export type NullResponse = {
  __typename?: 'NullResponse';
  content?: Maybe<Scalars['String']['output']>;
};

export type Order = {
  __typename?: 'Order';
  clientId?: Maybe<Scalars['Int']['output']>;
  customer?: Maybe<Customer>;
  driverId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  legacyId?: Maybe<Scalars['ID']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  /** Vehicle data */
  vehicle?: Maybe<Vehicle>;
  /** @deprecated Use instead "vehicle.id" field */
  vehicleId?: Maybe<Scalars['Int']['output']>;
};

export type OrderTask = EtaMonitor & {
  __typename?: 'OrderTask';
  arriveTimeEnd?: Maybe<Scalars['DateTime']['output']>;
  attachments?: Maybe<Array<Maybe<TaskAttachment>>>;
  attachmentsCount?: Maybe<Scalars['Int']['output']>;
  clientId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  eta?: Maybe<Eta>;
  etaTimeStatus?: Maybe<EtaTimeStatus>;
  finishNote?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isCalculated?: Maybe<Scalars['Boolean']['output']>;
  isCanceled?: Maybe<Scalars['Boolean']['output']>;
  isEndangered?: Maybe<Scalars['Boolean']['output']>;
  isEtaLightSource?: Maybe<Scalars['Boolean']['output']>;
  isExceeded?: Maybe<Scalars['Boolean']['output']>;
  isOk?: Maybe<Scalars['Boolean']['output']>;
  isOrderTaskSource?: Maybe<Scalars['Boolean']['output']>;
  isUnknown?: Maybe<Scalars['Boolean']['output']>;
  legacyId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']['output']>;
  payloads?: Maybe<Array<Maybe<Payload>>>;
  sourceId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<TaskState>;
  status?: Maybe<OrderTaskStatus>;
  target?: Maybe<TargetType>;
  type?: Maybe<OrderType>;
};

export enum OrderTaskStatus {
  CANCELED = 'CANCELED',
  CREATED = 'CREATED',
  DRIVE = 'DRIVE',
  FINISHED = 'FINISHED',
  IN_PROGRESS = 'IN_PROGRESS',
  READ = 'READ',
  RECEIVED = 'RECEIVED',
  SENT = 'SENT',
  STARTED = 'STARTED',
  WAIT = 'WAIT'
}

export enum OrderType {
  DRIVE = 'DRIVE',
  FERRY = 'FERRY',
  LOADING = 'LOADING',
  OTHER = 'OTHER',
  REFUEL = 'REFUEL',
  SERVICE = 'SERVICE',
  UNLOADING = 'UNLOADING',
  WASH = 'WASH'
}

export type OrdersModule = {
  __typename?: 'OrdersModule';
  archivePermissions?: Maybe<SettingsOrdersArchivePermissionsType>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  calendar?: Maybe<Scalars['Boolean']['output']>;
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  eta?: Maybe<Scalars['Boolean']['output']>;
  etaVehicles?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type PaginationContextInputType = {
  /** Page to get */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** How much items per single page */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type PaginationResultType = {
  __typename?: 'PaginationResultType';
  /** How much items for specified criteria */
  itemsCount?: Maybe<Scalars['Int']['output']>;
  /** Current page */
  page?: Maybe<Scalars['Int']['output']>;
  /** How much pages with items for selected to page size */
  pageCount?: Maybe<Scalars['Int']['output']>;
  /** How much items per page */
  pageSize?: Maybe<Scalars['Int']['output']>;
};

export type PartnerAccount = {
  __typename?: 'PartnerAccount';
  id?: Maybe<Scalars['Int']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PartnerAccountMutationType = {
  __typename?: 'PartnerAccountMutationType';
  /** Create API account for partner type */
  create?: Maybe<CreatePartnerAccountMutationType>;
  /** Reset API account password for partner type */
  resetPassword?: Maybe<ResetPartnerAccountPasswordMutationType>;
};


export type PartnerAccountMutationTypeCreateArgs = {
  prefix?: InputMaybe<PartnerAccountPrefix>;
};


export type PartnerAccountMutationTypeResetPasswordArgs = {
  prefix?: InputMaybe<PartnerAccountPrefix>;
};

/** A prefix for account name to add. By default there's no prefix added. */
export enum PartnerAccountPrefix {
  DEFAULT = 'DEFAULT',
  FIRE_TMS = 'FIRE_TMS'
}

export type Payload = {
  __typename?: 'Payload';
  amount?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Client instance */
  client?: Maybe<Client>;
  /**
   * Temporary solution for 4Trans integration
   * @deprecated Its temporary solution - do not use it
   */
  client4trans?: Maybe<Client4Trans>;
  clientId: Scalars['Int']['output'];
  mapModuleClientSettings: MapModuleClientSettingsResponse;
  mapModuleIncidentsList: MapModuleIncidentsListResponse;
  mapModuleUserPointGroups: MapModuleUserPointGroupsResponse;
  mapModuleUserPoints: MapModuleUserPointsResponse;
  mapModuleUserSettings: MapModuleUserSettingsResponse;
  /** Current user */
  me?: Maybe<Me>;
};


export type QueryClientArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMapModuleUserPointsArgs = {
  groupId: Scalars['Int']['input'];
};


export type QueryMapModuleUserSettingsArgs = {
  settingsId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type RpmDistribution = {
  __typename?: 'RPMDistribution';
  aboveNorm?: Maybe<Scalars['Float']['output']>;
  belowNorm?: Maybe<Scalars['Float']['output']>;
  inNorm?: Maybe<Scalars['Float']['output']>;
};

export type ResetGboxAuthorizationAccountPasswordMutationType = {
  __typename?: 'ResetGboxAuthorizationAccountPasswordMutationType';
  id?: Maybe<Scalars['Int']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ResetPartnerAccountPasswordMutationType = {
  __typename?: 'ResetPartnerAccountPasswordMutationType';
  id?: Maybe<Scalars['Int']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Settings = {
  __typename?: 'Settings';
  /**
   * Deprecated Settings for EcoDriving
   * @deprecated You should use system->ecoDriving leaf instead of this one. New field contains information about enabled module
   */
  ecoDriving?: Maybe<DeprecatedEcoDrivingSettings>;
  legacy?: Maybe<Legacy>;
  system?: Maybe<System>;
};

export enum SettingsOrdersArchivePermissionsType {
  EDIT_ONLY = 'EDIT_ONLY',
  FULL = 'FULL'
}

export enum SortOrderType {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type StopOnEngine = {
  __typename?: 'StopOnEngine';
  duration?: Maybe<Scalars['Int']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
};

export type System = {
  __typename?: 'System';
  apiAccounts?: Maybe<ApiAccountsModule>;
  driverApp?: Maybe<DriverAppModule>;
  ecoDriving?: Maybe<EcoDrivingModule>;
  etaLight?: Maybe<EtaLightModule>;
  etoll?: Maybe<EtollModule>;
  fireTms?: Maybe<FireTms>;
  fleet?: Maybe<Fleet>;
  legacyAlerts?: Maybe<LegacyAlertsModule>;
  /** @deprecated You should use system->fleet->hasAssist leaf instead of this one. */
  legacyAssist?: Maybe<LegacyAssistModule>;
  legacyHistory?: Maybe<LegacyHistoryModule>;
  legacyReports?: Maybe<LegacyReportsModule>;
  legacyTemporaryLinks?: Maybe<LegacyTemporaryLinksModule>;
  mobilityPackage?: Maybe<MobilityPackageModule>;
  orders?: Maybe<OrdersModule>;
  tachoRemote?: Maybe<TachoRemoteModule>;
  tachoRemote2?: Maybe<TachoRemote2Module>;
  tasks?: Maybe<TasksModule>;
  workTime?: Maybe<WorkingTimeModule>;
};

export type TachoRemote2Module = {
  __typename?: 'TachoRemote2Module';
  configured?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  launched?: Maybe<Scalars['Boolean']['output']>;
  migrated?: Maybe<Scalars['Boolean']['output']>;
};

export type TachoRemoteActionMessageMutationType = {
  __typename?: 'TachoRemoteActionMessageMutationType';
  code?: Maybe<Scalars['Int']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type TachoRemoteAuthorizationAppCompanyCardDataType = {
  __typename?: 'TachoRemoteAuthorizationAppCompanyCardDataType';
  countryCode?: Maybe<Scalars['Int']['output']>;
  countryCodeLabel?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  serialNo?: Maybe<Scalars['String']['output']>;
};

export type TachoRemoteAuthorizationAppMutationType = {
  __typename?: 'TachoRemoteAuthorizationAppMutationType';
  /** Deactivates the card */
  deactivateAuthorizationApp?: Maybe<TachoRemoteDeactivateAuthorizationAppMutationType>;
};


export type TachoRemoteAuthorizationAppMutationTypeDeactivateAuthorizationAppArgs = {
  appId: Scalars['String']['input'];
};

export enum TachoRemoteAuthorizationAppStatusType {
  CARD_EXPIRED = 'CARD_EXPIRED',
  CARD_IN_THE_READER = 'CARD_IN_THE_READER',
  CONNECTION_ERROR = 'CONNECTION_ERROR',
  NO_CARD_IN_THE_READER = 'NO_CARD_IN_THE_READER',
  NO_READER = 'NO_READER'
}

export type TachoRemoteAuthorizationAppType = {
  __typename?: 'TachoRemoteAuthorizationAppType';
  companyCards?: Maybe<Array<Maybe<TachoRemoteAuthorizationAppCompanyCardDataType>>>;
  id?: Maybe<Scalars['String']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  lastContact?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  server?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TachoRemoteAuthorizationAppStatusType>;
};

export type TachoRemoteAuthorizationAppsResultType = {
  __typename?: 'TachoRemoteAuthorizationAppsResultType';
  data?: Maybe<Array<Maybe<TachoRemoteAuthorizationAppType>>>;
};

export type TachoRemoteClientMutationType = {
  __typename?: 'TachoRemoteClientMutationType';
  /** enable/disable support for multiple company */
  supportForMultipleCompany?: Maybe<TachoRemoteSupportForMultipleCompanyMutationType>;
};


export type TachoRemoteClientMutationTypeSupportForMultipleCompanyArgs = {
  enabled: Scalars['Boolean']['input'];
};

export type TachoRemoteClientType = {
  __typename?: 'TachoRemoteClientType';
  hasSupportForMultipleCompany?: Maybe<Scalars['Boolean']['output']>;
  isConfigured?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  numberOfCompanies?: Maybe<Scalars['Int']['output']>;
};

export type TachoRemoteCompaniesResultType = {
  __typename?: 'TachoRemoteCompaniesResultType';
  data?: Maybe<Array<Maybe<TachoRemoteCompanyType>>>;
};

export type TachoRemoteCompanyCardConnectionType = {
  __typename?: 'TachoRemoteCompanyCardConnectionType';
  ip?: Maybe<Scalars['String']['output']>;
  reader?: Maybe<Scalars['String']['output']>;
  server?: Maybe<Scalars['String']['output']>;
};

export type TachoRemoteCompanyCardMutationType = {
  __typename?: 'TachoRemoteCompanyCardMutationType';
  /** Update company card */
  update?: Maybe<TachoRemoteUpdateCompanyCardMutationType>;
};


export type TachoRemoteCompanyCardMutationTypeUpdateArgs = {
  payload: TachoRemoteUpdateCompanyCardInputType;
  serialNo: Scalars['String']['input'];
};

export enum TachoRemoteCompanyCardStatusType {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  EXPIRED = 'EXPIRED'
}

export type TachoRemoteCompanyCardType = {
  __typename?: 'TachoRemoteCompanyCardType';
  active?: Maybe<Scalars['Boolean']['output']>;
  clientId?: Maybe<Scalars['Int']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  configuredAt?: Maybe<Scalars['DateTime']['output']>;
  connection?: Maybe<TachoRemoteCompanyCardConnectionType>;
  countryCode?: Maybe<Scalars['Int']['output']>;
  countryCodeLabel?: Maybe<Scalars['String']['output']>;
  expirationWarning?: Maybe<Scalars['Boolean']['output']>;
  expireDate?: Maybe<Scalars['Date']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  generation?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  serialNo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TachoRemoteCompanyCardStatusType>;
};

export type TachoRemoteCompanyCardsResultType = {
  __typename?: 'TachoRemoteCompanyCardsResultType';
  data?: Maybe<Array<Maybe<TachoRemoteCompanyCardType>>>;
};

export type TachoRemoteCompanyMutationType = {
  __typename?: 'TachoRemoteCompanyMutationType';
  /** Assign vehicles to company */
  assignVehicles?: Maybe<TachoRemoteCompanyVehiclesMutationType>;
  /** Create company */
  create?: Maybe<TachoRemoteCreateCompanyMutationType>;
  /** Delete company */
  delete?: Maybe<TachoRemoteDeleteCompanyMutationType>;
  /** Update company */
  update?: Maybe<TachoRemoteUpdateCompanyMutationType>;
};


export type TachoRemoteCompanyMutationTypeAssignVehiclesArgs = {
  id: Scalars['String']['input'];
  payload: TachoRemoteCompanyVehiclesInputType;
};


export type TachoRemoteCompanyMutationTypeCreateArgs = {
  payload: TachoRemoteCreateCompanyInputType;
};


export type TachoRemoteCompanyMutationTypeDeleteArgs = {
  id: Scalars['String']['input'];
};


export type TachoRemoteCompanyMutationTypeUpdateArgs = {
  id: Scalars['String']['input'];
  payload: TachoRemoteUpdateCompanyInputType;
};

export type TachoRemoteCompanyType = {
  __typename?: 'TachoRemoteCompanyType';
  companyCardSerialNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfVehicles?: Maybe<Scalars['Int']['output']>;
};

export type TachoRemoteCompanyVehiclesInputType = {
  scheduleIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type TachoRemoteCompanyVehiclesMutationType = {
  __typename?: 'TachoRemoteCompanyVehiclesMutationType';
  messages?: Maybe<Array<Maybe<TachoRemoteActionMessageMutationType>>>;
};

export type TachoRemoteCreateCompanyInputType = {
  companyCardSerialNumbers: Array<InputMaybe<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type TachoRemoteCreateCompanyMutationType = {
  __typename?: 'TachoRemoteCreateCompanyMutationType';
  companyCardSerialNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfVehicles?: Maybe<Scalars['Int']['output']>;
};

export type TachoRemoteDeactivateAuthorizationAppMutationType = {
  __typename?: 'TachoRemoteDeactivateAuthorizationAppMutationType';
  messages?: Maybe<Array<Maybe<TachoRemoteActionMessageMutationType>>>;
};

export type TachoRemoteDeleteCompanyMutationType = {
  __typename?: 'TachoRemoteDeleteCompanyMutationType';
  status?: Maybe<Scalars['String']['output']>;
};

export type TachoRemoteDriverCardMetaType = {
  __typename?: 'TachoRemoteDriverCardMetaType';
  /** Contain information how many driver card reads are suspended */
  suspendedCount?: Maybe<Scalars['Int']['output']>;
};

export type TachoRemoteDriverCardMutationType = {
  __typename?: 'TachoRemoteDriverCardMutationType';
  /** Order additional reads */
  additionalReads?: Maybe<TachoRemoteDriverCardReadAdditionalReadOrdersMutationType>;
  /** Suspend read orders */
  suspendReads?: Maybe<TachoRemoteSuspendReadsMutationType>;
  /** Unsuspend read orders */
  unsuspendReads?: Maybe<TachoRemoteUnsuspendReadsMutationType>;
};


export type TachoRemoteDriverCardMutationTypeAdditionalReadsArgs = {
  payload: TachoRemoteDriverCardReadAdditionalReadOrderInputType;
};


export type TachoRemoteDriverCardMutationTypeSuspendReadsArgs = {
  payload: TachoRemoteSuspendReadsInputType;
};


export type TachoRemoteDriverCardMutationTypeUnsuspendReadsArgs = {
  payload: TachoRemoteUnsuspendReadsInputType;
};

export type TachoRemoteDriverCardReadAdditionalReadOrderInputType = {
  scheduleIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type TachoRemoteDriverCardReadAdditionalReadOrdersMutationType = {
  __typename?: 'TachoRemoteDriverCardReadAdditionalReadOrdersMutationType';
  messages?: Maybe<Array<Maybe<TachoRemoteActionMessageMutationType>>>;
};

export type TachoRemoteDriverCardReadFiltersInputType = {
  from: Scalars['Date']['input'];
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Date']['input'];
};

export type TachoRemoteDriverCardReadLastReadType = {
  __typename?: 'TachoRemoteDriverCardReadLastReadType';
  date?: Maybe<Scalars['DateTime']['output']>;
  delayStatus?: Maybe<TachoRemoteLastReadDelayStatusType>;
  status?: Maybe<TachoRemoteReadStatusType>;
  type?: Maybe<TachoRemoteReadReasonType>;
};

export type TachoRemoteDriverCardReadNextReadType = {
  __typename?: 'TachoRemoteDriverCardReadNextReadType';
  date?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<TachoRemoteReadReasonType>;
};

export enum TachoRemoteDriverCardReadSortingFieldInputType {
  DRIVER_CARD_NUMBER = 'DRIVER_CARD_NUMBER',
  GENERATED_AT = 'GENERATED_AT',
  LAST_NAME = 'LAST_NAME',
  REGISTRATION_NUMBER = 'REGISTRATION_NUMBER'
}

export type TachoRemoteDriverCardReadSortingItemInputType = {
  /** Field to sort by */
  sortBy?: InputMaybe<TachoRemoteDriverCardReadSortingFieldInputType>;
  /** How field should be sorted */
  sortOrder?: InputMaybe<SortOrderType>;
};

export type TachoRemoteDriverCardReadStatusFiltersInputType = {
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  showSuspended?: InputMaybe<Scalars['Boolean']['input']>;
  showWarnings?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TachoRemoteDriverCardReadStatusSortingFieldInputType {
  DRIVER_CARD_NUMBER = 'DRIVER_CARD_NUMBER',
  LAST_NAME = 'LAST_NAME',
  LAST_READ_DATE = 'LAST_READ_DATE',
  NEXT_READ_DATE = 'NEXT_READ_DATE',
  NEXT_READ_TYPE = 'NEXT_READ_TYPE'
}

export type TachoRemoteDriverCardReadStatusSortingItemInputType = {
  /** Field to sort by */
  sortBy?: InputMaybe<TachoRemoteDriverCardReadStatusSortingFieldInputType>;
  /** How field should be sorted */
  sortOrder?: InputMaybe<SortOrderType>;
};

export type TachoRemoteDriverCardReadStatusType = {
  __typename?: 'TachoRemoteDriverCardReadStatusType';
  /** Contain information about card of driver */
  driverCard?: Maybe<DriverCard>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Driver last contact date in ISO-8601 format */
  lastContact?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Contain information about last done read */
  lastRead?: Maybe<TachoRemoteDriverCardReadLastReadType>;
  /** Contain information about next planned read */
  nextRead?: Maybe<TachoRemoteDriverCardReadNextReadType>;
  /** Contain information that driver card reads reads are suspended for this driver */
  suspended?: Maybe<Scalars['Boolean']['output']>;
  /** Contain warnings related with reads */
  warnings?: Maybe<Array<Maybe<TachoRemoteWarningType>>>;
};

export type TachoRemoteDriverCardReadStatusesResultType = {
  __typename?: 'TachoRemoteDriverCardReadStatusesResultType';
  data?: Maybe<Array<Maybe<TachoRemoteDriverCardReadStatusType>>>;
  matched?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  meta?: Maybe<PaginationResultType>;
};

export type TachoRemoteDriverCardReadType = {
  __typename?: 'TachoRemoteDriverCardReadType';
  driverCard?: Maybe<DriverCard>;
  driverFirstName?: Maybe<Scalars['String']['output']>;
  driverLastName?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<TachoRemoteReadReasonType>;
  source?: Maybe<Scalars['String']['output']>;
  vehicleRegistrationNumber?: Maybe<Scalars['String']['output']>;
  /** Contain warnings related with reads */
  warnings?: Maybe<Array<Maybe<TachoRemoteWarningType>>>;
};

export type TachoRemoteDriverCardReadsResultType = {
  __typename?: 'TachoRemoteDriverCardReadsResultType';
  data?: Maybe<Array<Maybe<TachoRemoteDriverCardReadType>>>;
  matched?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  meta?: Maybe<PaginationResultType>;
};

export type TachoRemoteDriverCardType = {
  __typename?: 'TachoRemoteDriverCardType';
  /** Meta data for driver card reads */
  meta?: Maybe<TachoRemoteDriverCardMetaType>;
  /** List of driver cards's reads */
  reads?: Maybe<TachoRemoteDriverCardReadsResultType>;
  /** List of driver cards's read statuses */
  statuses?: Maybe<TachoRemoteDriverCardReadStatusesResultType>;
};


export type TachoRemoteDriverCardTypeReadsArgs = {
  filters?: InputMaybe<TachoRemoteDriverCardReadFiltersInputType>;
  pagination?: InputMaybe<PaginationContextInputType>;
  sorting?: InputMaybe<Array<InputMaybe<TachoRemoteDriverCardReadSortingItemInputType>>>;
};


export type TachoRemoteDriverCardTypeStatusesArgs = {
  filters?: InputMaybe<TachoRemoteDriverCardReadStatusFiltersInputType>;
  pagination?: InputMaybe<PaginationContextInputType>;
  sorting?: InputMaybe<Array<InputMaybe<TachoRemoteDriverCardReadStatusSortingItemInputType>>>;
};

export enum TachoRemoteFileRangeType {
  HISTORY = 'HISTORY',
  NEWEST = 'NEWEST'
}

export enum TachoRemoteFileSourceType {
  DRIVER_CARD = 'DRIVER_CARD',
  TACHOGRAPH = 'TACHOGRAPH'
}

export type TachoRemoteFileType = {
  __typename?: 'TachoRemoteFileType';
  fileId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export enum TachoRemoteLastReadDelayStatusType {
  CRITICAL = 'CRITICAL',
  OK = 'OK',
  WARNING = 'WARNING'
}

export type TachoRemoteModule = {
  __typename?: 'TachoRemoteModule';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  hadEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type TachoRemoteMutationType = {
  __typename?: 'TachoRemoteMutationType';
  /** Aggregates mutators for authorization apps */
  authorizationApp?: Maybe<TachoRemoteAuthorizationAppMutationType>;
  /** Aggregates mutators for tacho remote client */
  client?: Maybe<TachoRemoteClientMutationType>;
  /** Aggregates mutators for company */
  company?: Maybe<TachoRemoteCompanyMutationType>;
  /** Aggregates mutators for company card */
  companyCard?: Maybe<TachoRemoteCompanyCardMutationType>;
  /** Aggregates mutators for driver card reads */
  driverCardRead?: Maybe<TachoRemoteDriverCardMutationType>;
  /** Aggregates mutators for tachograph reads */
  tachographRead?: Maybe<TachoRemoteTachographMutationType>;
};

export enum TachoRemoteReadReasonType {
  ADDITIONAL_ORDER = 'ADDITIONAL_ORDER',
  PLANNED = 'PLANNED'
}

export enum TachoRemoteReadStatusType {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export enum TachoRemoteStatusCodeType {
  CLIENT_HAS_UNASSIGNED_COMPANY_CARDS = 'client_has_unassigned_company_cards',
  CLIENT_HAS_UNASSIGNED_VEHICLES = 'client_has_unassigned_vehicles',
  COMPANY_CARD_EXPIRATION_DATE_APPROACHING = 'company_card_expiration_date_approaching',
  COMPANY_CARD_EXPIRED = 'company_card_expired',
  COMPANY_CARD_NOT_CONNECTED = 'company_card_not_connected',
  CONNECTION_ERROR = 'connection_error',
  NO_COMPANY_CARD_IN_READER = 'no_company_card_in_reader',
  NO_CONNECTED_APP = 'no_connected_app',
  NO_READER_CONNECTED = 'no_reader_connected',
  UNKNOWN = 'unknown'
}

export type TachoRemoteStatusMessageType = {
  __typename?: 'TachoRemoteStatusMessageType';
  code?: Maybe<TachoRemoteStatusCodeType>;
  target?: Maybe<Scalars['String']['output']>;
};

export enum TachoRemoteStatusStateType {
  CRITICAL = 'CRITICAL',
  NOT_CONFIGURED = 'NOT_CONFIGURED',
  OK = 'OK',
  WARNING = 'WARNING'
}

export type TachoRemoteStatusType = {
  __typename?: 'TachoRemoteStatusType';
  messages?: Maybe<Array<Maybe<TachoRemoteStatusMessageType>>>;
  state?: Maybe<TachoRemoteStatusStateType>;
};

export type TachoRemoteSupportForMultipleCompanyMutationType = {
  __typename?: 'TachoRemoteSupportForMultipleCompanyMutationType';
  messages?: Maybe<Array<Maybe<TachoRemoteActionMessageMutationType>>>;
};

export type TachoRemoteSuspendReadsInputType = {
  scheduleIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type TachoRemoteSuspendReadsMutationType = {
  __typename?: 'TachoRemoteSuspendReadsMutationType';
  messages?: Maybe<Array<Maybe<TachoRemoteActionMessageMutationType>>>;
};

export type TachoRemoteTachographMetaType = {
  __typename?: 'TachoRemoteTachographMetaType';
  /** Contain information about limit for additional read orders */
  maxAdditionalReadOrders?: Maybe<Scalars['Int']['output']>;
  /** Contain information how many tachograph reads are suspended */
  suspendedCount?: Maybe<Scalars['Int']['output']>;
};

export type TachoRemoteTachographMutationType = {
  __typename?: 'TachoRemoteTachographMutationType';
  /** Order additional reads */
  additionalReads?: Maybe<TachoRemoteTachographReadAdditionalReadOrdersMutationType>;
  /** Suspend read orders */
  suspendReads?: Maybe<TachoRemoteSuspendReadsMutationType>;
  /** Unsuspend read orders */
  unsuspendReads?: Maybe<TachoRemoteUnsuspendReadsMutationType>;
};


export type TachoRemoteTachographMutationTypeAdditionalReadsArgs = {
  payload: TachoRemoteVehicleScheduleAdditionalReadOrderInputType;
};


export type TachoRemoteTachographMutationTypeSuspendReadsArgs = {
  payload: TachoRemoteSuspendReadsInputType;
};


export type TachoRemoteTachographMutationTypeUnsuspendReadsArgs = {
  payload: TachoRemoteUnsuspendReadsInputType;
};

export type TachoRemoteTachographReadAdditionalReadOrdersMutationType = {
  __typename?: 'TachoRemoteTachographReadAdditionalReadOrdersMutationType';
  messages?: Maybe<Array<Maybe<TachoRemoteActionMessageMutationType>>>;
};

export type TachoRemoteTachographReadFiltersInputType = {
  from: Scalars['Date']['input'];
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Date']['input'];
};

export type TachoRemoteTachographReadLastReadType = {
  __typename?: 'TachoRemoteTachographReadLastReadType';
  date?: Maybe<Scalars['DateTime']['output']>;
  delayStatus?: Maybe<TachoRemoteLastReadDelayStatusType>;
  /** Start date of this read */
  from?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<TachoRemoteReadStatusType>;
  /** End date of this read */
  to?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<TachoRemoteReadReasonType>;
};

export type TachoRemoteTachographReadNextReadType = {
  __typename?: 'TachoRemoteTachographReadNextReadType';
  date?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<TachoRemoteReadReasonType>;
};

export enum TachoRemoteTachographReadSortingFieldInputType {
  GENERATED_AT = 'GENERATED_AT',
  NAME = 'NAME',
  READ_FROM = 'READ_FROM',
  REGISTRATION_NUMBER = 'REGISTRATION_NUMBER'
}

export type TachoRemoteTachographReadSortingItemInputType = {
  /** Field to sort by */
  sortBy?: InputMaybe<TachoRemoteTachographReadSortingFieldInputType>;
  /** How field should be sorted */
  sortOrder?: InputMaybe<SortOrderType>;
};

export type TachoRemoteTachographReadStatusFiltersInputType = {
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  showSuspended?: InputMaybe<Scalars['Boolean']['input']>;
  showWarnings?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TachoRemoteTachographReadStatusSortingFieldInputType {
  LAST_READ_DATE = 'LAST_READ_DATE',
  NAME = 'NAME',
  NEXT_READ_DATE = 'NEXT_READ_DATE',
  NEXT_READ_TYPE = 'NEXT_READ_TYPE',
  REGISTRATION_NUMBER = 'REGISTRATION_NUMBER'
}

export type TachoRemoteTachographReadStatusSortingItemInputType = {
  /** Field to sort by */
  sortBy?: InputMaybe<TachoRemoteTachographReadStatusSortingFieldInputType>;
  /** How field should be sorted */
  sortOrder?: InputMaybe<SortOrderType>;
};

export type TachoRemoteTachographReadStatusType = {
  __typename?: 'TachoRemoteTachographReadStatusType';
  /** Contain information how many additional read orders is pending */
  additionalReadOrdersCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Driver last contact date in ISO-8601 format */
  lastContact?: Maybe<Scalars['DateTime']['output']>;
  /** Contain information about last done read */
  lastRead?: Maybe<TachoRemoteTachographReadLastReadType>;
  /** Vehicle's name where tachograph is mounted on */
  name?: Maybe<Scalars['String']['output']>;
  /** Contain information about next planned read */
  nextRead?: Maybe<TachoRemoteTachographReadNextReadType>;
  /** Vehicle's registration number where tachograph is mounted on */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** Contain information that tachograph reads are suspended for this vehicle */
  suspended?: Maybe<Scalars['Boolean']['output']>;
  /** Contain warnings related with reads */
  warnings?: Maybe<Array<Maybe<TachoRemoteWarningType>>>;
};

export type TachoRemoteTachographReadStatusesResultType = {
  __typename?: 'TachoRemoteTachographReadStatusesResultType';
  data?: Maybe<Array<Maybe<TachoRemoteTachographReadStatusType>>>;
  matched?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  meta?: Maybe<PaginationResultType>;
};

export type TachoRemoteTachographReadType = {
  __typename?: 'TachoRemoteTachographReadType';
  fileId?: Maybe<Scalars['String']['output']>;
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  readFrom?: Maybe<Scalars['Date']['output']>;
  readTo?: Maybe<Scalars['Date']['output']>;
  reason?: Maybe<TachoRemoteReadReasonType>;
  source?: Maybe<Scalars['String']['output']>;
  vehicleName?: Maybe<Scalars['String']['output']>;
  vehicleRegistrationNumber?: Maybe<Scalars['String']['output']>;
  /** Contain warnings related with reads */
  warnings?: Maybe<Array<Maybe<TachoRemoteWarningType>>>;
};

export type TachoRemoteTachographReadsResultType = {
  __typename?: 'TachoRemoteTachographReadsResultType';
  data?: Maybe<Array<Maybe<TachoRemoteTachographReadType>>>;
  matched?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  meta?: Maybe<PaginationResultType>;
};

export type TachoRemoteTachographType = {
  __typename?: 'TachoRemoteTachographType';
  /** Meta data for tachograph reads */
  meta?: Maybe<TachoRemoteTachographMetaType>;
  /** List of tachograph's reads */
  reads?: Maybe<TachoRemoteTachographReadsResultType>;
  /** List of driver cards's read statuses */
  statuses?: Maybe<TachoRemoteTachographReadStatusesResultType>;
};


export type TachoRemoteTachographTypeReadsArgs = {
  filters?: InputMaybe<TachoRemoteTachographReadFiltersInputType>;
  pagination?: InputMaybe<PaginationContextInputType>;
  sorting?: InputMaybe<Array<InputMaybe<TachoRemoteTachographReadSortingItemInputType>>>;
};


export type TachoRemoteTachographTypeStatusesArgs = {
  filters?: InputMaybe<TachoRemoteTachographReadStatusFiltersInputType>;
  pagination?: InputMaybe<PaginationContextInputType>;
  sorting?: InputMaybe<Array<InputMaybe<TachoRemoteTachographReadStatusSortingItemInputType>>>;
};

export type TachoRemoteType = {
  __typename?: 'TachoRemoteType';
  /** List of authorization apps with their statuses */
  authorizationApps?: Maybe<TachoRemoteAuthorizationAppsResultType>;
  /** Tacho remote client info */
  client?: Maybe<TachoRemoteClientType>;
  /** List of companies */
  companies?: Maybe<TachoRemoteCompaniesResultType>;
  /** List of company cards */
  companyCards?: Maybe<TachoRemoteCompanyCardsResultType>;
  /** Aggregate for driver card data */
  driverCard?: Maybe<TachoRemoteDriverCardType>;
  /** Get files from specified source and range */
  files?: Maybe<Array<Maybe<TachoRemoteFileType>>>;
  /** Status of TachoRemote 2.0 service */
  status?: Maybe<TachoRemoteStatusType>;
  /** Aggregate for tachograph data */
  tachograph?: Maybe<TachoRemoteTachographType>;
  /** List of vehicles */
  vehicles?: Maybe<TachoRemoteVehiclesType>;
};


export type TachoRemoteTypeCompanyCardsArgs = {
  filters?: InputMaybe<TachoRemoteUpdateCompanyCardFiltersInputType>;
};


export type TachoRemoteTypeFilesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  range?: InputMaybe<TachoRemoteFileRangeType>;
  source?: InputMaybe<TachoRemoteFileSourceType>;
};

export type TachoRemoteUnsuspendReadsInputType = {
  scheduleIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type TachoRemoteUnsuspendReadsMutationType = {
  __typename?: 'TachoRemoteUnsuspendReadsMutationType';
  messages?: Maybe<Array<Maybe<TachoRemoteActionMessageMutationType>>>;
};

export type TachoRemoteUpdateCompanyCardFiltersInputType = {
  pending?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TachoRemoteUpdateCompanyCardInputType = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['Int']['input']>;
  expireDate: Scalars['Date']['input'];
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TachoRemoteUpdateCompanyCardMutationType = {
  __typename?: 'TachoRemoteUpdateCompanyCardMutationType';
  active?: Maybe<Scalars['Boolean']['output']>;
  clientId?: Maybe<Scalars['Int']['output']>;
  /** Allow to attach company to card - only if support is enabled */
  companyId?: Maybe<Scalars['String']['output']>;
  configuredAt?: Maybe<Scalars['DateTime']['output']>;
  connected?: Maybe<Scalars['Boolean']['output']>;
  countryCode?: Maybe<Scalars['Int']['output']>;
  expireDate?: Maybe<Scalars['Date']['output']>;
  generation?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  serialNo?: Maybe<Scalars['String']['output']>;
};

export type TachoRemoteUpdateCompanyInputType = {
  companyCardSerialNumbers: Array<InputMaybe<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type TachoRemoteUpdateCompanyMutationType = {
  __typename?: 'TachoRemoteUpdateCompanyMutationType';
  companyCardSerialNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfVehicles?: Maybe<Scalars['Int']['output']>;
};

export type TachoRemoteVehicleScheduleAdditionalReadOrderInputType = {
  includeSpeed?: InputMaybe<Scalars['Boolean']['input']>;
  readFrom: Scalars['Date']['input'];
  readTo: Scalars['Date']['input'];
  scheduleIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type TachoRemoteVehicleType = {
  __typename?: 'TachoRemoteVehicleType';
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
};

export type TachoRemoteVehiclesType = {
  __typename?: 'TachoRemoteVehiclesType';
  data?: Maybe<Array<Maybe<TachoRemoteVehicleType>>>;
};

export enum TachoRemoteWarningCodeType {
  CAN_BUS_UNKNOWN_SPEED = 'CAN_BUS_UNKNOWN_SPEED',
  COMPANY_SMART_CARD_RESPONSE_ERROR = 'COMPANY_SMART_CARD_RESPONSE_ERROR',
  COMPANY_SMART_CARD_RESPONSE_PENDING = 'COMPANY_SMART_CARD_RESPONSE_PENDING',
  COMPANY_SMART_CARD_RESPONSE_TIMEOUT = 'COMPANY_SMART_CARD_RESPONSE_TIMEOUT',
  CRC_CALC_ERROR = 'CRC_CALC_ERROR',
  CRC_FILE_ERROR = 'CRC_FILE_ERROR',
  D8_DATA_ERROR = 'D8_DATA_ERROR',
  DATA_PRESENT_ON_TACHO_CAN_BUS = 'DATA_PRESENT_ON_TACHO_CAN_BUS',
  DRIVER_CARD_LAST_READ_DELAY_CRITICAL = 'DRIVER_CARD_LAST_READ_DELAY_CRITICAL',
  DRIVER_CARD_LAST_READ_DELAY_WARNING = 'DRIVER_CARD_LAST_READ_DELAY_WARNING',
  END_DATE_IS_LOWER_THAN_START_DATE = 'END_DATE_IS_LOWER_THAN_START_DATE',
  ERROR_DURING_READ_FILE_FROM_TACHO = 'ERROR_DURING_READ_FILE_FROM_TACHO',
  IGNITION_OFF_MORE_THAN_2_H_AFTER_LAST_READ = 'IGNITION_OFF_MORE_THAN_2_H_AFTER_LAST_READ',
  IGNITION_OFF_MORE_THAN_24_H = 'IGNITION_OFF_MORE_THAN_24_H',
  NO_COMMUNICATION = 'NO_COMMUNICATION',
  NO_DRIVER_CARD_IN_TACHO = 'NO_DRIVER_CARD_IN_TACHO',
  NO_RESPONSE_FROM_CAN = 'NO_RESPONSE_FROM_CAN',
  OPENING_REMOTE_SESSION_ERROR = 'OPENING_REMOTE_SESSION_ERROR',
  OTHER_AUTHORIZATION_IN_PROGRESS = 'OTHER_AUTHORIZATION_IN_PROGRESS',
  READING_IMPOSSIBLE = 'READING_IMPOSSIBLE',
  READ_BLOCKED_BY_ANOTHER_COMPANY_CARD = 'READ_BLOCKED_BY_ANOTHER_COMPANY_CARD',
  READ_INVALID = 'READ_INVALID',
  READ_INVALID_CERT = 'READ_INVALID_CERT',
  REMOTE_READING_DISABLED = 'REMOTE_READING_DISABLED',
  RODO_FIRST_SLOT_LOCK = 'RODO_FIRST_SLOT_LOCK',
  RODO_SECOND_SLOT_LOCK = 'RODO_SECOND_SLOT_LOCK',
  SD_CARD_STORAGE_ERROR = 'SD_CARD_STORAGE_ERROR',
  SMART_CARD_AUTHORIZATION_FAILED = 'SMART_CARD_AUTHORIZATION_FAILED',
  TACHOGRAPH_LAST_READ_DELAY_CRITICAL = 'TACHOGRAPH_LAST_READ_DELAY_CRITICAL',
  TACHOGRAPH_LAST_READ_DELAY_WARNING = 'TACHOGRAPH_LAST_READ_DELAY_WARNING',
  TACHO_IS_BUSY = 'TACHO_IS_BUSY',
  TACHO_REJECT = 'TACHO_REJECT'
}

export type TachoRemoteWarningType = {
  __typename?: 'TachoRemoteWarningType';
  code?: Maybe<TachoRemoteWarningCodeType>;
  meta?: Maybe<Array<Maybe<KeyValueType>>>;
};

export type TargetType = {
  __typename?: 'TargetType';
  address?: Maybe<Scalars['String']['output']>;
  coords?: Maybe<Coordinate>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type Task = {
  __typename?: 'Task';
  arriveTimeEnd?: Maybe<Scalars['DateTime']['output']>;
  attachments?: Maybe<Array<Maybe<TaskAttachment>>>;
  attachmentsCount?: Maybe<Scalars['Int']['output']>;
  clientId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  /** List of vehicle types */
  driver?: Maybe<Driver>;
  driverId?: Maybe<Scalars['String']['output']>;
  eta?: Maybe<Eta>;
  finishNote?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  state?: Maybe<TaskState>;
  status?: Maybe<TaskStatus>;
  target?: Maybe<TargetType>;
};

export type TaskAttachment = {
  __typename?: 'TaskAttachment';
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum TaskCancelReason {
  DESTINATION_REACHED = 'DESTINATION_REACHED',
  MAX_JOB_TIME_REACHED = 'MAX_JOB_TIME_REACHED',
  REJECTED = 'REJECTED'
}

export enum TaskEtaStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING'
}

export enum TaskState {
  CREATED = 'CREATED',
  PROCESSED = 'PROCESSED',
  PROCESSING = 'PROCESSING'
}

export enum TaskStatus {
  CANCELED = 'CANCELED',
  CREATED = 'CREATED',
  FINISHED = 'FINISHED',
  READ = 'READ',
  RECEIVED = 'RECEIVED',
  SENT = 'SENT',
  STARTED = 'STARTED'
}

export type TasksModule = {
  __typename?: 'TasksModule';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export enum UnloadType {
  FULL = 'FULL',
  PARTIAL = 'PARTIAL'
}

export type UpdateDriverInputType = {
  driverCard: DriverCardInputType;
  driverIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone: DriverPhoneInputType;
  pin?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  workNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDriverMutationType = {
  __typename?: 'UpdateDriverMutationType';
  clientId?: Maybe<Scalars['Int']['output']>;
  driverCard?: Maybe<DriverCard>;
  driverIdentificationNumber?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<DriverPhone>;
  pin?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  workNumber?: Maybe<Scalars['String']['output']>;
};

export type UsageType = {
  __typename?: 'UsageType';
  count?: Maybe<Scalars['Int']['output']>;
  monthlyLimit?: Maybe<Scalars['Int']['output']>;
  vehicleId?: Maybe<Scalars['Int']['output']>;
};

export type UserPoint = {
  __typename?: 'UserPoint';
  address?: Maybe<Scalars['String']['output']>;
  filepath?: Maybe<Scalars['String']['output']>;
  iconName: UserPointIconName;
  name: Scalars['String']['output'];
  position?: Maybe<UserPointPosition>;
};

export type UserPointGroup = {
  __typename?: 'UserPointGroup';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  userPoints?: Maybe<Array<Maybe<UserPoint>>>;
};

export enum UserPointIconName {
  ANCHOR = 'Anchor',
  BOMB = 'Bomb',
  FLAG1 = 'Flag1',
  FLAG2 = 'Flag2',
  GASSTATION = 'GasStation',
  HOUSE = 'House',
  INFO = 'Info',
  ORDER = 'Order',
  PARKING = 'Parking',
  POI = 'Poi',
  SIGN = 'Sign',
  WRENCH = 'Wrench'
}

export type UserPointPosition = {
  __typename?: 'UserPointPosition';
  latitude: Scalars['Int']['output'];
  longitude: Scalars['Int']['output'];
};

export type UserPointPositionInput = {
  latitude: Scalars['Int']['input'];
  longitude: Scalars['Int']['input'];
};

export type Vehicle = {
  __typename?: 'Vehicle';
  appearance?: Maybe<VehicleAppearanceType>;
  assistDevice?: Maybe<VehicleDeviceType>;
  authorizedDrivers?: Maybe<Array<Maybe<MaybeUnknownDriver>>>;
  boxId?: Maybe<Scalars['Int']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use "hasAssist" field */
  communication?: Maybe<Scalars['Int']['output']>;
  current?: Maybe<VehicleCurrentType>;
  currentDriver?: Maybe<MaybeUnknownDriver>;
  currentEtaMonitors?: Maybe<Array<Maybe<EtaMonitorTask>>>;
  defaultGroup?: Maybe<VehicleGroupType>;
  devices?: Maybe<Array<Maybe<VehicleDeviceType>>>;
  driverCardReadingSource?: Maybe<DriverCardReadingSource>;
  driverStatus?: Maybe<DriverStatusType>;
  drivers?: Maybe<Array<Maybe<MaybeUnknownDriver>>>;
  ecoDrivingGroup?: Maybe<EcoDrivingGroup>;
  etaLightTasks?: Maybe<Array<Maybe<EtaLightTask>>>;
  etaMonitors?: Maybe<Array<Maybe<EtaMonitor>>>;
  etaOrderTasks?: Maybe<Array<Maybe<OrderTask>>>;
  fleetTypes?: Maybe<Array<Maybe<FleetType>>>;
  groups?: Maybe<Array<Maybe<VehicleGroupType>>>;
  hasAssist?: Maybe<Scalars['Boolean']['output']>;
  hasAuthorizedDrivers?: Maybe<Scalars['Boolean']['output']>;
  hasEtaLightMonitors?: Maybe<Scalars['Boolean']['output']>;
  hasOBU?: Maybe<Scalars['Boolean']['output']>;
  hasWorkingTimeSource?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  identifiedDrivers?: Maybe<Array<Maybe<Driver>>>;
  isBig?: Maybe<Scalars['Boolean']['output']>;
  isTrailer?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<VehicleKindType>;
  label?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<VehicleType>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  translatorTacho?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  workingTimeSource?: Maybe<VehicleWorkingTimeSource>;
  yearOfProduction?: Maybe<Scalars['Int']['output']>;
};

export type VehicleAppearanceType = {
  __typename?: 'VehicleAppearanceType';
  dynamicIcon?: Maybe<Scalars['Boolean']['output']>;
  iconId?: Maybe<Scalars['Int']['output']>;
  registrationNumberAsName?: Maybe<Scalars['Boolean']['output']>;
};

export type VehicleCurrentFuel = {
  __typename?: 'VehicleCurrentFuel';
  tank1?: Maybe<Scalars['Float']['output']>;
  tank2?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type VehicleCurrentGps = {
  __typename?: 'VehicleCurrentGps';
  address?: Maybe<Scalars['String']['output']>;
  directionAngle?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type VehicleCurrentType = {
  __typename?: 'VehicleCurrentType';
  batteryVoltage?: Maybe<Scalars['Float']['output']>;
  engineOn?: Maybe<Scalars['Boolean']['output']>;
  fuel?: Maybe<VehicleCurrentFuel>;
  gps?: Maybe<VehicleCurrentGps>;
  lastSignal?: Maybe<Scalars['DateTime']['output']>;
  press?: Maybe<Scalars['Float']['output']>;
  ride?: Maybe<Scalars['Boolean']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
  stopOnIgnitionDuration?: Maybe<Scalars['Float']['output']>;
  totalLoad?: Maybe<Scalars['Float']['output']>;
};

export type VehicleData = {
  __typename?: 'VehicleData';
  avgFuelConsumption?: Maybe<Scalars['Float']['output']>;
  dateRanges?: Maybe<Array<Maybe<DateRangeData>>>;
  distance?: Maybe<Scalars['Int']['output']>;
  /** Vehicle data */
  vehicle?: Maybe<Vehicle>;
  vehicleId?: Maybe<Scalars['Int']['output']>;
};

export enum VehicleDeviceCommunicationStatus {
  COMMUNICATION_PROBLEMS = 'COMMUNICATION_PROBLEMS',
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE'
}

export enum VehicleDeviceModelType {
  GBOX_ASSIST = 'GBOX_ASSIST',
  OBU = 'OBU'
}

export type VehicleDeviceType = {
  __typename?: 'VehicleDeviceType';
  boxId?: Maybe<Scalars['Int']['output']>;
  communicationStatus?: Maybe<VehicleDeviceCommunicationStatus>;
  imei?: Maybe<Scalars['String']['output']>;
  isOffline?: Maybe<Scalars['Boolean']['output']>;
  model: VehicleDeviceModelType;
  obuName?: Maybe<Scalars['String']['output']>;
};

export type VehicleExtended = {
  __typename?: 'VehicleExtended';
  appearance?: Maybe<VehicleAppearanceType>;
  assistDevice?: Maybe<VehicleDeviceType>;
  authorizedDrivers?: Maybe<Array<Maybe<MaybeUnknownDriver>>>;
  boxId?: Maybe<Scalars['Int']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  current?: Maybe<VehicleCurrentType>;
  currentDriver?: Maybe<MaybeUnknownDriver>;
  currentEtaMonitors?: Maybe<Array<Maybe<EtaMonitorTask>>>;
  defaultGroup?: Maybe<VehicleGroupType>;
  devices?: Maybe<Array<Maybe<VehicleDeviceType>>>;
  driverCardReadingSource?: Maybe<DriverCardReadingSource>;
  driverStatus?: Maybe<DriverStatusType>;
  drivers?: Maybe<Array<Maybe<MaybeUnknownDriver>>>;
  ecoDrivingGroup?: Maybe<EcoDrivingGroup>;
  etaLightTasks?: Maybe<Array<Maybe<EtaLightTask>>>;
  etaMonitors?: Maybe<Array<Maybe<EtaMonitor>>>;
  etaOrderTasks?: Maybe<Array<Maybe<OrderTask>>>;
  fleetTypes?: Maybe<Array<Maybe<FleetType>>>;
  fuelTanks?: Maybe<FuelTanksType>;
  groups?: Maybe<Array<Maybe<VehicleGroupType>>>;
  hasAssist?: Maybe<Scalars['Boolean']['output']>;
  hasAuthorizedDrivers?: Maybe<Scalars['Boolean']['output']>;
  hasEtaLightMonitors?: Maybe<Scalars['Boolean']['output']>;
  hasOBU?: Maybe<Scalars['Boolean']['output']>;
  hasWorkingTimeSource?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  identifiedDrivers?: Maybe<Array<Maybe<Driver>>>;
  isBig?: Maybe<Scalars['Boolean']['output']>;
  isTrailer?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<VehicleKindType>;
  label?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<VehicleType>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  translatorTacho?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  workingTimeSource?: Maybe<VehicleWorkingTimeSource>;
  yearOfProduction?: Maybe<Scalars['Int']['output']>;
};

export type VehicleGroupType = {
  __typename?: 'VehicleGroupType';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hexColor?: Maybe<Scalars['String']['output']>;
  hexInvertedColor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum VehicleKindType {
  TRACTOR = 'TRACTOR',
  TRAILER = 'TRAILER'
}

export type VehicleType = {
  __typename?: 'VehicleType';
  axleLoad?: Maybe<Scalars['Float']['output']>;
  grossWeight?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  trailersCount?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export enum VehicleWorkingTimeSource {
  ASSIST = 'ASSIST',
  GBOX = 'GBOX',
  NONE = 'NONE'
}

export type WorkTimeActivity = {
  __typename?: 'WorkTimeActivity';
  begin?: Maybe<Scalars['DateTime']['output']>;
  end?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type WorkingTimeModule = {
  __typename?: 'WorkingTimeModule';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ClientQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientQuery = { __typename?: 'Query', me?: { __typename?: 'Me', id?: number | null, name?: string | null, isInternal?: boolean | null, isJoint?: boolean | null, featureFlags?: { __typename?: 'FeatureFlagsType', batteryVoltage?: boolean | null, tachoRemote?: boolean | null } | null, settings?: { __typename?: 'Settings', legacy?: { __typename?: 'Legacy', hasAssist?: boolean | null, licencePlan?: LicencePlanType | null, fleetType?: FleetTypeType | null } | null, system?: { __typename?: 'System', legacyAssist?: { __typename?: 'LegacyAssistModule', enabled?: boolean | null } | null, legacyAlerts?: { __typename?: 'LegacyAlertsModule', enabled?: boolean | null } | null, legacyReports?: { __typename?: 'LegacyReportsModule', enabled?: boolean | null } | null, tachoRemote?: { __typename?: 'TachoRemoteModule', enabled?: boolean | null } | null, tachoRemote2?: { __typename?: 'TachoRemote2Module', enabled?: boolean | null, configured?: boolean | null, launched?: boolean | null, migrated?: boolean | null } | null, legacyTemporaryLinks?: { __typename?: 'LegacyTemporaryLinksModule', enabled?: boolean | null } | null, ecoDriving?: { __typename?: 'EcoDrivingModule', enabled?: boolean | null, cruiseControl?: boolean | null, groups?: boolean | null, pdfExport?: boolean | null, ranking?: boolean | null, retarder?: boolean | null, tonnage?: boolean | null } | null, legacyHistory?: { __typename?: 'LegacyHistoryModule', enabled?: boolean | null, availabilityTime?: number | null } | null, etaLight?: { __typename?: 'EtaLightModule', enabled?: boolean | null, vehicles?: Array<number | null> | null } | null, orders?: { __typename?: 'OrdersModule', enabled?: boolean | null, eta?: boolean | null, etaVehicles?: Array<number | null> | null, deprecated?: boolean | null, archived?: boolean | null, calendar?: boolean | null, archivePermissions?: SettingsOrdersArchivePermissionsType | null } | null, workTime?: { __typename?: 'WorkingTimeModule', enabled?: boolean | null } | null, tasks?: { __typename?: 'TasksModule', enabled?: boolean | null } | null, driverApp?: { __typename?: 'DriverAppModule', enabled?: boolean | null } | null, apiAccounts?: { __typename?: 'ApiAccountsModule', enabled?: boolean | null, partner?: boolean | null } | null, etoll?: { __typename?: 'ETOLLModule', enabled?: boolean | null } | null, mobilityPackage?: { __typename?: 'MobilityPackageModule', enabled?: boolean | null, foreignWage?: boolean | null } | null, fireTms?: { __typename?: 'FireTms', enabled?: boolean | null } | null, fleet?: { __typename?: 'Fleet', hasAssist?: boolean | null, type?: FleetTypeType | null } | null } | null } | null } | null };

export type MapContextCancelEtaLightTaskMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type MapContextCancelEtaLightTaskMutation = { __typename?: 'Mutation', etaLightTask?: { __typename?: 'EtaLightTaskMutationType', cancel?: { __typename?: 'CancelEtaLightTaskMutationType', id?: string | null } | null } | null };

type MapContextEtaMonitorFields_EtaLightTask_Fragment = { __typename?: 'EtaLightTask', etaTimeStatus?: EtaTimeStatus | null, sourceId?: string | null, isExceeded?: boolean | null, isOk?: boolean | null, isEndangered?: boolean | null, isUnknown?: boolean | null, isEtaLightSource?: boolean | null, isOrderTaskSource?: boolean | null, isCalculated?: boolean | null, isCanceled?: boolean | null };

type MapContextEtaMonitorFields_OrderTask_Fragment = { __typename?: 'OrderTask', etaTimeStatus?: EtaTimeStatus | null, sourceId?: string | null, isExceeded?: boolean | null, isOk?: boolean | null, isEndangered?: boolean | null, isUnknown?: boolean | null, isEtaLightSource?: boolean | null, isOrderTaskSource?: boolean | null, isCalculated?: boolean | null, isCanceled?: boolean | null };

export type MapContextEtaMonitorFieldsFragment = MapContextEtaMonitorFields_EtaLightTask_Fragment | MapContextEtaMonitorFields_OrderTask_Fragment;

export type MapContextActiveOrderTaskFragmentFragment = { __typename?: 'OrderTask', arriveTimeEnd?: Date | null, createdAt?: Date | null, order?: { __typename?: 'Order', vehicleId?: number | null, vehicle?: { __typename?: 'Vehicle', id?: number | null } | null } | null, target?: { __typename?: 'TargetType', address?: string | null, coords?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null } | null } | null, eta?: { __typename?: 'Eta', status?: TaskEtaStatus | null, distance?: { __typename?: 'EtaDistance', left?: number | null } | null, arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null, restsTaken?: Array<{ __typename?: 'EtaRestTakenType', startedAt?: Date | null, questionable?: boolean | null, period?: number | null } | null> | null } | null };

export type MapContextActiveEtaLightTaskFragmentFragment = { __typename?: 'EtaLightTask', plannedArrivalTime?: Date | null, vehicleId?: number | null, createdAt?: Date | null, updateAt?: Date | null, status?: EtaLightTaskStatus | null, cancelReason?: TaskCancelReason | null, target?: { __typename?: 'TargetType', address?: string | null, coords?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null } | null } | null, eta?: { __typename?: 'Eta', status?: TaskEtaStatus | null, distance?: { __typename?: 'EtaDistance', left?: number | null } | null, arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null, restsTaken?: Array<{ __typename?: 'EtaRestTakenType', startedAt?: Date | null, questionable?: boolean | null, period?: number | null } | null> | null } | null };

export type MapContextEtaTasksQueryVariables = Exact<{
  includeOrderTasks: Scalars['Boolean']['input'];
  includeEtaLightTasks: Scalars['Boolean']['input'];
}>;


export type MapContextEtaTasksQuery = { __typename?: 'Query', me?: { __typename?: 'Me', orderTasks?: Array<{ __typename?: 'OrderTask', id?: string | null, arriveTimeEnd?: Date | null, createdAt?: Date | null, order?: { __typename?: 'Order', vehicleId?: number | null, vehicle?: { __typename?: 'Vehicle', id?: number | null } | null } | null, target?: { __typename?: 'TargetType', address?: string | null, coords?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null } | null } | null, eta?: { __typename?: 'Eta', status?: TaskEtaStatus | null, distance?: { __typename?: 'EtaDistance', left?: number | null } | null, arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null, restsTaken?: Array<{ __typename?: 'EtaRestTakenType', startedAt?: Date | null, questionable?: boolean | null, period?: number | null } | null> | null } | null } | null> | null, etaLightTasks?: Array<{ __typename?: 'EtaLightTask', id?: number | null, plannedArrivalTime?: Date | null, vehicleId?: number | null, createdAt?: Date | null, updateAt?: Date | null, status?: EtaLightTaskStatus | null, cancelReason?: TaskCancelReason | null, target?: { __typename?: 'TargetType', address?: string | null, coords?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null } | null } | null, eta?: { __typename?: 'Eta', status?: TaskEtaStatus | null, distance?: { __typename?: 'EtaDistance', left?: number | null } | null, arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null, restsTaken?: Array<{ __typename?: 'EtaRestTakenType', startedAt?: Date | null, questionable?: boolean | null, period?: number | null } | null> | null } | null } | null> | null } | null };

export type IncidentsListQueryVariables = Exact<{ [key: string]: never; }>;


export type IncidentsListQuery = { __typename?: 'Query', mapModuleIncidentsList: { __typename?: 'MapModuleIncidentsListResponse', trafficCongestion?: Array<{ __typename?: 'Incident', geoLat: number, geoLong: number, position?: Array<number> | null, type: string, roadLabel: string, description: string, incidentType?: { __typename?: 'IncidentType', id: IncidentTypeKey } | null }> | null } };

type OpenedEtaMonitor_EtaLightTask_Fragment = { __typename?: 'EtaLightTask', id?: number | null, etaTimeStatus?: EtaTimeStatus | null, sourceId?: string | null, isExceeded?: boolean | null, isOk?: boolean | null, isEndangered?: boolean | null, isUnknown?: boolean | null, isEtaLightSource?: boolean | null, isOrderTaskSource?: boolean | null, isCalculated?: boolean | null, isCanceled?: boolean | null, plannedArrivalTime?: Date | null, vehicleId?: number | null, createdAt?: Date | null, updateAt?: Date | null, status?: EtaLightTaskStatus | null, cancelReason?: TaskCancelReason | null, target?: { __typename?: 'TargetType', address?: string | null, coords?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null } | null } | null, eta?: { __typename?: 'Eta', status?: TaskEtaStatus | null, distance?: { __typename?: 'EtaDistance', left?: number | null } | null, arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null, restsTaken?: Array<{ __typename?: 'EtaRestTakenType', startedAt?: Date | null, questionable?: boolean | null, period?: number | null } | null> | null } | null };

type OpenedEtaMonitor_OrderTask_Fragment = { __typename?: 'OrderTask', etaTimeStatus?: EtaTimeStatus | null, sourceId?: string | null, isExceeded?: boolean | null, isOk?: boolean | null, isEndangered?: boolean | null, isUnknown?: boolean | null, isEtaLightSource?: boolean | null, isOrderTaskSource?: boolean | null, isCalculated?: boolean | null, isCanceled?: boolean | null, arriveTimeEnd?: Date | null, createdAt?: Date | null, Id?: string | null, order?: { __typename?: 'Order', vehicleId?: number | null, vehicle?: { __typename?: 'Vehicle', id?: number | null } | null } | null, target?: { __typename?: 'TargetType', address?: string | null, coords?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null } | null } | null, eta?: { __typename?: 'Eta', status?: TaskEtaStatus | null, distance?: { __typename?: 'EtaDistance', left?: number | null } | null, arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null, restsTaken?: Array<{ __typename?: 'EtaRestTakenType', startedAt?: Date | null, questionable?: boolean | null, period?: number | null } | null> | null } | null };

export type OpenedEtaMonitorFragment = OpenedEtaMonitor_EtaLightTask_Fragment | OpenedEtaMonitor_OrderTask_Fragment;

export type DriverVehicleDetailsFragmentFragment = { __typename?: 'Driver', id?: number | null, uuid?: string | null, driverIdentificationNumber?: string | null, firstName?: string | null, lastName?: string | null, driverState?: DriverState | null, isAuthorized?: boolean | null, fullName?: string | null, identificationId?: string | null, driverCard?: { __typename?: 'DriverCard', countryCode?: number | null, number?: string | null } | null };

export type MapSelectedVehicleDetailsQueryVariables = Exact<{
  vehicleId: Scalars['Int']['input'];
}>;


export type MapSelectedVehicleDetailsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', vehicle?: { __typename?: 'VehicleExtended', id?: number | null, boxId?: number | null, name?: string | null, registrationNumber?: string | null, type?: number | null, kind?: VehicleKindType | null, label?: string | null, driverCardReadingSource?: DriverCardReadingSource | null, isTrailer?: boolean | null, hasEtaLightMonitors?: boolean | null, hasOBU?: boolean | null, hasAssist?: boolean | null, hasAuthorizedDrivers?: boolean | null, workingTimeSource?: VehicleWorkingTimeSource | null, hasWorkingTimeSource?: boolean | null, devices?: Array<{ __typename?: 'VehicleDeviceType', model: VehicleDeviceModelType, communicationStatus?: VehicleDeviceCommunicationStatus | null, imei?: string | null } | null> | null, drivers?: Array<{ __typename?: 'Driver', id?: number | null, uuid?: string | null, driverIdentificationNumber?: string | null, firstName?: string | null, lastName?: string | null, driverState?: DriverState | null, isAuthorized?: boolean | null, fullName?: string | null, identificationId?: string | null, driverCard?: { __typename?: 'DriverCard', countryCode?: number | null, number?: string | null } | null } | { __typename?: 'DriverUnknown', driverCardNumber?: string | null, driverState?: DriverState | null, isAuthorized?: boolean | null } | null> | null, authorizedDrivers?: Array<{ __typename?: 'Driver', id?: number | null, uuid?: string | null, driverIdentificationNumber?: string | null, firstName?: string | null, lastName?: string | null, driverState?: DriverState | null, isAuthorized?: boolean | null, fullName?: string | null, identificationId?: string | null, driverCard?: { __typename?: 'DriverCard', countryCode?: number | null, number?: string | null } | null } | { __typename?: 'DriverUnknown', driverCardNumber?: string | null, identificationId?: string | null } | null> | null, currentDriver?: { __typename?: 'Driver', id?: number | null, uuid?: string | null, driverIdentificationNumber?: string | null, firstName?: string | null, lastName?: string | null, driverState?: DriverState | null, isAuthorized?: boolean | null, fullName?: string | null, identificationId?: string | null, driverCard?: { __typename?: 'DriverCard', countryCode?: number | null, number?: string | null } | null } | { __typename?: 'DriverUnknown', driverCardNumber?: string | null, isAuthorized?: boolean | null } | null, driverStatus?: { __typename?: 'DriverStatusType', name?: string | null, date?: Date | null } | null, fuelTanks?: { __typename?: 'FuelTanksType', tank1?: { __typename?: 'FuelTankType', capacity?: number | null } | null, tank2?: { __typename?: 'FuelTankType', capacity?: number | null } | null } | null, assistDevice?: { __typename?: 'VehicleDeviceType', model: VehicleDeviceModelType, communicationStatus?: VehicleDeviceCommunicationStatus | null, isOffline?: boolean | null, imei?: string | null } | null, profile?: { __typename?: 'VehicleType', id?: number | null, name?: string | null, width?: number | null, height?: number | null, length?: number | null, grossWeight?: number | null, axleLoad?: number | null } | null, current?: { __typename?: 'VehicleCurrentType', lastSignal?: Date | null, engineOn?: boolean | null, press?: number | null, ride?: boolean | null, stopOnIgnitionDuration?: number | null, totalLoad?: number | null, speed?: number | null, batteryVoltage?: number | null, gps?: { __typename?: 'VehicleCurrentGps', address?: string | null, lat?: number | null, lng?: number | null, directionAngle?: number | null } | null, fuel?: { __typename?: 'VehicleCurrentFuel', tank1?: number | null, tank2?: number | null, total?: number | null } | null } | null } | null } | null };

export type MapSettingsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  settingsId: Scalars['Int']['input'];
}>;


export type MapSettingsQuery = { __typename?: 'Query', mapModuleUserSettings: { __typename?: 'MapModuleUserSettingsResponse', userSettings: { __typename?: 'MapModuleUserSettings', list: { __typename?: 'MapModuleUserSettingsList', vehicleDetails: { __typename?: 'MapModuleUserSettingsListVehicleDetails', address: boolean, currentEtaMonitor: boolean, driverName: boolean }, vehicleInfo: { __typename?: 'MapModuleUserSettingsListVehicleInfo', fuel: boolean, speed: boolean, totalLoad: boolean, batteryVoltage: boolean }, vehicleTitle: { __typename?: 'MapModuleUserSettingsListVehicleTitle', name: boolean, registration: boolean } } } }, mapModuleClientSettings: { __typename?: 'MapModuleClientSettingsResponse', configuration?: { __typename?: 'MapModuleClientSettings', hiSpeedBig: number, hiSpeedSmall: number, layingLabels: boolean, lowSpeedBig: number, lowSpeedSmall: number, showStopAfter: number, unifyLabelsColor: boolean, showDrivingDirection: boolean, labelBackgroundColorTransparentize: number } | null } };

export type UserPointGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPointGroupsQuery = { __typename?: 'Query', mapModuleUserPointGroups: { __typename?: 'MapModuleUserPointGroupsResponse', userPointGroups?: Array<{ __typename?: 'UserPointGroup', id: number, name: string }> | null } };

export type UserPointsQueryVariables = Exact<{
  groupId: Scalars['Int']['input'];
}>;


export type UserPointsQuery = { __typename?: 'Query', mapModuleUserPoints: { __typename?: 'MapModuleUserPointsResponse', userPointGroup?: { __typename?: 'UserPointGroup', id: number, name: string, userPoints?: Array<{ __typename?: 'UserPoint', name: string, address?: string | null, iconName: UserPointIconName, filePath?: string | null, position?: { __typename?: 'UserPointPosition', latitude: number, longitude: number } | null } | null> | null } | null } };

export type CreateUserPointMutationVariables = Exact<{
  createUserPointInput: MapModuleUserPointCreateInputType;
}>;


export type CreateUserPointMutation = { __typename?: 'Mutation', mapModuleUserPoints?: { __typename?: 'NullResponse', content?: string | null } | null };

export type UpdateUserSettingsMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  settingsId: Scalars['Int']['input'];
  settings: MapModuleUserSettingsInputType;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'Mutation', mapModuleSettings?: { __typename?: 'NullResponse', content?: string | null } | null };

export type OnVehicleCurrentFragmentFragment = { __typename?: 'VehicleCurrentType', lastSignal?: Date | null, engineOn?: boolean | null, press?: number | null, ride?: boolean | null, stopOnIgnitionDuration?: number | null, totalLoad?: number | null, speed?: number | null, batteryVoltage?: number | null, gps?: { __typename?: 'VehicleCurrentGps', address?: string | null, lat?: number | null, lng?: number | null, directionAngle?: number | null } | null, fuel?: { __typename?: 'VehicleCurrentFuel', tank1?: number | null, tank2?: number | null, total?: number | null } | null };

export type VehicleCurrentFragmentFragment = { __typename?: 'Vehicle', current?: { __typename?: 'VehicleCurrentType', lastSignal?: Date | null, engineOn?: boolean | null, press?: number | null, ride?: boolean | null, stopOnIgnitionDuration?: number | null, totalLoad?: number | null, speed?: number | null, batteryVoltage?: number | null, gps?: { __typename?: 'VehicleCurrentGps', address?: string | null, lat?: number | null, lng?: number | null, directionAngle?: number | null } | null, fuel?: { __typename?: 'VehicleCurrentFuel', tank1?: number | null, tank2?: number | null, total?: number | null } | null } | null };

export type VehicleExtendedCurrentFragmentFragment = { __typename?: 'VehicleExtended', current?: { __typename?: 'VehicleCurrentType', lastSignal?: Date | null, engineOn?: boolean | null, press?: number | null, ride?: boolean | null, stopOnIgnitionDuration?: number | null, totalLoad?: number | null, speed?: number | null, batteryVoltage?: number | null, gps?: { __typename?: 'VehicleCurrentGps', address?: string | null, lat?: number | null, lng?: number | null, directionAngle?: number | null } | null, fuel?: { __typename?: 'VehicleCurrentFuel', tank1?: number | null, tank2?: number | null, total?: number | null } | null } | null };

export type VehicleProfileQueryQueryVariables = Exact<{
  clientId: Scalars['Int']['input'];
}>;


export type VehicleProfileQueryQuery = { __typename?: 'Query', client?: { __typename?: 'Client', vehicleTypes?: Array<{ __typename?: 'VehicleType', id?: number | null, name?: string | null, grossWeight?: number | null, length?: number | null, height?: number | null, width?: number | null, axleLoad?: number | null } | null> | null } | null };

export type MapVehiclesGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type MapVehiclesGroupsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', vehiclesGroups?: Array<{ __typename?: 'VehicleGroupType', id?: number | null, name?: string | null, color?: string | null } | null> | null } | null };

export type VehicleMapContextFragmentFragment = { __typename?: 'Vehicle', id?: number | null, boxId?: number | null, name?: string | null, registrationNumber?: string | null, label?: string | null, fleetTypes?: Array<FleetType | null> | null, driverCardReadingSource?: DriverCardReadingSource | null, workingTimeSource?: VehicleWorkingTimeSource | null, type?: number | null, kind?: VehicleKindType | null, hasWorkingTimeSource?: boolean | null, hasAuthorizedDrivers?: boolean | null, isTrailer?: boolean | null, hasEtaLightMonitors?: boolean | null, isBig?: boolean | null, hasOBU?: boolean | null, hasAssist?: boolean | null, drivers?: Array<{ __typename: 'Driver', id?: number | null, uuid?: string | null, driverIdentificationNumber?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, driverState?: DriverState | null, driverCard?: { __typename?: 'DriverCard', countryCode?: number | null, number?: string | null } | null } | { __typename: 'DriverUnknown', driverCardNumber?: string | null, driverState?: DriverState | null } | null> | null, identifiedDrivers?: Array<{ __typename?: 'Driver', id?: number | null, firstName?: string | null, lastName?: string | null } | null> | null, groups?: Array<{ __typename?: 'VehicleGroupType', id?: number | null, color?: string | null } | null> | null, defaultGroup?: { __typename?: 'VehicleGroupType', id?: number | null, color?: string | null, hexColor?: string | null, hexInvertedColor?: string | null } | null, appearance?: { __typename?: 'VehicleAppearanceType', dynamicIcon?: boolean | null, iconId?: number | null, registrationNumberAsName?: boolean | null } | null, devices?: Array<{ __typename?: 'VehicleDeviceType', model: VehicleDeviceModelType, communicationStatus?: VehicleDeviceCommunicationStatus | null } | null> | null, assistDevice?: { __typename?: 'VehicleDeviceType', model: VehicleDeviceModelType, communicationStatus?: VehicleDeviceCommunicationStatus | null, isOffline?: boolean | null } | null, etaLightTasks?: Array<{ __typename?: 'EtaLightTask', id?: number | null, plannedArrivalTime?: Date | null, vehicleId?: number | null, createdAt?: Date | null, updateAt?: Date | null, status?: EtaLightTaskStatus | null, cancelReason?: TaskCancelReason | null, target?: { __typename?: 'TargetType', address?: string | null, coords?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null } | null } | null, eta?: { __typename?: 'Eta', status?: TaskEtaStatus | null, distance?: { __typename?: 'EtaDistance', left?: number | null } | null, arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null, restsTaken?: Array<{ __typename?: 'EtaRestTakenType', startedAt?: Date | null, questionable?: boolean | null, period?: number | null } | null> | null } | null } | null> | null, etaOrderTasks?: Array<{ __typename?: 'OrderTask', id?: string | null, arriveTimeEnd?: Date | null, createdAt?: Date | null, order?: { __typename?: 'Order', vehicleId?: number | null, vehicle?: { __typename?: 'Vehicle', id?: number | null } | null } | null, target?: { __typename?: 'TargetType', address?: string | null, coords?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null } | null } | null, eta?: { __typename?: 'Eta', status?: TaskEtaStatus | null, distance?: { __typename?: 'EtaDistance', left?: number | null } | null, arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null, restsTaken?: Array<{ __typename?: 'EtaRestTakenType', startedAt?: Date | null, questionable?: boolean | null, period?: number | null } | null> | null } | null } | null> | null, currentEtaMonitors?: Array<{ __typename?: 'EtaLightTask', id?: number | null, plannedArrivalTime?: Date | null, vehicleId?: number | null, createdAt?: Date | null, updateAt?: Date | null, status?: EtaLightTaskStatus | null, cancelReason?: TaskCancelReason | null, etaTimeStatus?: EtaTimeStatus | null, sourceId?: string | null, isExceeded?: boolean | null, isOk?: boolean | null, isEndangered?: boolean | null, isUnknown?: boolean | null, isEtaLightSource?: boolean | null, isOrderTaskSource?: boolean | null, isCalculated?: boolean | null, isCanceled?: boolean | null, target?: { __typename?: 'TargetType', address?: string | null, coords?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null } | null } | null, eta?: { __typename?: 'Eta', status?: TaskEtaStatus | null, distance?: { __typename?: 'EtaDistance', left?: number | null } | null, arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null, restsTaken?: Array<{ __typename?: 'EtaRestTakenType', startedAt?: Date | null, questionable?: boolean | null, period?: number | null } | null> | null } | null } | { __typename?: 'OrderTask', arriveTimeEnd?: Date | null, createdAt?: Date | null, etaTimeStatus?: EtaTimeStatus | null, sourceId?: string | null, isExceeded?: boolean | null, isOk?: boolean | null, isEndangered?: boolean | null, isUnknown?: boolean | null, isEtaLightSource?: boolean | null, isOrderTaskSource?: boolean | null, isCalculated?: boolean | null, isCanceled?: boolean | null, Id?: string | null, order?: { __typename?: 'Order', vehicleId?: number | null, vehicle?: { __typename?: 'Vehicle', id?: number | null } | null } | null, target?: { __typename?: 'TargetType', address?: string | null, coords?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null } | null } | null, eta?: { __typename?: 'Eta', status?: TaskEtaStatus | null, distance?: { __typename?: 'EtaDistance', left?: number | null } | null, arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null, restsTaken?: Array<{ __typename?: 'EtaRestTakenType', startedAt?: Date | null, questionable?: boolean | null, period?: number | null } | null> | null } | null } | null> | null, current?: { __typename?: 'VehicleCurrentType', lastSignal?: Date | null, engineOn?: boolean | null, press?: number | null, ride?: boolean | null, stopOnIgnitionDuration?: number | null, totalLoad?: number | null, speed?: number | null, batteryVoltage?: number | null, gps?: { __typename?: 'VehicleCurrentGps', address?: string | null, lat?: number | null, lng?: number | null, directionAngle?: number | null } | null, fuel?: { __typename?: 'VehicleCurrentFuel', tank1?: number | null, tank2?: number | null, total?: number | null } | null } | null };

export type MapVehiclesListFullQueryVariables = Exact<{ [key: string]: never; }>;


export type MapVehiclesListFullQuery = { __typename?: 'Query', me?: { __typename?: 'Me', vehicles?: Array<{ __typename?: 'Vehicle', id?: number | null, boxId?: number | null, name?: string | null, registrationNumber?: string | null, label?: string | null, fleetTypes?: Array<FleetType | null> | null, driverCardReadingSource?: DriverCardReadingSource | null, workingTimeSource?: VehicleWorkingTimeSource | null, type?: number | null, kind?: VehicleKindType | null, hasWorkingTimeSource?: boolean | null, hasAuthorizedDrivers?: boolean | null, isTrailer?: boolean | null, hasEtaLightMonitors?: boolean | null, isBig?: boolean | null, hasOBU?: boolean | null, hasAssist?: boolean | null, drivers?: Array<{ __typename: 'Driver', id?: number | null, uuid?: string | null, driverIdentificationNumber?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, driverState?: DriverState | null, driverCard?: { __typename?: 'DriverCard', countryCode?: number | null, number?: string | null } | null } | { __typename: 'DriverUnknown', driverCardNumber?: string | null, driverState?: DriverState | null } | null> | null, identifiedDrivers?: Array<{ __typename?: 'Driver', id?: number | null, firstName?: string | null, lastName?: string | null } | null> | null, groups?: Array<{ __typename?: 'VehicleGroupType', id?: number | null, color?: string | null } | null> | null, defaultGroup?: { __typename?: 'VehicleGroupType', id?: number | null, color?: string | null, hexColor?: string | null, hexInvertedColor?: string | null } | null, appearance?: { __typename?: 'VehicleAppearanceType', dynamicIcon?: boolean | null, iconId?: number | null, registrationNumberAsName?: boolean | null } | null, devices?: Array<{ __typename?: 'VehicleDeviceType', model: VehicleDeviceModelType, communicationStatus?: VehicleDeviceCommunicationStatus | null } | null> | null, assistDevice?: { __typename?: 'VehicleDeviceType', model: VehicleDeviceModelType, communicationStatus?: VehicleDeviceCommunicationStatus | null, isOffline?: boolean | null } | null, etaLightTasks?: Array<{ __typename?: 'EtaLightTask', id?: number | null, plannedArrivalTime?: Date | null, vehicleId?: number | null, createdAt?: Date | null, updateAt?: Date | null, status?: EtaLightTaskStatus | null, cancelReason?: TaskCancelReason | null, target?: { __typename?: 'TargetType', address?: string | null, coords?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null } | null } | null, eta?: { __typename?: 'Eta', status?: TaskEtaStatus | null, distance?: { __typename?: 'EtaDistance', left?: number | null } | null, arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null, restsTaken?: Array<{ __typename?: 'EtaRestTakenType', startedAt?: Date | null, questionable?: boolean | null, period?: number | null } | null> | null } | null } | null> | null, etaOrderTasks?: Array<{ __typename?: 'OrderTask', id?: string | null, arriveTimeEnd?: Date | null, createdAt?: Date | null, order?: { __typename?: 'Order', vehicleId?: number | null, vehicle?: { __typename?: 'Vehicle', id?: number | null } | null } | null, target?: { __typename?: 'TargetType', address?: string | null, coords?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null } | null } | null, eta?: { __typename?: 'Eta', status?: TaskEtaStatus | null, distance?: { __typename?: 'EtaDistance', left?: number | null } | null, arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null, restsTaken?: Array<{ __typename?: 'EtaRestTakenType', startedAt?: Date | null, questionable?: boolean | null, period?: number | null } | null> | null } | null } | null> | null, currentEtaMonitors?: Array<{ __typename?: 'EtaLightTask', id?: number | null, plannedArrivalTime?: Date | null, vehicleId?: number | null, createdAt?: Date | null, updateAt?: Date | null, status?: EtaLightTaskStatus | null, cancelReason?: TaskCancelReason | null, etaTimeStatus?: EtaTimeStatus | null, sourceId?: string | null, isExceeded?: boolean | null, isOk?: boolean | null, isEndangered?: boolean | null, isUnknown?: boolean | null, isEtaLightSource?: boolean | null, isOrderTaskSource?: boolean | null, isCalculated?: boolean | null, isCanceled?: boolean | null, target?: { __typename?: 'TargetType', address?: string | null, coords?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null } | null } | null, eta?: { __typename?: 'Eta', status?: TaskEtaStatus | null, distance?: { __typename?: 'EtaDistance', left?: number | null } | null, arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null, restsTaken?: Array<{ __typename?: 'EtaRestTakenType', startedAt?: Date | null, questionable?: boolean | null, period?: number | null } | null> | null } | null } | { __typename?: 'OrderTask', arriveTimeEnd?: Date | null, createdAt?: Date | null, etaTimeStatus?: EtaTimeStatus | null, sourceId?: string | null, isExceeded?: boolean | null, isOk?: boolean | null, isEndangered?: boolean | null, isUnknown?: boolean | null, isEtaLightSource?: boolean | null, isOrderTaskSource?: boolean | null, isCalculated?: boolean | null, isCanceled?: boolean | null, Id?: string | null, order?: { __typename?: 'Order', vehicleId?: number | null, vehicle?: { __typename?: 'Vehicle', id?: number | null } | null } | null, target?: { __typename?: 'TargetType', address?: string | null, coords?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null } | null } | null, eta?: { __typename?: 'Eta', status?: TaskEtaStatus | null, distance?: { __typename?: 'EtaDistance', left?: number | null } | null, arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null, restsTaken?: Array<{ __typename?: 'EtaRestTakenType', startedAt?: Date | null, questionable?: boolean | null, period?: number | null } | null> | null } | null } | null> | null, current?: { __typename?: 'VehicleCurrentType', lastSignal?: Date | null, engineOn?: boolean | null, press?: number | null, ride?: boolean | null, stopOnIgnitionDuration?: number | null, totalLoad?: number | null, speed?: number | null, batteryVoltage?: number | null, gps?: { __typename?: 'VehicleCurrentGps', address?: string | null, lat?: number | null, lng?: number | null, directionAngle?: number | null } | null, fuel?: { __typename?: 'VehicleCurrentFuel', tank1?: number | null, tank2?: number | null, total?: number | null } | null } | null } | null> | null } | null };

export type WorkingTimeDriverUnknownFragment = { __typename?: 'DriverUnknown', driverState?: DriverState | null, identificationId?: string | null, driverCardNumber?: string | null };

export type WorkingTimeDriverQueryVariables = Exact<{
  driverId: Scalars['String']['input'];
}>;


export type WorkingTimeDriverQuery = { __typename?: 'Query', me?: { __typename?: 'Me', drivers?: Array<{ __typename?: 'Driver', id?: number | null, lastName?: string | null, firstName?: string | null, fullName?: string | null, driverState?: DriverState | null, identificationId?: string | null, driverIdentificationNumber?: string | null, driverCard?: { __typename?: 'DriverCard', countryCode?: number | null, number?: string | null } | null } | null> | null } | null };

export type CreateEtaLightTaskMutationVariables = Exact<{
  params: CreateEtaLightTaskInput;
}>;


export type CreateEtaLightTaskMutation = { __typename?: 'Mutation', etaLightTask?: { __typename?: 'EtaLightTaskMutationType', create?: { __typename?: 'CreateEtaLightTaskMutationType', id?: string | null, plannedArrivalTime?: Date | null, vehicleId?: number | null, createdAt?: Date | null, updateAt?: Date | null, status?: EtaLightTaskStatus | null, target?: { __typename?: 'TargetType', address?: string | null, coords?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null } | null } | null, eta?: { __typename?: 'Eta', distance?: { __typename?: 'EtaDistance', left?: number | null } | null, arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null } | null } | null } | null };

export type EtaLightVehicleLimitQueryVariables = Exact<{
  vehicleId: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type EtaLightVehicleLimitQuery = { __typename?: 'Query', me?: { __typename?: 'Me', etaLight?: { __typename?: 'EtaLightType', usage?: Array<{ __typename?: 'UsageType', vehicleId?: number | null, count?: number | null, monthlyLimit?: number | null } | null> | null } | null } | null };

export type DevicesListQueryVariables = Exact<{ [key: string]: never; }>;


export type DevicesListQuery = { __typename?: 'Query', me?: { __typename?: 'Me', customerArea?: { __typename?: 'CustomerArea', contracts?: { __typename?: 'CustomerAreaContractsResponse', data?: Array<{ __typename?: 'CustomerAreaContract', vehicleId: number, registrationNumber: string, state: CustomerAreaContractState, type: string, features: Array<string>, licence: { __typename?: 'CustomerAreaContractLicence', name: string, amount: number, currency: string } }> | null } | null } | null } | null };

export type CustomerAreaPaymentsQueryVariables = Exact<{
  since: Scalars['Date']['input'];
}>;


export type CustomerAreaPaymentsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', customerArea?: { __typename?: 'CustomerArea', payments?: Array<{ __typename?: 'CustomerAreaPayment', number: string, date: any, term: any, status: CustomerAreaPaymentStatus, amount: { __typename?: 'CustomerAreaPaymentAmount', net: number, gross: number, currency: string } }> | null } | null } | null };

export type AssignVehiclesToCompanyMutationVariables = Exact<{
  id: Scalars['String']['input'];
  payload: TachoRemoteCompanyVehiclesInputType;
}>;


export type AssignVehiclesToCompanyMutation = { __typename?: 'Mutation', tachoRemote?: { __typename?: 'TachoRemoteMutationType', company?: { __typename?: 'TachoRemoteCompanyMutationType', assignVehicles?: { __typename?: 'TachoRemoteCompanyVehiclesMutationType', messages?: Array<{ __typename?: 'TachoRemoteActionMessageMutationType', id?: string | null, code?: number | null, fullName?: string | null, message?: string | null } | null> | null } | null } | null } | null };

export type AuthorizationAppsListQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthorizationAppsListQuery = { __typename?: 'Query', me?: { __typename?: 'Me', tachoRemote?: { __typename?: 'TachoRemoteType', authorizationApps?: { __typename?: 'TachoRemoteAuthorizationAppsResultType', data?: Array<{ __typename?: 'TachoRemoteAuthorizationAppType', id?: string | null, name?: string | null, status?: TachoRemoteAuthorizationAppStatusType | null, server?: string | null, ip?: string | null, lastContact?: Date | null, companyCards?: Array<{ __typename?: 'TachoRemoteAuthorizationAppCompanyCardDataType', name?: string | null, countryCode?: number | null, countryCodeLabel?: string | null, number?: string | null, serialNo?: string | null } | null> | null } | null> | null } | null } | null } | null };

export type CompanyCardUpdateMutationVariables = Exact<{
  payload: TachoRemoteUpdateCompanyCardInputType;
  serialNo: Scalars['String']['input'];
}>;


export type CompanyCardUpdateMutation = { __typename?: 'Mutation', tachoRemote?: { __typename?: 'TachoRemoteMutationType', companyCard?: { __typename?: 'TachoRemoteCompanyCardMutationType', update?: { __typename?: 'TachoRemoteUpdateCompanyCardMutationType', serialNo?: string | null } | null } | null } | null };

export type CompanyCardsListQueryVariables = Exact<{
  pending: Scalars['Boolean']['input'];
}>;


export type CompanyCardsListQuery = { __typename?: 'Query', me?: { __typename?: 'Me', tachoRemote?: { __typename?: 'TachoRemoteType', companyCards?: { __typename?: 'TachoRemoteCompanyCardsResultType', data?: Array<{ __typename?: 'TachoRemoteCompanyCardType', name?: string | null, expireDate?: any | null, countryCode?: number | null, number?: string | null, generation?: number | null, configuredAt?: Date | null, active?: boolean | null, serialNo?: string | null, expirationWarning?: boolean | null, status?: TachoRemoteCompanyCardStatusType | null, countryCodeLabel?: string | null, companyId?: string | null, connection?: { __typename?: 'TachoRemoteCompanyCardConnectionType', ip?: string | null, reader?: string | null, server?: string | null } | null } | null> | null } | null } | null } | null };

export type DeactivateAuthorizationAppMutationVariables = Exact<{
  appId: Scalars['String']['input'];
}>;


export type DeactivateAuthorizationAppMutation = { __typename?: 'Mutation', tachoRemote?: { __typename?: 'TachoRemoteMutationType', authorizationApp?: { __typename?: 'TachoRemoteAuthorizationAppMutationType', deactivateAuthorizationApp?: { __typename?: 'TachoRemoteDeactivateAuthorizationAppMutationType', messages?: Array<{ __typename?: 'TachoRemoteActionMessageMutationType', code?: number | null, fullName?: string | null, id?: string | null, message?: string | null } | null> | null } | null } | null } | null };

export type DriverCardsReadsFilesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  source: TachoRemoteFileSourceType;
  range: TachoRemoteFileRangeType;
}>;


export type DriverCardsReadsFilesQuery = { __typename?: 'Query', me?: { __typename?: 'Me', tachoRemote?: { __typename?: 'TachoRemoteType', files?: Array<{ __typename?: 'TachoRemoteFileType', id?: string | null, fileId?: string | null } | null> | null } | null } | null };

export type SupportForMultipleCompanyMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
}>;


export type SupportForMultipleCompanyMutation = { __typename?: 'Mutation', tachoRemote?: { __typename?: 'TachoRemoteMutationType', client?: { __typename?: 'TachoRemoteClientMutationType', supportForMultipleCompany?: { __typename?: 'TachoRemoteSupportForMultipleCompanyMutationType', messages?: Array<{ __typename?: 'TachoRemoteActionMessageMutationType', message?: string | null, id?: string | null, fullName?: string | null, code?: number | null } | null> | null } | null } | null } | null };

export type TachoRemoteCompanyCreateMutationVariables = Exact<{
  payload: TachoRemoteCreateCompanyInputType;
}>;


export type TachoRemoteCompanyCreateMutation = { __typename?: 'Mutation', tachoRemote?: { __typename?: 'TachoRemoteMutationType', company?: { __typename?: 'TachoRemoteCompanyMutationType', create?: { __typename?: 'TachoRemoteCreateCompanyMutationType', id?: string | null, numberOfVehicles?: number | null, name?: string | null, companyCardSerialNumbers?: Array<string | null> | null } | null } | null } | null };

export type TachoRemoteCompanyDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TachoRemoteCompanyDeleteMutation = { __typename?: 'Mutation', tachoRemote?: { __typename?: 'TachoRemoteMutationType', company?: { __typename?: 'TachoRemoteCompanyMutationType', delete?: { __typename?: 'TachoRemoteDeleteCompanyMutationType', status?: string | null } | null } | null } | null };

export type TachoRemoteCompanyUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  payload: TachoRemoteUpdateCompanyInputType;
}>;


export type TachoRemoteCompanyUpdateMutation = { __typename?: 'Mutation', tachoRemote?: { __typename?: 'TachoRemoteMutationType', company?: { __typename?: 'TachoRemoteCompanyMutationType', update?: { __typename?: 'TachoRemoteUpdateCompanyMutationType', id?: string | null, numberOfVehicles?: number | null, name?: string | null, companyCardSerialNumbers?: Array<string | null> | null } | null } | null } | null };

export type TachoRemoteCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type TachoRemoteCompanyQuery = { __typename?: 'Query', me?: { __typename?: 'Me', tachoRemote?: { __typename?: 'TachoRemoteType', companies?: { __typename?: 'TachoRemoteCompaniesResultType', data?: Array<{ __typename?: 'TachoRemoteCompanyType', id?: string | null, name?: string | null, companyCardSerialNumbers?: Array<string | null> | null, numberOfVehicles?: number | null } | null> | null } | null } | null } | null };

export type TachoRemoteStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type TachoRemoteStatusQuery = { __typename?: 'Query', me?: { __typename?: 'Me', tachoRemote?: { __typename?: 'TachoRemoteType', status?: { __typename?: 'TachoRemoteStatusType', state?: TachoRemoteStatusStateType | null, messages?: Array<{ __typename?: 'TachoRemoteStatusMessageType', code?: TachoRemoteStatusCodeType | null, target?: string | null } | null> | null } | null } | null } | null };

export type TachoRemoteVehiclesQueryVariables = Exact<{ [key: string]: never; }>;


export type TachoRemoteVehiclesQuery = { __typename?: 'Query', me?: { __typename?: 'Me', tachoRemote?: { __typename?: 'TachoRemoteType', vehicles?: { __typename?: 'TachoRemoteVehiclesType', data?: Array<{ __typename?: 'TachoRemoteVehicleType', id?: string | null, companyId?: string | null, name?: string | null, registrationNumber?: string | null, companyName?: string | null } | null> | null } | null } | null } | null };

export type TachoRemoteClientQueryVariables = Exact<{ [key: string]: never; }>;


export type TachoRemoteClientQuery = { __typename?: 'Query', me?: { __typename?: 'Me', tachoRemote?: { __typename?: 'TachoRemoteType', client?: { __typename?: 'TachoRemoteClientType', isConfigured?: boolean | null, isEnabled?: boolean | null, numberOfCompanies?: number | null, hasSupportForMultipleCompany?: boolean | null } | null } | null } | null };

export type DriverCardAdditionalReadsMutationVariables = Exact<{
  payload: TachoRemoteDriverCardReadAdditionalReadOrderInputType;
}>;


export type DriverCardAdditionalReadsMutation = { __typename?: 'Mutation', tachoRemote?: { __typename?: 'TachoRemoteMutationType', driverCardRead?: { __typename?: 'TachoRemoteDriverCardMutationType', additionalReads?: { __typename?: 'TachoRemoteDriverCardReadAdditionalReadOrdersMutationType', messages?: Array<{ __typename?: 'TachoRemoteActionMessageMutationType', id?: string | null, code?: number | null, fullName?: string | null, message?: string | null } | null> | null } | null } | null } | null };

export type DriverCardReadsMetaQueryVariables = Exact<{ [key: string]: never; }>;


export type DriverCardReadsMetaQuery = { __typename?: 'Query', me?: { __typename?: 'Me', tachoRemote?: { __typename?: 'TachoRemoteType', driverCard?: { __typename?: 'TachoRemoteDriverCardType', meta?: { __typename?: 'TachoRemoteDriverCardMetaType', suspendedCount?: number | null } | null } | null } | null } | null };

export type DriverCardReadsQueryVariables = Exact<{
  pagination: PaginationContextInputType;
  sorting?: InputMaybe<Array<InputMaybe<TachoRemoteDriverCardReadStatusSortingItemInputType>> | InputMaybe<TachoRemoteDriverCardReadStatusSortingItemInputType>>;
  filters?: InputMaybe<TachoRemoteDriverCardReadStatusFiltersInputType>;
}>;


export type DriverCardReadsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', tachoRemote?: { __typename?: 'TachoRemoteType', driverCard?: { __typename?: 'TachoRemoteDriverCardType', statuses?: { __typename?: 'TachoRemoteDriverCardReadStatusesResultType', matched?: Array<string | null> | null, meta?: { __typename?: 'PaginationResultType', page?: number | null, pageSize?: number | null, pageCount?: number | null, itemsCount?: number | null } | null, data?: Array<{ __typename?: 'TachoRemoteDriverCardReadStatusType', id?: string | null, firstName?: string | null, lastName?: string | null, lastContact?: Date | null, suspended?: boolean | null, driverCard?: { __typename?: 'DriverCard', number?: string | null, countryCode?: number | null, countryCodeLabel?: string | null } | null, lastRead?: { __typename?: 'TachoRemoteDriverCardReadLastReadType', date?: Date | null, delayStatus?: TachoRemoteLastReadDelayStatusType | null } | null, nextRead?: { __typename?: 'TachoRemoteDriverCardReadNextReadType', date?: any | null, type?: TachoRemoteReadReasonType | null } | null, warnings?: Array<{ __typename?: 'TachoRemoteWarningType', code?: TachoRemoteWarningCodeType | null, meta?: Array<{ __typename?: 'KeyValueType', key?: string | null, value?: string | null } | null> | null } | null> | null } | null> | null } | null } | null } | null } | null };

export type SuspendDriverCardReadsMutationVariables = Exact<{
  payload: TachoRemoteSuspendReadsInputType;
}>;


export type SuspendDriverCardReadsMutation = { __typename?: 'Mutation', tachoRemote?: { __typename?: 'TachoRemoteMutationType', driverCardRead?: { __typename?: 'TachoRemoteDriverCardMutationType', suspendReads?: { __typename?: 'TachoRemoteSuspendReadsMutationType', messages?: Array<{ __typename?: 'TachoRemoteActionMessageMutationType', code?: number | null, id?: string | null, fullName?: string | null, message?: string | null } | null> | null } | null } | null } | null };

export type UnsuspendDriverCardReadsMutationVariables = Exact<{
  payload: TachoRemoteUnsuspendReadsInputType;
}>;


export type UnsuspendDriverCardReadsMutation = { __typename?: 'Mutation', tachoRemote?: { __typename?: 'TachoRemoteMutationType', driverCardRead?: { __typename?: 'TachoRemoteDriverCardMutationType', unsuspendReads?: { __typename?: 'TachoRemoteUnsuspendReadsMutationType', messages?: Array<{ __typename?: 'TachoRemoteActionMessageMutationType', code?: number | null, id?: string | null, fullName?: string | null, message?: string | null } | null> | null } | null } | null } | null };

export type DriverCardsReadingsHistoryQueryVariables = Exact<{
  filters?: InputMaybe<TachoRemoteDriverCardReadFiltersInputType>;
  pagination: PaginationContextInputType;
  sorting?: InputMaybe<Array<InputMaybe<TachoRemoteDriverCardReadSortingItemInputType>> | InputMaybe<TachoRemoteDriverCardReadSortingItemInputType>>;
}>;


export type DriverCardsReadingsHistoryQuery = { __typename?: 'Query', me?: { __typename?: 'Me', tachoRemote?: { __typename?: 'TachoRemoteType', driverCard?: { __typename?: 'TachoRemoteDriverCardType', reads?: { __typename?: 'TachoRemoteDriverCardReadsResultType', matched?: Array<string | null> | null, meta?: { __typename?: 'PaginationResultType', page?: number | null, pageSize?: number | null, pageCount?: number | null, itemsCount?: number | null } | null, data?: Array<{ __typename?: 'TachoRemoteDriverCardReadType', id?: string | null, driverFirstName?: string | null, driverLastName?: string | null, generatedAt?: Date | null, fileId?: string | null, vehicleRegistrationNumber?: string | null, source?: string | null, reason?: TachoRemoteReadReasonType | null, driverCard?: { __typename?: 'DriverCard', number?: string | null, countryCode?: number | null, countryCodeLabel?: string | null } | null, warnings?: Array<{ __typename?: 'TachoRemoteWarningType', code?: TachoRemoteWarningCodeType | null, meta?: Array<{ __typename?: 'KeyValueType', key?: string | null, value?: string | null } | null> | null } | null> | null } | null> | null } | null } | null } | null } | null };

export type TachographsReadingsHistoryQueryVariables = Exact<{
  filters?: InputMaybe<TachoRemoteTachographReadFiltersInputType>;
  pagination: PaginationContextInputType;
  sorting?: InputMaybe<Array<InputMaybe<TachoRemoteTachographReadSortingItemInputType>> | InputMaybe<TachoRemoteTachographReadSortingItemInputType>>;
}>;


export type TachographsReadingsHistoryQuery = { __typename?: 'Query', me?: { __typename?: 'Me', tachoRemote?: { __typename?: 'TachoRemoteType', tachograph?: { __typename?: 'TachoRemoteTachographType', reads?: { __typename?: 'TachoRemoteTachographReadsResultType', matched?: Array<string | null> | null, meta?: { __typename?: 'PaginationResultType', page?: number | null, pageSize?: number | null, pageCount?: number | null, itemsCount?: number | null } | null, data?: Array<{ __typename?: 'TachoRemoteTachographReadType', id?: string | null, vehicleRegistrationNumber?: string | null, vehicleName?: string | null, generatedAt?: Date | null, source?: string | null, readFrom?: any | null, readTo?: any | null, reason?: TachoRemoteReadReasonType | null, warnings?: Array<{ __typename?: 'TachoRemoteWarningType', code?: TachoRemoteWarningCodeType | null, meta?: Array<{ __typename?: 'KeyValueType', key?: string | null, value?: string | null } | null> | null } | null> | null } | null> | null } | null } | null } | null } | null };

export type SuspendTachographReadingsMutationVariables = Exact<{
  payload: TachoRemoteSuspendReadsInputType;
}>;


export type SuspendTachographReadingsMutation = { __typename?: 'Mutation', tachoRemote?: { __typename?: 'TachoRemoteMutationType', tachographRead?: { __typename?: 'TachoRemoteTachographMutationType', suspendReads?: { __typename?: 'TachoRemoteSuspendReadsMutationType', messages?: Array<{ __typename?: 'TachoRemoteActionMessageMutationType', code?: number | null, id?: string | null, fullName?: string | null, message?: string | null } | null> | null } | null } | null } | null };

export type TachographAdditionalReadingsMutationVariables = Exact<{
  payload: TachoRemoteVehicleScheduleAdditionalReadOrderInputType;
}>;


export type TachographAdditionalReadingsMutation = { __typename?: 'Mutation', tachoRemote?: { __typename?: 'TachoRemoteMutationType', tachographRead?: { __typename?: 'TachoRemoteTachographMutationType', additionalReads?: { __typename?: 'TachoRemoteTachographReadAdditionalReadOrdersMutationType', messages?: Array<{ __typename?: 'TachoRemoteActionMessageMutationType', code?: number | null, id?: string | null, message?: string | null, fullName?: string | null } | null> | null } | null } | null } | null };

export type TachographReadingsMetaQueryVariables = Exact<{ [key: string]: never; }>;


export type TachographReadingsMetaQuery = { __typename?: 'Query', me?: { __typename?: 'Me', tachoRemote?: { __typename?: 'TachoRemoteType', tachograph?: { __typename?: 'TachoRemoteTachographType', meta?: { __typename?: 'TachoRemoteTachographMetaType', suspendedCount?: number | null } | null } | null } | null } | null };

export type TachographReadingsQueryVariables = Exact<{
  pagination: PaginationContextInputType;
  sorting?: InputMaybe<Array<InputMaybe<TachoRemoteTachographReadStatusSortingItemInputType>> | InputMaybe<TachoRemoteTachographReadStatusSortingItemInputType>>;
  filters?: InputMaybe<TachoRemoteTachographReadStatusFiltersInputType>;
}>;


export type TachographReadingsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', tachoRemote?: { __typename?: 'TachoRemoteType', tachograph?: { __typename?: 'TachoRemoteTachographType', statuses?: { __typename?: 'TachoRemoteTachographReadStatusesResultType', matched?: Array<string | null> | null, meta?: { __typename?: 'PaginationResultType', page?: number | null, pageSize?: number | null, pageCount?: number | null, itemsCount?: number | null } | null, data?: Array<{ __typename?: 'TachoRemoteTachographReadStatusType', id?: string | null, name?: string | null, registrationNumber?: string | null, lastContact?: Date | null, additionalReadOrdersCount?: number | null, suspended?: boolean | null, lastRead?: { __typename?: 'TachoRemoteTachographReadLastReadType', date?: Date | null, from?: any | null, to?: any | null, status?: TachoRemoteReadStatusType | null, delayStatus?: TachoRemoteLastReadDelayStatusType | null, type?: TachoRemoteReadReasonType | null } | null, nextRead?: { __typename?: 'TachoRemoteTachographReadNextReadType', date?: any | null, type?: TachoRemoteReadReasonType | null } | null, warnings?: Array<{ __typename?: 'TachoRemoteWarningType', code?: TachoRemoteWarningCodeType | null, meta?: Array<{ __typename?: 'KeyValueType', key?: string | null, value?: string | null } | null> | null } | null> | null } | null> | null } | null } | null } | null } | null };

export type UnsuspendTachographReadingsMutationVariables = Exact<{
  payload: TachoRemoteUnsuspendReadsInputType;
}>;


export type UnsuspendTachographReadingsMutation = { __typename?: 'Mutation', tachoRemote?: { __typename?: 'TachoRemoteMutationType', tachographRead?: { __typename?: 'TachoRemoteTachographMutationType', unsuspendReads?: { __typename?: 'TachoRemoteUnsuspendReadsMutationType', messages?: Array<{ __typename?: 'TachoRemoteActionMessageMutationType', code?: number | null, id?: string | null, fullName?: string | null, message?: string | null } | null> | null } | null } | null } | null };

export type DriversListQueryVariables = Exact<{
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DriversListQuery = { __typename?: 'Query', me?: { __typename?: 'Me', drivers?: Array<{ __typename?: 'Driver', id?: number | null, firstName?: string | null, lastName?: string | null, isActive?: boolean | null, uuid?: string | null, driverIdentificationNumber?: string | null, workNumber?: string | null, username?: string | null, pin?: number | null, clientId?: number | null, applicationLinkStatus?: DriverApplicationLinkStatus | null, phone?: { __typename?: 'DriverPhone', number?: string | null, prefix?: string | null } | null, driverCard?: { __typename?: 'DriverCard', number?: string | null, countryCode?: number | null } | null } | null> | null } | null };

export type EcoDrivingGroupsListQueryVariables = Exact<{ [key: string]: never; }>;


export type EcoDrivingGroupsListQuery = { __typename?: 'Query', me?: { __typename?: 'Me', ecoDriving?: { __typename?: 'EcoDrivingType', vehiclesGroups?: Array<{ __typename?: 'EcoDrivingVehicleGroupType', id?: number | null, fuelUsageNorm?: number | null, maxAllowedSpeed?: number | null, maxRPM?: number | null, minRPM?: number | null, vehiclesIds?: Array<number | null> | null, name?: string | null } | null> | null } | null } | null };

export type EcoDrivingQueryVariables = Exact<{
  clientId: Scalars['Int']['input'];
  driverId?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  driverIdentification: Scalars['String']['input'];
}>;


export type EcoDrivingQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id?: number | null, settings?: { __typename?: 'Settings', ecoDriving?: { __typename?: 'DeprecatedEcoDrivingSettings', fuelUsageNorm?: number | null, minRPM?: number | null, maxRPM?: number | null, maxAllowedSpeed?: number | null } | null } | null, ecoDriving?: { __typename?: 'EcoDrivingType', statistics?: { __typename?: 'EcoDrivingCompanyStatisticsType', avgFuelConsumption?: number | null, totalFuelConsumption?: number | null, rpmDistribution?: { __typename?: 'RPMDistribution', inNorm?: number | null } | null } | null } | null, drivers?: Array<{ __typename?: 'Driver', ecoDriving?: { __typename?: 'EcoDrivingDriverStatistics', totalFuelConsumption?: number | null, totalDistance?: number | null, avgFuelConsumption?: number | null, avgRPM?: number | null, avgSpeed?: number | null, fuelSaving?: number | null, totalSpeedExceeds?: number | null, totalAcceleratePressed?: { __typename?: 'AcceleratePress', distance?: number | null, duration?: number | null, percent?: number | null } | null, totalAccelerateReleased?: { __typename?: 'AcceleratePress', distance?: number | null, duration?: number | null, percent?: number | null } | null, totalStopOnEngine?: { __typename?: 'StopOnEngine', duration?: number | null, percent?: number | null } | null, totalCruiseControl?: { __typename?: 'CruiseControl', distance?: number | null, duration?: number | null, percent?: number | null } | null, totalAccelerateUnknown?: { __typename?: 'AcceleratePress', distance?: number | null, duration?: number | null, percent?: number | null } | null, dailyData?: Array<{ __typename?: 'DailyData', date?: any | null, fuelConsumption?: number | null, distance?: number | null, avgFuelConsumption?: number | null, avgRPM?: number | null, avgSpeed?: number | null, speedExceeds?: number | null, accelerateUnknown?: { __typename?: 'AcceleratePress', distance?: number | null, duration?: number | null, percent?: number | null } | null, acceleratePressed?: { __typename?: 'AcceleratePress', distance?: number | null, duration?: number | null, percent?: number | null } | null, accelerateReleased?: { __typename?: 'AcceleratePress', distance?: number | null, duration?: number | null, percent?: number | null } | null, stopOnEngine?: { __typename?: 'StopOnEngine', duration?: number | null, percent?: number | null } | null, cruiseControl?: { __typename?: 'CruiseControl', distance?: number | null, duration?: number | null, percent?: number | null } | null } | null> | null, rpmDistribution?: { __typename?: 'RPMDistribution', inNorm?: number | null, aboveNorm?: number | null, belowNorm?: number | null } | null, vehicleData?: Array<{ __typename?: 'VehicleData', vehicleId?: number | null, avgFuelConsumption?: number | null, distance?: number | null, vehicle?: { __typename?: 'Vehicle', registrationNumber?: string | null } | null, dateRanges?: Array<{ __typename?: 'DateRangeData', from?: any | null, to?: any | null } | null> | null } | null> | null } | null } | null> | null } | null };

export type AttachVehiclesToVehiclesGroupMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  payload: EcoDrivingAttachVehiclesToVehiclesGroupInputType;
}>;


export type AttachVehiclesToVehiclesGroupMutation = { __typename?: 'Mutation', ecoDriving?: { __typename?: 'EcoDrivingMutationType', attachVehiclesToVehiclesGroup?: { __typename?: 'EcoDrivingAttachVehiclesToVehiclesGroupMutationType', vehiclesIds: Array<number | null> } | null } | null };

export type CompanyEcoDrivingQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type CompanyEcoDrivingQuery = { __typename?: 'Query', me?: { __typename?: 'Me', ecoDriving?: { __typename?: 'EcoDrivingType', statistics?: { __typename?: 'EcoDrivingCompanyStatisticsType', monthlyData?: Array<{ __typename?: 'EcoDrivingCompanyMonthlyDataType', avgFuelConsumption?: number | null, date?: any | null, distance?: number | null, fuelConsumption?: number | null } | null> | null } | null } | null } | null };

export type CreateVehicleGroupMutationVariables = Exact<{
  params: EcoDrivingCreateVehiclesGroupInputType;
}>;


export type CreateVehicleGroupMutation = { __typename?: 'Mutation', ecoDriving?: { __typename?: 'EcoDrivingMutationType', createVehiclesGroup?: { __typename?: 'EcoDrivingCreateVehiclesGroupMutationType', id?: number | null, name?: string | null, vehiclesIds?: Array<number | null> | null, fuelUsageNorm?: number | null, maxAllowedSpeed?: number | null, maxRPM?: number | null, minRPM?: number | null, tractorWeight?: number | null, stepFuelConsumptionPerTon?: number | null, fuelUsageNormForEmpty?: number | null } | null } | null };

export type DeleteVehicleGroupMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteVehicleGroupMutation = { __typename?: 'Mutation', ecoDriving?: { __typename?: 'EcoDrivingMutationType', deleteVehiclesGroup?: { __typename?: 'EcoDrivingDeleteVehiclesGroupMutationType', id?: number | null } | null } | null };

export type DetachVehiclesFromVehiclesGroupMutationVariables = Exact<{
  payload: EcoDrivingDetachVehiclesToVehiclesGroupInputType;
}>;


export type DetachVehiclesFromVehiclesGroupMutation = { __typename?: 'Mutation', ecoDriving?: { __typename?: 'EcoDrivingMutationType', detachVehiclesFromVehiclesGroup?: { __typename?: 'EcoDrivingDetachVehiclesToVehiclesGroupMutationType', vehiclesIds: Array<number | null> } | null } | null };

export type DriversRankingQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  parameters?: InputMaybe<EcoDrivingDriverRankingParametersType>;
}>;


export type DriversRankingQuery = { __typename?: 'Query', me?: { __typename?: 'Me', ecoDriving?: { __typename?: 'EcoDrivingType', driversRanking?: Array<{ __typename?: 'EcoDrivingDriverRankingType', driverIdentification?: string | null, fuelSaving?: number | null, avgFuelConsumption?: number | null, distance?: number | null, grade?: number | null, vehicles?: Array<{ __typename?: 'DriverVehicleInfo', boxId?: number | null, registerNumber?: string | null } | null> | null, cruiseControl?: { __typename?: 'CruiseControl', percent?: number | null } | null, loadPart?: { __typename?: 'LoadPart', avgTotalLoad?: number | null, avgAxleLoad?: number | null } | null, driver?: { __typename?: 'Driver', firstName?: string | null, lastName?: string | null, uuid?: string | null, isActive?: boolean | null } | null } | null> | null } | null } | null };

export type EcoDrivingGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type EcoDrivingGroupsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', ecoDriving?: { __typename?: 'EcoDrivingType', vehiclesGroups?: Array<{ __typename?: 'EcoDrivingVehicleGroupType', id?: number | null, name?: string | null, vehiclesIds?: Array<number | null> | null, fuelUsageNorm?: number | null, maxAllowedSpeed?: number | null, maxRPM?: number | null, minRPM?: number | null, tractorWeight?: number | null, stepFuelConsumptionPerTon?: number | null, fuelUsageNormForEmpty?: number | null } | null> | null, settings?: { __typename?: 'EcoDrivingSettingsType', fuelUsageNorm?: number | null, maxAllowedSpeed?: number | null, maxRPM?: number | null, minRPM?: number | null, tractorWeight?: number | null, stepFuelConsumptionPerTon?: number | null, fuelUsageNormForEmpty?: number | null } | null } | null, vehicles?: Array<{ __typename?: 'Vehicle', id?: number | null, model?: string | null, yearOfProduction?: number | null, brand?: string | null, name?: string | null, registrationNumber?: string | null, ecoDrivingGroup?: { __typename?: 'EcoDrivingGroup', id?: number | null, name?: string | null } | null } | null> | null } | null };

export type EcoDrivingSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type EcoDrivingSettingsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', ecoDriving?: { __typename?: 'EcoDrivingType', settings?: { __typename?: 'EcoDrivingSettingsType', fuelUsageNorm?: number | null, maxAllowedSpeed?: number | null, maxRPM?: number | null, minRPM?: number | null } | null } | null } | null };

export type UpdateSettingsMutationVariables = Exact<{
  payload: EcoDrivingUpdateSettingsInputType;
}>;


export type UpdateSettingsMutation = { __typename?: 'Mutation', ecoDriving?: { __typename?: 'EcoDrivingMutationType', updateSettings?: { __typename?: 'EcoDrivingUpdateSettingsMutationType', fuelUsageNorm?: number | null, maxAllowedSpeed?: number | null, minRPM?: number | null, maxRPM?: number | null } | null } | null };

export type UpdateVehiclesGroupMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  payload: EcoDrivingUpdateVehiclesGroupInputType;
}>;


export type UpdateVehiclesGroupMutation = { __typename?: 'Mutation', ecoDriving?: { __typename?: 'EcoDrivingMutationType', updateVehiclesGroup?: { __typename?: 'EcoDrivingUpdateVehiclesGroupMutationType', id?: number | null, clientId?: number | null, name?: string | null, vehiclesIds?: Array<number | null> | null, fuelUsageNorm?: number | null, minRPM?: number | null, maxRPM?: number | null, maxAllowedSpeed?: number | null, fuelUsageNormForEmpty?: number | null, stepFuelConsumptionPerTon?: number | null, tractorWeight?: number | null } | null } | null };

export type CreateGboxAuthorizationAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateGboxAuthorizationAccountMutation = { __typename?: 'Mutation', gboxAuthorizationAccount?: { __typename?: 'GboxAuthorizationAccountMutationType', create?: { __typename?: 'CreateGboxAuthorizationAccountMutationType', id?: number | null, login?: string | null, password?: string | null, type?: string | null } | null } | null };

export type GboxAuthorizationAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GboxAuthorizationAccountQuery = { __typename?: 'Query', me?: { __typename?: 'Me', apiAccounts?: { __typename?: 'ApiAccounts', gboxAuthorization?: { __typename?: 'GboxAuthorizationAccount', id?: number | null, login?: string | null, type?: string | null } | null } | null } | null };

export type ResetGboxAuthorizationAccountPasswordMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetGboxAuthorizationAccountPasswordMutation = { __typename?: 'Mutation', gboxAuthorizationAccount?: { __typename?: 'GboxAuthorizationAccountMutationType', resetPassword?: { __typename?: 'ResetGboxAuthorizationAccountPasswordMutationType', id?: number | null, login?: string | null, password?: string | null, type?: string | null } | null } | null };

export type CompanyApiAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyApiAccountsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', apiAccounts?: { __typename?: 'ApiAccounts', partner?: { __typename?: 'PartnerAccount', id?: number | null, login?: string | null, type?: string | null } | null } | null } | null };

export type CreatePartnerAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type CreatePartnerAccountMutation = { __typename?: 'Mutation', partnerAccount?: { __typename?: 'PartnerAccountMutationType', create?: { __typename?: 'CreatePartnerAccountMutationType', id?: number | null, login?: string | null, password?: string | null, type?: string | null } | null } | null };

export type ResetPartnerAccountPasswordMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetPartnerAccountPasswordMutation = { __typename?: 'Mutation', partnerAccount?: { __typename?: 'PartnerAccountMutationType', resetPassword?: { __typename?: 'ResetPartnerAccountPasswordMutationType', id?: number | null, login?: string | null, password?: string | null, type?: string | null } | null } | null };

export type TaskDetailsQueryVariables = Exact<{
  taskId: Scalars['String']['input'];
}>;


export type TaskDetailsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', tasks?: Array<{ __typename?: 'Task', id?: string | null, finishNote?: string | null, note?: string | null, arriveTimeEnd?: Date | null, target?: { __typename?: 'TargetType', address?: string | null } | null, eta?: { __typename?: 'Eta', createdAt?: Date | null, arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null, distance?: { __typename?: 'EtaDistance', total?: number | null, left?: number | null } | null } | null, attachments?: Array<{ __typename?: 'TaskAttachment', id?: string | null, filename?: string | null } | null> | null, driver?: { __typename?: 'Driver', id?: number | null, vehicle?: { __typename?: 'Vehicle', id?: number | null } | null } | null } | null> | null } | null };

export type TaskListItemFragmentFragment = { __typename?: 'Task', id?: string | null, name?: string | null, status?: TaskStatus | null, arriveTimeEnd?: Date | null, driver?: { __typename?: 'Driver', id?: number | null, firstName?: string | null, lastName?: string | null } | null, eta?: { __typename?: 'Eta', arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null, distance?: { __typename?: 'EtaDistance', total?: number | null, left?: number | null } | null } | null };

export type TaskListQueryVariables = Exact<{ [key: string]: never; }>;


export type TaskListQuery = { __typename?: 'Query', me?: { __typename?: 'Me', tasks?: Array<{ __typename?: 'Task', id?: string | null, name?: string | null, status?: TaskStatus | null, arriveTimeEnd?: Date | null, driver?: { __typename?: 'Driver', id?: number | null, firstName?: string | null, lastName?: string | null } | null, eta?: { __typename?: 'Eta', arrival?: { __typename?: 'EtaArrival', withWorkTime?: Date | null } | null, distance?: { __typename?: 'EtaDistance', total?: number | null, left?: number | null } | null } | null } | null> | null } | null };

export type TachoRemoteStatusInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type TachoRemoteStatusInfoQuery = { __typename?: 'Query', me?: { __typename?: 'Me', tachoRemote?: { __typename?: 'TachoRemoteType', status?: { __typename?: 'TachoRemoteStatusType', state?: TachoRemoteStatusStateType | null } | null } | null } | null };

export const MapContextEtaMonitorFieldsFragmentDoc = gql`
    fragment mapContextEtaMonitorFields on EtaMonitor {
  etaTimeStatus @client
  sourceId @client
  isExceeded @client
  isOk @client
  isEndangered @client
  isUnknown @client
  isEtaLightSource @client
  isOrderTaskSource @client
  isCalculated @client
  isCanceled @client
}
    `;
export const MapContextActiveEtaLightTaskFragmentFragmentDoc = gql`
    fragment mapContextActiveETALightTaskFragment on EtaLightTask {
  plannedArrivalTime
  vehicleId
  createdAt
  updateAt
  status
  cancelReason
  target {
    address
    coords {
      lat
      lng
    }
  }
  eta {
    status
    distance {
      left
    }
    arrival {
      withWorkTime
    }
    restsTaken {
      startedAt
      questionable
      period
    }
  }
}
    `;
export const MapContextActiveOrderTaskFragmentFragmentDoc = gql`
    fragment mapContextActiveOrderTaskFragment on OrderTask {
  arriveTimeEnd
  createdAt
  order {
    vehicleId
    vehicle {
      id
    }
  }
  target {
    address
    coords {
      lat
      lng
    }
  }
  eta {
    status
    distance {
      left
    }
    arrival {
      withWorkTime
    }
    restsTaken {
      startedAt
      questionable
      period
    }
  }
}
    `;
export const OpenedEtaMonitorFragmentDoc = gql`
    fragment openedEtaMonitor on EtaMonitorTask {
  ... on EtaMonitor {
    ...mapContextEtaMonitorFields
  }
  ... on EtaLightTask {
    id
    ...mapContextActiveETALightTaskFragment
  }
  ... on OrderTask {
    Id: id
    ...mapContextActiveOrderTaskFragment
  }
}
    ${MapContextEtaMonitorFieldsFragmentDoc}
${MapContextActiveEtaLightTaskFragmentFragmentDoc}
${MapContextActiveOrderTaskFragmentFragmentDoc}`;
export const DriverVehicleDetailsFragmentFragmentDoc = gql`
    fragment driverVehicleDetailsFragment on Driver {
  id
  uuid
  driverIdentificationNumber
  firstName
  lastName
  driverCard {
    countryCode
    number
  }
  driverState @client
  isAuthorized @client
  fullName @client
  identificationId @client
}
    `;
export const OnVehicleCurrentFragmentFragmentDoc = gql`
    fragment onVehicleCurrentFragment on VehicleCurrentType {
  lastSignal
  engineOn
  press
  ride
  stopOnIgnitionDuration
  totalLoad
  speed
  gps {
    address
    lat
    lng
    directionAngle
  }
  fuel {
    tank1
    tank2
    total
  }
  batteryVoltage
}
    `;
export const VehicleExtendedCurrentFragmentFragmentDoc = gql`
    fragment vehicleExtendedCurrentFragment on VehicleExtended {
  current {
    ...onVehicleCurrentFragment
  }
}
    ${OnVehicleCurrentFragmentFragmentDoc}`;
export const VehicleCurrentFragmentFragmentDoc = gql`
    fragment vehicleCurrentFragment on Vehicle {
  current {
    ...onVehicleCurrentFragment
  }
}
    ${OnVehicleCurrentFragmentFragmentDoc}`;
export const VehicleMapContextFragmentFragmentDoc = gql`
    fragment vehicleMapContextFragment on Vehicle {
  id
  boxId
  name
  registrationNumber
  label @client
  fleetTypes @client
  driverCardReadingSource
  workingTimeSource
  type
  kind
  hasWorkingTimeSource @client
  hasAuthorizedDrivers @client
  isTrailer @client
  hasEtaLightMonitors @client
  isBig @client
  drivers {
    __typename
    ... on Driver {
      __typename
      id
      uuid
      driverIdentificationNumber
      firstName
      lastName
      driverCard {
        countryCode
        number
      }
      fullName @client
      driverState @client
    }
    ... on DriverUnknown {
      __typename
      driverCardNumber
      driverState @client
    }
  }
  identifiedDrivers @client {
    id
    firstName
    lastName
  }
  groups {
    id
    color
  }
  defaultGroup @client {
    id
    color
    hexColor @client
    hexInvertedColor @client
  }
  appearance {
    dynamicIcon
    iconId
    registrationNumberAsName
  }
  devices {
    model
    communicationStatus
  }
  assistDevice @client {
    model
    communicationStatus
    isOffline @client
  }
  hasOBU @client
  hasAssist @client
  etaLightTasks @client {
    id
    ...mapContextActiveETALightTaskFragment
  }
  etaOrderTasks @client {
    id
    ...mapContextActiveOrderTaskFragment
  }
  currentEtaMonitors @client {
    ... on EtaLightTask {
      id
      ...mapContextActiveETALightTaskFragment
      ...mapContextEtaMonitorFields
    }
    ... on OrderTask {
      Id: id
      ...mapContextActiveOrderTaskFragment
      ...mapContextEtaMonitorFields
    }
  }
  ...vehicleCurrentFragment
}
    ${MapContextActiveEtaLightTaskFragmentFragmentDoc}
${MapContextActiveOrderTaskFragmentFragmentDoc}
${MapContextEtaMonitorFieldsFragmentDoc}
${VehicleCurrentFragmentFragmentDoc}`;
export const WorkingTimeDriverUnknownFragmentDoc = gql`
    fragment workingTimeDriverUnknown on DriverUnknown {
  driverState @client
  identificationId @client
  driverCardNumber
}
    `;
export const TaskListItemFragmentFragmentDoc = gql`
    fragment taskListItemFragment on Task {
  id
  name
  status
  arriveTimeEnd
  driver {
    id
    firstName
    lastName
  }
  eta {
    arrival {
      withWorkTime
    }
    distance {
      total
      left
    }
  }
}
    `;
export const ClientDocument = gql`
    query client {
  me {
    id
    name
    isInternal
    isJoint
    featureFlags {
      batteryVoltage
      tachoRemote
    }
    settings {
      legacy {
        hasAssist
        licencePlan
        fleetType
      }
      system {
        legacyAssist {
          enabled
        }
        legacyAlerts {
          enabled
        }
        legacyReports {
          enabled
        }
        tachoRemote {
          enabled
        }
        tachoRemote2 {
          enabled
          configured
          launched
          migrated
        }
        legacyTemporaryLinks {
          enabled
        }
        ecoDriving {
          enabled
          cruiseControl
          groups
          pdfExport
          ranking
          retarder
          tonnage
        }
        legacyHistory {
          enabled
          availabilityTime
        }
        etaLight {
          enabled
          vehicles
        }
        orders {
          enabled
          eta
          etaVehicles
          deprecated
          archived
          calendar
          archivePermissions
        }
        workTime {
          enabled
        }
        tasks {
          enabled
        }
        driverApp {
          enabled
        }
        apiAccounts {
          enabled
          partner
        }
        etoll {
          enabled
        }
        mobilityPackage {
          enabled
          foreignWage
        }
        fireTms {
          enabled
        }
        fleet {
          hasAssist
          type
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClientGQL extends Apollo.Query<ClientQuery, ClientQueryVariables> {
    document = ClientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MapContextCancelEtaLightTaskDocument = gql`
    mutation mapContextCancelEtaLightTask($id: Int!) {
  etaLightTask {
    cancel(id: $id) {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MapContextCancelEtaLightTaskGQL extends Apollo.Mutation<MapContextCancelEtaLightTaskMutation, MapContextCancelEtaLightTaskMutationVariables> {
    document = MapContextCancelEtaLightTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MapContextEtaTasksDocument = gql`
    query MapContextEtaTasks($includeOrderTasks: Boolean!, $includeEtaLightTasks: Boolean!) {
  me {
    orderTasks(status: STARTED) @include(if: $includeOrderTasks) {
      id
      ...mapContextActiveOrderTaskFragment
    }
    etaLightTasks(statuses: [NEW, IN_PROGRESS, CANCELLED]) @include(if: $includeEtaLightTasks) {
      id
      ...mapContextActiveETALightTaskFragment
    }
  }
}
    ${MapContextActiveOrderTaskFragmentFragmentDoc}
${MapContextActiveEtaLightTaskFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MapContextEtaTasksGQL extends Apollo.Query<MapContextEtaTasksQuery, MapContextEtaTasksQueryVariables> {
    document = MapContextEtaTasksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IncidentsListDocument = gql`
    query incidentsList {
  mapModuleIncidentsList @rest(path: "/trafficCongestion", endpoint: "core", type: "MapModuleIncidentsListResponse") {
    trafficCongestion @type(name: "Incident") {
      geoLat
      geoLong
      roadLabel: nrDrogi
      description: objazd
      incidentType: rodzaj {
        id: poz
      }
      position @client
      type @client
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IncidentsListGQL extends Apollo.Query<IncidentsListQuery, IncidentsListQueryVariables> {
    document = IncidentsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MapSelectedVehicleDetailsDocument = gql`
    query mapSelectedVehicleDetails($vehicleId: Int!) {
  me {
    vehicle(id: $vehicleId) {
      id
      boxId
      name
      registrationNumber
      type
      kind
      label @client
      driverCardReadingSource
      isTrailer @client
      hasEtaLightMonitors @client
      devices {
        model
        communicationStatus
        imei
      }
      drivers {
        ... on Driver {
          ...driverVehicleDetailsFragment
        }
        ... on DriverUnknown {
          driverCardNumber
          driverState @client
          isAuthorized @client
        }
      }
      authorizedDrivers @client {
        ... on Driver {
          ...driverVehicleDetailsFragment
        }
        ... on DriverUnknown {
          driverCardNumber
          identificationId @client
        }
      }
      currentDriver @client {
        ... on Driver {
          ...driverVehicleDetailsFragment
        }
        ... on DriverUnknown {
          driverCardNumber
          isAuthorized @client
        }
      }
      hasOBU @client
      hasAssist @client
      hasAuthorizedDrivers @client
      workingTimeSource
      hasWorkingTimeSource @client
      driverStatus {
        name
        date
      }
      fuelTanks {
        tank1 {
          capacity
        }
        tank2 {
          capacity
        }
      }
      assistDevice @client {
        model
        communicationStatus
        isOffline @client
        imei
      }
      profile @client {
        id
        name
        width
        height
        length
        grossWeight
        axleLoad
      }
      current {
        ...onVehicleCurrentFragment
      }
    }
  }
}
    ${DriverVehicleDetailsFragmentFragmentDoc}
${OnVehicleCurrentFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MapSelectedVehicleDetailsGQL extends Apollo.Query<MapSelectedVehicleDetailsQuery, MapSelectedVehicleDetailsQueryVariables> {
    document = MapSelectedVehicleDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MapSettingsDocument = gql`
    query mapSettings($userId: Int!, $settingsId: Int!) {
  mapModuleUserSettings(userId: $userId, settingsId: $settingsId) @rest(path: "/users/{args.userId}/settings/{args.settingsId}", endpoint: "auth", type: "MapModuleUserSettings") {
    userSettings @type(name: "UserSettings") {
      list @type(name: "MapModuleUserSettingsList") {
        vehicleDetails @type(name: "MapModuleUserSettingsListVehicleDetails") {
          address
          currentEtaMonitor
          driverName
        }
        vehicleInfo @type(name: "MapModuleUserSettingsListVehicleInfo") {
          fuel
          speed
          totalLoad
          batteryVoltage
        }
        vehicleTitle @type(name: "MapModuleUserSettingsListVehicleTitle") {
          name
          registration
        }
      }
    }
  }
  mapModuleClientSettings @rest(path: "/client/configuration", endpoint: "core", type: "MapModuleClientSettingsResponse") {
    configuration @type(name: "MapModuleClientSettings") {
      hiSpeedBig
      hiSpeedSmall
      layingLabels
      lowSpeedBig
      lowSpeedSmall
      showDrivingDirection: rosaVentorum
      showStopAfter
      labelBackgroundColorTransparentize: transparentLblBgColor
      unifyLabelsColor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MapSettingsGQL extends Apollo.Query<MapSettingsQuery, MapSettingsQueryVariables> {
    document = MapSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserPointGroupsDocument = gql`
    query userPointGroups {
  mapModuleUserPointGroups @rest(path: "/userPointGroups?noEmpty=true", endpoint: "core", type: "MapModuleUserPointGroupsResponse") {
    userPointGroups @type(name: "UserPointGroup") {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserPointGroupsGQL extends Apollo.Query<UserPointGroupsQuery, UserPointGroupsQueryVariables> {
    document = UserPointGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserPointsDocument = gql`
    query userPoints($groupId: Int!) {
  mapModuleUserPoints(groupId: $groupId) @rest(path: "/userPointGroups/{args.groupId}?include=userPoints", endpoint: "core", type: "MapModuleUserPointsResponse") {
    userPointGroup @type(name: "UserPointGroup") {
      id
      name
      userPoints @type(name: "UserPoint") {
        name
        address
        filePath: filepath
        iconName @client
        position {
          latitude
          longitude
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserPointsGQL extends Apollo.Query<UserPointsQuery, UserPointsQueryVariables> {
    document = UserPointsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserPointDocument = gql`
    mutation createUserPoint($createUserPointInput: MapModuleUserPointCreateInputType!) {
  mapModuleUserPoints(input: $createUserPointInput) @rest(type: "NullResponse", path: "/userPoint", method: "POST", bodyKey: "input", endpoint: "core") {
    content
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserPointGQL extends Apollo.Mutation<CreateUserPointMutation, CreateUserPointMutationVariables> {
    document = CreateUserPointDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserSettingsDocument = gql`
    mutation updateUserSettings($userId: Int!, $settingsId: Int!, $settings: MapModuleUserSettingsInputType!) {
  mapModuleSettings(userId: $userId, settings: $settings, settingsId: $settingsId) @rest(type: "NullResponse", path: "/users/{args.userId}/settings/{args.settingsId}", method: "PUT", bodyKey: "settings", endpoint: "auth") {
    content
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserSettingsGQL extends Apollo.Mutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables> {
    document = UpdateUserSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VehicleProfileQueryDocument = gql`
    query vehicleProfileQuery($clientId: Int!) {
  client(id: $clientId) {
    vehicleTypes {
      id
      name
      grossWeight
      length
      height
      width
      axleLoad
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VehicleProfileQueryGQL extends Apollo.Query<VehicleProfileQueryQuery, VehicleProfileQueryQueryVariables> {
    document = VehicleProfileQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MapVehiclesGroupsDocument = gql`
    query mapVehiclesGroups {
  me {
    vehiclesGroups {
      id
      name
      color
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MapVehiclesGroupsGQL extends Apollo.Query<MapVehiclesGroupsQuery, MapVehiclesGroupsQueryVariables> {
    document = MapVehiclesGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MapVehiclesListFullDocument = gql`
    query mapVehiclesListFull {
  me {
    vehicles {
      ...vehicleMapContextFragment
    }
  }
}
    ${VehicleMapContextFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MapVehiclesListFullGQL extends Apollo.Query<MapVehiclesListFullQuery, MapVehiclesListFullQueryVariables> {
    document = MapVehiclesListFullDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WorkingTimeDriverDocument = gql`
    query workingTimeDriver($driverId: String!) {
  me {
    drivers(id: $driverId) {
      id
      lastName
      firstName
      fullName @client
      driverState @client
      identificationId @client
      driverIdentificationNumber
      driverCard {
        countryCode
        number
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WorkingTimeDriverGQL extends Apollo.Query<WorkingTimeDriverQuery, WorkingTimeDriverQueryVariables> {
    document = WorkingTimeDriverDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEtaLightTaskDocument = gql`
    mutation createEtaLightTask($params: CreateEtaLightTaskInput!) {
  etaLightTask {
    create(payload: $params) {
      id
      plannedArrivalTime
      vehicleId
      createdAt
      updateAt
      status
      target {
        address
        coords {
          lat
          lng
        }
      }
      eta {
        distance {
          left
        }
        arrival {
          withWorkTime
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEtaLightTaskGQL extends Apollo.Mutation<CreateEtaLightTaskMutation, CreateEtaLightTaskMutationVariables> {
    document = CreateEtaLightTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EtaLightVehicleLimitDocument = gql`
    query etaLightVehicleLimit($vehicleId: [Int]!) {
  me {
    etaLight {
      usage(vehicleId: $vehicleId) {
        vehicleId
        count
        monthlyLimit
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EtaLightVehicleLimitGQL extends Apollo.Query<EtaLightVehicleLimitQuery, EtaLightVehicleLimitQueryVariables> {
    document = EtaLightVehicleLimitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DevicesListDocument = gql`
    query devicesList {
  me {
    customerArea {
      contracts {
        data {
          vehicleId
          registrationNumber
          state
          type
          licence {
            name
            amount
            currency
          }
          features
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DevicesListGQL extends Apollo.Query<DevicesListQuery, DevicesListQueryVariables> {
    document = DevicesListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerAreaPaymentsDocument = gql`
    query CustomerAreaPayments($since: Date!) {
  me {
    customerArea {
      payments(since: $since) {
        number
        date
        term
        amount {
          net
          gross
          currency
        }
        status
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerAreaPaymentsGQL extends Apollo.Query<CustomerAreaPaymentsQuery, CustomerAreaPaymentsQueryVariables> {
    document = CustomerAreaPaymentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignVehiclesToCompanyDocument = gql`
    mutation AssignVehiclesToCompany($id: String!, $payload: TachoRemoteCompanyVehiclesInputType!) {
  tachoRemote {
    company {
      assignVehicles(id: $id, payload: $payload) {
        messages {
          id
          code
          fullName
          message
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignVehiclesToCompanyGQL extends Apollo.Mutation<AssignVehiclesToCompanyMutation, AssignVehiclesToCompanyMutationVariables> {
    document = AssignVehiclesToCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AuthorizationAppsListDocument = gql`
    query authorizationAppsList {
  me {
    tachoRemote {
      authorizationApps {
        data {
          id
          name
          status
          server
          ip
          lastContact
          companyCards {
            name
            countryCode
            countryCodeLabel @client
            number
            serialNo
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AuthorizationAppsListGQL extends Apollo.Query<AuthorizationAppsListQuery, AuthorizationAppsListQueryVariables> {
    document = AuthorizationAppsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyCardUpdateDocument = gql`
    mutation CompanyCardUpdate($payload: TachoRemoteUpdateCompanyCardInputType!, $serialNo: String!) {
  tachoRemote {
    companyCard {
      update(payload: $payload, serialNo: $serialNo) {
        serialNo
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyCardUpdateGQL extends Apollo.Mutation<CompanyCardUpdateMutation, CompanyCardUpdateMutationVariables> {
    document = CompanyCardUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyCardsListDocument = gql`
    query CompanyCardsList($pending: Boolean!) {
  me {
    tachoRemote {
      companyCards(filters: {pending: $pending}) {
        data {
          name
          expireDate
          countryCode
          number
          generation
          configuredAt
          active
          serialNo
          expirationWarning
          status
          countryCodeLabel @client
          companyId
          connection {
            ip
            reader
            server
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyCardsListGQL extends Apollo.Query<CompanyCardsListQuery, CompanyCardsListQueryVariables> {
    document = CompanyCardsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeactivateAuthorizationAppDocument = gql`
    mutation DeactivateAuthorizationApp($appId: String!) {
  tachoRemote {
    authorizationApp {
      deactivateAuthorizationApp(appId: $appId) {
        messages {
          code
          fullName
          id
          message
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeactivateAuthorizationAppGQL extends Apollo.Mutation<DeactivateAuthorizationAppMutation, DeactivateAuthorizationAppMutationVariables> {
    document = DeactivateAuthorizationAppDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DriverCardsReadsFilesDocument = gql`
    query driverCardsReadsFiles($ids: [String!], $source: TachoRemoteFileSourceType!, $range: TachoRemoteFileRangeType!) {
  me {
    tachoRemote {
      files(ids: $ids, source: $source, range: $range) {
        id
        fileId
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DriverCardsReadsFilesGQL extends Apollo.Query<DriverCardsReadsFilesQuery, DriverCardsReadsFilesQueryVariables> {
    document = DriverCardsReadsFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SupportForMultipleCompanyDocument = gql`
    mutation supportForMultipleCompany($enabled: Boolean!) {
  tachoRemote {
    client {
      supportForMultipleCompany(enabled: $enabled) {
        messages {
          message
          id
          fullName
          code
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SupportForMultipleCompanyGQL extends Apollo.Mutation<SupportForMultipleCompanyMutation, SupportForMultipleCompanyMutationVariables> {
    document = SupportForMultipleCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TachoRemoteCompanyCreateDocument = gql`
    mutation TachoRemoteCompanyCreate($payload: TachoRemoteCreateCompanyInputType!) {
  tachoRemote {
    company {
      create(payload: $payload) {
        id
        numberOfVehicles
        name
        companyCardSerialNumbers
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TachoRemoteCompanyCreateGQL extends Apollo.Mutation<TachoRemoteCompanyCreateMutation, TachoRemoteCompanyCreateMutationVariables> {
    document = TachoRemoteCompanyCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TachoRemoteCompanyDeleteDocument = gql`
    mutation TachoRemoteCompanyDelete($id: String!) {
  tachoRemote {
    company {
      delete(id: $id) {
        status
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TachoRemoteCompanyDeleteGQL extends Apollo.Mutation<TachoRemoteCompanyDeleteMutation, TachoRemoteCompanyDeleteMutationVariables> {
    document = TachoRemoteCompanyDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TachoRemoteCompanyUpdateDocument = gql`
    mutation TachoRemoteCompanyUpdate($id: String!, $payload: TachoRemoteUpdateCompanyInputType!) {
  tachoRemote {
    company {
      update(id: $id, payload: $payload) {
        id
        numberOfVehicles
        name
        companyCardSerialNumbers
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TachoRemoteCompanyUpdateGQL extends Apollo.Mutation<TachoRemoteCompanyUpdateMutation, TachoRemoteCompanyUpdateMutationVariables> {
    document = TachoRemoteCompanyUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TachoRemoteCompanyDocument = gql`
    query TachoRemoteCompany {
  me {
    tachoRemote {
      companies {
        data {
          id
          name
          companyCardSerialNumbers
          numberOfVehicles
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TachoRemoteCompanyGQL extends Apollo.Query<TachoRemoteCompanyQuery, TachoRemoteCompanyQueryVariables> {
    document = TachoRemoteCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TachoRemoteStatusDocument = gql`
    query TachoRemoteStatus {
  me {
    tachoRemote {
      status {
        state
        messages {
          code
          target
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TachoRemoteStatusGQL extends Apollo.Query<TachoRemoteStatusQuery, TachoRemoteStatusQueryVariables> {
    document = TachoRemoteStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TachoRemoteVehiclesDocument = gql`
    query TachoRemoteVehicles {
  me {
    tachoRemote {
      vehicles {
        data {
          id
          companyId
          name
          registrationNumber
          companyName @client
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TachoRemoteVehiclesGQL extends Apollo.Query<TachoRemoteVehiclesQuery, TachoRemoteVehiclesQueryVariables> {
    document = TachoRemoteVehiclesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TachoRemoteClientDocument = gql`
    query tachoRemoteClient {
  me {
    tachoRemote {
      client {
        isConfigured
        isEnabled
        numberOfCompanies
        hasSupportForMultipleCompany
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TachoRemoteClientGQL extends Apollo.Query<TachoRemoteClientQuery, TachoRemoteClientQueryVariables> {
    document = TachoRemoteClientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DriverCardAdditionalReadsDocument = gql`
    mutation DriverCardAdditionalReads($payload: TachoRemoteDriverCardReadAdditionalReadOrderInputType!) {
  tachoRemote {
    driverCardRead {
      additionalReads(payload: $payload) {
        messages {
          id
          code
          fullName
          message
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DriverCardAdditionalReadsGQL extends Apollo.Mutation<DriverCardAdditionalReadsMutation, DriverCardAdditionalReadsMutationVariables> {
    document = DriverCardAdditionalReadsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DriverCardReadsMetaDocument = gql`
    query DriverCardReadsMeta {
  me {
    tachoRemote {
      driverCard {
        meta {
          suspendedCount
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DriverCardReadsMetaGQL extends Apollo.Query<DriverCardReadsMetaQuery, DriverCardReadsMetaQueryVariables> {
    document = DriverCardReadsMetaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DriverCardReadsDocument = gql`
    query DriverCardReads($pagination: PaginationContextInputType!, $sorting: [TachoRemoteDriverCardReadStatusSortingItemInputType], $filters: TachoRemoteDriverCardReadStatusFiltersInputType) {
  me {
    tachoRemote {
      driverCard {
        statuses(pagination: $pagination, sorting: $sorting, filters: $filters) {
          meta {
            page
            pageSize
            pageCount
            itemsCount
          }
          data {
            id
            firstName
            lastName
            driverCard {
              number
              countryCode
              countryCodeLabel @client
            }
            lastRead {
              date
              delayStatus
            }
            nextRead {
              date
              type
            }
            lastContact
            warnings {
              code
              meta {
                key
                value
              }
            }
            suspended
          }
          matched
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DriverCardReadsGQL extends Apollo.Query<DriverCardReadsQuery, DriverCardReadsQueryVariables> {
    document = DriverCardReadsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SuspendDriverCardReadsDocument = gql`
    mutation SuspendDriverCardReads($payload: TachoRemoteSuspendReadsInputType!) {
  tachoRemote {
    driverCardRead {
      suspendReads(payload: $payload) {
        messages {
          code
          id
          fullName
          message
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SuspendDriverCardReadsGQL extends Apollo.Mutation<SuspendDriverCardReadsMutation, SuspendDriverCardReadsMutationVariables> {
    document = SuspendDriverCardReadsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnsuspendDriverCardReadsDocument = gql`
    mutation UnsuspendDriverCardReads($payload: TachoRemoteUnsuspendReadsInputType!) {
  tachoRemote {
    driverCardRead {
      unsuspendReads(payload: $payload) {
        messages {
          code
          id
          fullName
          message
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnsuspendDriverCardReadsGQL extends Apollo.Mutation<UnsuspendDriverCardReadsMutation, UnsuspendDriverCardReadsMutationVariables> {
    document = UnsuspendDriverCardReadsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DriverCardsReadingsHistoryDocument = gql`
    query DriverCardsReadingsHistory($filters: TachoRemoteDriverCardReadFiltersInputType, $pagination: PaginationContextInputType!, $sorting: [TachoRemoteDriverCardReadSortingItemInputType]) {
  me {
    tachoRemote {
      driverCard {
        reads(pagination: $pagination, sorting: $sorting, filters: $filters) {
          meta {
            page
            pageSize
            pageCount
            itemsCount
          }
          data {
            id
            driverFirstName
            driverLastName
            driverCard {
              number
              countryCode
              countryCodeLabel @client
            }
            generatedAt
            fileId
            vehicleRegistrationNumber
            source
            reason
            warnings {
              code
              meta {
                key
                value
              }
            }
          }
          matched
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DriverCardsReadingsHistoryGQL extends Apollo.Query<DriverCardsReadingsHistoryQuery, DriverCardsReadingsHistoryQueryVariables> {
    document = DriverCardsReadingsHistoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TachographsReadingsHistoryDocument = gql`
    query TachographsReadingsHistory($filters: TachoRemoteTachographReadFiltersInputType, $pagination: PaginationContextInputType!, $sorting: [TachoRemoteTachographReadSortingItemInputType]) {
  me {
    tachoRemote {
      tachograph {
        reads(filters: $filters, pagination: $pagination, sorting: $sorting) {
          meta {
            page
            pageSize
            pageCount
            itemsCount
          }
          data {
            id
            vehicleRegistrationNumber
            vehicleName
            generatedAt
            source
            readFrom
            readTo
            reason
            warnings {
              code
              meta {
                key
                value
              }
            }
          }
          matched
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TachographsReadingsHistoryGQL extends Apollo.Query<TachographsReadingsHistoryQuery, TachographsReadingsHistoryQueryVariables> {
    document = TachographsReadingsHistoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SuspendTachographReadingsDocument = gql`
    mutation SuspendTachographReadings($payload: TachoRemoteSuspendReadsInputType!) {
  tachoRemote {
    tachographRead {
      suspendReads(payload: $payload) {
        messages {
          code
          id
          fullName
          message
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SuspendTachographReadingsGQL extends Apollo.Mutation<SuspendTachographReadingsMutation, SuspendTachographReadingsMutationVariables> {
    document = SuspendTachographReadingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TachographAdditionalReadingsDocument = gql`
    mutation TachographAdditionalReadings($payload: TachoRemoteVehicleScheduleAdditionalReadOrderInputType!) {
  tachoRemote {
    tachographRead {
      additionalReads(payload: $payload) {
        messages {
          code
          id
          message
          fullName
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TachographAdditionalReadingsGQL extends Apollo.Mutation<TachographAdditionalReadingsMutation, TachographAdditionalReadingsMutationVariables> {
    document = TachographAdditionalReadingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TachographReadingsMetaDocument = gql`
    query TachographReadingsMeta {
  me {
    tachoRemote {
      tachograph {
        meta {
          suspendedCount
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TachographReadingsMetaGQL extends Apollo.Query<TachographReadingsMetaQuery, TachographReadingsMetaQueryVariables> {
    document = TachographReadingsMetaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TachographReadingsDocument = gql`
    query TachographReadings($pagination: PaginationContextInputType!, $sorting: [TachoRemoteTachographReadStatusSortingItemInputType], $filters: TachoRemoteTachographReadStatusFiltersInputType) {
  me {
    tachoRemote {
      tachograph {
        statuses(pagination: $pagination, sorting: $sorting, filters: $filters) {
          meta {
            page
            pageSize
            pageCount
            itemsCount
          }
          data {
            id
            name
            registrationNumber
            lastRead {
              date
              from
              to
              status
              delayStatus
              type
            }
            nextRead {
              date
              type
            }
            lastContact
            additionalReadOrdersCount
            warnings {
              code
              meta {
                key
                value
              }
            }
            suspended
          }
          matched
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TachographReadingsGQL extends Apollo.Query<TachographReadingsQuery, TachographReadingsQueryVariables> {
    document = TachographReadingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnsuspendTachographReadingsDocument = gql`
    mutation UnsuspendTachographReadings($payload: TachoRemoteUnsuspendReadsInputType!) {
  tachoRemote {
    tachographRead {
      unsuspendReads(payload: $payload) {
        messages {
          code
          id
          fullName
          message
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnsuspendTachographReadingsGQL extends Apollo.Mutation<UnsuspendTachographReadingsMutation, UnsuspendTachographReadingsMutationVariables> {
    document = UnsuspendTachographReadingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DriversListDocument = gql`
    query DriversList($isActive: Boolean) {
  me {
    drivers(isActive: $isActive) {
      id
      firstName
      lastName
      isActive
      uuid
      phone {
        number
        prefix
      }
      driverIdentificationNumber
      driverCard {
        number
        countryCode
      }
      workNumber
      username
      pin
      clientId
      applicationLinkStatus
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DriversListGQL extends Apollo.Query<DriversListQuery, DriversListQueryVariables> {
    document = DriversListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EcoDrivingGroupsListDocument = gql`
    query EcoDrivingGroupsList {
  me {
    ecoDriving {
      vehiclesGroups {
        id
        fuelUsageNorm
        maxAllowedSpeed
        maxRPM
        minRPM
        vehiclesIds
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EcoDrivingGroupsListGQL extends Apollo.Query<EcoDrivingGroupsListQuery, EcoDrivingGroupsListQueryVariables> {
    document = EcoDrivingGroupsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EcoDrivingDocument = gql`
    query EcoDriving($clientId: Int!, $driverId: String, $from: Date!, $to: Date!, $driverIdentification: String!) {
  client(id: $clientId) {
    id
    settings {
      ecoDriving {
        fuelUsageNorm
        minRPM
        maxRPM
        maxAllowedSpeed
      }
    }
    ecoDriving {
      statistics(from: $from, to: $to) {
        avgFuelConsumption
        totalFuelConsumption
        rpmDistribution {
          inNorm
        }
      }
    }
    drivers(id: $driverId) {
      ecoDriving(from: $from, to: $to, driverIdentification: $driverIdentification) {
        totalFuelConsumption
        totalDistance
        avgFuelConsumption
        avgRPM
        avgSpeed
        fuelSaving
        totalAcceleratePressed {
          distance
          duration
          percent
        }
        totalAccelerateReleased {
          distance
          duration
          percent
        }
        totalStopOnEngine {
          duration
          percent
        }
        totalCruiseControl {
          distance
          duration
          percent
        }
        totalAccelerateUnknown {
          distance
          duration
          percent
        }
        totalSpeedExceeds
        dailyData {
          date
          fuelConsumption
          distance
          avgFuelConsumption
          avgRPM
          avgSpeed
          speedExceeds
          accelerateUnknown {
            distance
            duration
            percent
          }
          acceleratePressed {
            distance
            duration
            percent
          }
          accelerateReleased {
            distance
            duration
            percent
          }
          stopOnEngine {
            duration
            percent
          }
          cruiseControl {
            distance
            duration
            percent
          }
        }
        rpmDistribution {
          inNorm
          aboveNorm
          belowNorm
        }
        vehicleData {
          vehicleId
          vehicle {
            registrationNumber
          }
          avgFuelConsumption
          distance
          dateRanges {
            from
            to
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EcoDrivingGQL extends Apollo.Query<EcoDrivingQuery, EcoDrivingQueryVariables> {
    document = EcoDrivingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AttachVehiclesToVehiclesGroupDocument = gql`
    mutation attachVehiclesToVehiclesGroup($id: Int!, $payload: EcoDrivingAttachVehiclesToVehiclesGroupInputType!) {
  ecoDriving {
    attachVehiclesToVehiclesGroup(id: $id, payload: $payload) {
      vehiclesIds
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AttachVehiclesToVehiclesGroupGQL extends Apollo.Mutation<AttachVehiclesToVehiclesGroupMutation, AttachVehiclesToVehiclesGroupMutationVariables> {
    document = AttachVehiclesToVehiclesGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyEcoDrivingDocument = gql`
    query CompanyEcoDriving($from: Date!, $to: Date!) {
  me {
    ecoDriving {
      statistics(from: $from, to: $to) {
        monthlyData {
          avgFuelConsumption
          date
          distance
          fuelConsumption
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyEcoDrivingGQL extends Apollo.Query<CompanyEcoDrivingQuery, CompanyEcoDrivingQueryVariables> {
    document = CompanyEcoDrivingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateVehicleGroupDocument = gql`
    mutation createVehicleGroup($params: EcoDrivingCreateVehiclesGroupInputType!) {
  ecoDriving {
    createVehiclesGroup(payload: $params) {
      id
      name
      vehiclesIds
      fuelUsageNorm
      maxAllowedSpeed
      maxRPM
      minRPM
      tractorWeight
      stepFuelConsumptionPerTon
      fuelUsageNormForEmpty
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateVehicleGroupGQL extends Apollo.Mutation<CreateVehicleGroupMutation, CreateVehicleGroupMutationVariables> {
    document = CreateVehicleGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteVehicleGroupDocument = gql`
    mutation deleteVehicleGroup($id: Int!) {
  ecoDriving {
    deleteVehiclesGroup(id: $id) {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteVehicleGroupGQL extends Apollo.Mutation<DeleteVehicleGroupMutation, DeleteVehicleGroupMutationVariables> {
    document = DeleteVehicleGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DetachVehiclesFromVehiclesGroupDocument = gql`
    mutation detachVehiclesFromVehiclesGroup($payload: EcoDrivingDetachVehiclesToVehiclesGroupInputType!) {
  ecoDriving {
    detachVehiclesFromVehiclesGroup(payload: $payload) {
      vehiclesIds
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DetachVehiclesFromVehiclesGroupGQL extends Apollo.Mutation<DetachVehiclesFromVehiclesGroupMutation, DetachVehiclesFromVehiclesGroupMutationVariables> {
    document = DetachVehiclesFromVehiclesGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DriversRankingDocument = gql`
    query DriversRanking($from: Date!, $to: Date!, $parameters: EcoDrivingDriverRankingParametersType) {
  me {
    ecoDriving {
      driversRanking(from: $from, to: $to, parameters: $parameters) {
        driverIdentification
        fuelSaving
        avgFuelConsumption
        distance
        grade
        vehicles {
          boxId
          registerNumber
        }
        cruiseControl {
          percent
        }
        loadPart {
          avgTotalLoad
          avgAxleLoad
        }
        driver {
          ... on Driver {
            firstName
            lastName
            uuid
            isActive
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DriversRankingGQL extends Apollo.Query<DriversRankingQuery, DriversRankingQueryVariables> {
    document = DriversRankingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EcoDrivingGroupsDocument = gql`
    query EcoDrivingGroups {
  me {
    ecoDriving {
      vehiclesGroups {
        id
        name
        vehiclesIds
        fuelUsageNorm
        maxAllowedSpeed
        maxRPM
        minRPM
        tractorWeight
        stepFuelConsumptionPerTon
        fuelUsageNormForEmpty
      }
      settings {
        fuelUsageNorm
        maxAllowedSpeed
        maxRPM
        minRPM
        tractorWeight
        stepFuelConsumptionPerTon
        fuelUsageNormForEmpty
      }
    }
    vehicles {
      id
      ecoDrivingGroup {
        id
        name
      }
      model
      yearOfProduction
      brand
      name
      registrationNumber
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EcoDrivingGroupsGQL extends Apollo.Query<EcoDrivingGroupsQuery, EcoDrivingGroupsQueryVariables> {
    document = EcoDrivingGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EcoDrivingSettingsDocument = gql`
    query EcoDrivingSettings {
  me {
    ecoDriving {
      settings {
        fuelUsageNorm
        maxAllowedSpeed
        maxRPM
        minRPM
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EcoDrivingSettingsGQL extends Apollo.Query<EcoDrivingSettingsQuery, EcoDrivingSettingsQueryVariables> {
    document = EcoDrivingSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSettingsDocument = gql`
    mutation updateSettings($payload: EcoDrivingUpdateSettingsInputType!) {
  ecoDriving {
    updateSettings(payload: $payload) {
      fuelUsageNorm
      maxAllowedSpeed
      minRPM
      maxRPM
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSettingsGQL extends Apollo.Mutation<UpdateSettingsMutation, UpdateSettingsMutationVariables> {
    document = UpdateSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateVehiclesGroupDocument = gql`
    mutation updateVehiclesGroup($id: Int!, $payload: EcoDrivingUpdateVehiclesGroupInputType!) {
  ecoDriving {
    updateVehiclesGroup(id: $id, payload: $payload) {
      id
      clientId
      name
      vehiclesIds
      fuelUsageNorm
      minRPM
      maxRPM
      maxAllowedSpeed
      fuelUsageNormForEmpty
      stepFuelConsumptionPerTon
      tractorWeight
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateVehiclesGroupGQL extends Apollo.Mutation<UpdateVehiclesGroupMutation, UpdateVehiclesGroupMutationVariables> {
    document = UpdateVehiclesGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateGboxAuthorizationAccountDocument = gql`
    mutation CreateGboxAuthorizationAccount {
  gboxAuthorizationAccount {
    create {
      id
      login
      password
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateGboxAuthorizationAccountGQL extends Apollo.Mutation<CreateGboxAuthorizationAccountMutation, CreateGboxAuthorizationAccountMutationVariables> {
    document = CreateGboxAuthorizationAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GboxAuthorizationAccountDocument = gql`
    query GboxAuthorizationAccount {
  me {
    apiAccounts {
      gboxAuthorization {
        id
        login
        type
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GboxAuthorizationAccountGQL extends Apollo.Query<GboxAuthorizationAccountQuery, GboxAuthorizationAccountQueryVariables> {
    document = GboxAuthorizationAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetGboxAuthorizationAccountPasswordDocument = gql`
    mutation ResetGboxAuthorizationAccountPassword {
  gboxAuthorizationAccount {
    resetPassword {
      id
      login
      password
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetGboxAuthorizationAccountPasswordGQL extends Apollo.Mutation<ResetGboxAuthorizationAccountPasswordMutation, ResetGboxAuthorizationAccountPasswordMutationVariables> {
    document = ResetGboxAuthorizationAccountPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyApiAccountsDocument = gql`
    query CompanyApiAccounts {
  me {
    apiAccounts {
      partner {
        id
        login
        type
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyApiAccountsGQL extends Apollo.Query<CompanyApiAccountsQuery, CompanyApiAccountsQueryVariables> {
    document = CompanyApiAccountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePartnerAccountDocument = gql`
    mutation CreatePartnerAccount {
  partnerAccount {
    create {
      id
      login
      password
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePartnerAccountGQL extends Apollo.Mutation<CreatePartnerAccountMutation, CreatePartnerAccountMutationVariables> {
    document = CreatePartnerAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetPartnerAccountPasswordDocument = gql`
    mutation ResetPartnerAccountPassword {
  partnerAccount {
    resetPassword {
      id
      login
      password
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetPartnerAccountPasswordGQL extends Apollo.Mutation<ResetPartnerAccountPasswordMutation, ResetPartnerAccountPasswordMutationVariables> {
    document = ResetPartnerAccountPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TaskDetailsDocument = gql`
    query taskDetails($taskId: String!) {
  me {
    tasks(id: $taskId) {
      id
      finishNote
      note
      arriveTimeEnd
      target {
        address
      }
      eta {
        arrival {
          withWorkTime
        }
        distance {
          total
          left
        }
        createdAt
      }
      attachments {
        id
        filename
      }
      driver {
        id
        vehicle {
          id
        }
      }
      arriveTimeEnd
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TaskDetailsGQL extends Apollo.Query<TaskDetailsQuery, TaskDetailsQueryVariables> {
    document = TaskDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TaskListDocument = gql`
    query taskList {
  me {
    tasks {
      ...taskListItemFragment
    }
  }
}
    ${TaskListItemFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TaskListGQL extends Apollo.Query<TaskListQuery, TaskListQueryVariables> {
    document = TaskListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TachoRemoteStatusInfoDocument = gql`
    query TachoRemoteStatusInfo {
  me {
    tachoRemote {
      status {
        state
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TachoRemoteStatusInfoGQL extends Apollo.Query<TachoRemoteStatusInfoQuery, TachoRemoteStatusInfoQueryVariables> {
    document = TachoRemoteStatusInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "EtaMonitor": [
      "EtaLightTask",
      "OrderTask"
    ],
    "EtaMonitorTask": [
      "EtaLightTask",
      "OrderTask"
    ],
    "MaybeUnknownDriver": [
      "Driver",
      "DriverUnknown"
    ]
  }
};
      export default result;
    
export type AcceleratePressKeySpecifier = ('distance' | 'duration' | 'percent' | AcceleratePressKeySpecifier)[];
export type AcceleratePressFieldPolicy = {
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	percent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivateDriverAppMutationTypeKeySpecifier = ('clientId' | 'createdAt' | 'driverId' | 'fcmRegistrationToken' | 'googleUserId' | 'id' | 'linkedAt' | 'phone' | ActivateDriverAppMutationTypeKeySpecifier)[];
export type ActivateDriverAppMutationTypeFieldPolicy = {
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	driverId?: FieldPolicy<any> | FieldReadFunction<any>,
	fcmRegistrationToken?: FieldPolicy<any> | FieldReadFunction<any>,
	googleUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ApiAccountsKeySpecifier = ('gboxAuthorization' | 'partner' | ApiAccountsKeySpecifier)[];
export type ApiAccountsFieldPolicy = {
	gboxAuthorization?: FieldPolicy<any> | FieldReadFunction<any>,
	partner?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ApiAccountsModuleKeySpecifier = ('enabled' | 'partner' | ApiAccountsModuleKeySpecifier)[];
export type ApiAccountsModuleFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	partner?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuthKeySpecifier = ('hereToken' | AuthKeySpecifier)[];
export type AuthFieldPolicy = {
	hereToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuthHereTokenTypeKeySpecifier = ('accessToken' | AuthHereTokenTypeKeySpecifier)[];
export type AuthHereTokenTypeFieldPolicy = {
	accessToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CancelEtaLightTaskMutationTypeKeySpecifier = ('createdAt' | 'eta' | 'id' | 'plannedArrivalTime' | 'status' | 'target' | 'updateAt' | 'vehicleId' | CancelEtaLightTaskMutationTypeKeySpecifier)[];
export type CancelEtaLightTaskMutationTypeFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	eta?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	plannedArrivalTime?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	target?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAt?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CargoEventKeySpecifier = ('action' | 'cargoId' | 'country' | 'driverId' | 'occurredAt' | 'registeredAt' | 'type' | 'unloadId' | CargoEventKeySpecifier)[];
export type CargoEventFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	cargoId?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	driverId?: FieldPolicy<any> | FieldReadFunction<any>,
	occurredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	registeredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	unloadId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CargoEventListPageInfoKeySpecifier = ('pageCount' | 'pageNumber' | 'pageSize' | CargoEventListPageInfoKeySpecifier)[];
export type CargoEventListPageInfoFieldPolicy = {
	pageCount?: FieldPolicy<any> | FieldReadFunction<any>,
	pageNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	pageSize?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CargoEventsKeySpecifier = ('edges' | 'pageInfo' | CargoEventsKeySpecifier)[];
export type CargoEventsFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CargoMutationTypeKeySpecifier = ('createLoading' | 'createUnloading' | CargoMutationTypeKeySpecifier)[];
export type CargoMutationTypeFieldPolicy = {
	createLoading?: FieldPolicy<any> | FieldReadFunction<any>,
	createUnloading?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClientKeySpecifier = ('apiAccounts' | 'auth' | 'drivers' | 'ecoDriving' | 'etaLight' | 'etaLightTasks' | 'featureFlags' | 'fullName' | 'id' | 'isInternal' | 'isJoint' | 'name' | 'orderTasks' | 'settings' | 'tachoRemote' | 'tasks' | 'vehicleTypes' | 'vehicles' | 'vehiclesGroups' | ClientKeySpecifier)[];
export type ClientFieldPolicy = {
	apiAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	auth?: FieldPolicy<any> | FieldReadFunction<any>,
	drivers?: FieldPolicy<any> | FieldReadFunction<any>,
	ecoDriving?: FieldPolicy<any> | FieldReadFunction<any>,
	etaLight?: FieldPolicy<any> | FieldReadFunction<any>,
	etaLightTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	featureFlags?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isInternal?: FieldPolicy<any> | FieldReadFunction<any>,
	isJoint?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	orderTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	tachoRemote?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicles?: FieldPolicy<any> | FieldReadFunction<any>,
	vehiclesGroups?: FieldPolicy<any> | FieldReadFunction<any>
};
export type Client4TransKeySpecifier = ('cargoEvents' | 'drivers' | Client4TransKeySpecifier)[];
export type Client4TransFieldPolicy = {
	cargoEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	drivers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CoordinateKeySpecifier = ('lat' | 'lng' | CoordinateKeySpecifier)[];
export type CoordinateFieldPolicy = {
	lat?: FieldPolicy<any> | FieldReadFunction<any>,
	lng?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateCargoLoadingMutationTypeKeySpecifier = ('country' | 'id' | 'occurredAt' | 'registeredAt' | CreateCargoLoadingMutationTypeKeySpecifier)[];
export type CreateCargoLoadingMutationTypeFieldPolicy = {
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	occurredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	registeredAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateCargoUnloadingMutationTypeKeySpecifier = ('cargoId' | 'country' | 'id' | 'occurredAt' | 'registeredAt' | 'type' | CreateCargoUnloadingMutationTypeKeySpecifier)[];
export type CreateCargoUnloadingMutationTypeFieldPolicy = {
	cargoId?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	occurredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	registeredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateDriverMutationTypeKeySpecifier = ('clientId' | 'driverCard' | 'driverIdentificationNumber' | 'firstName' | 'id' | 'lastName' | 'phone' | 'pin' | 'username' | 'uuid' | 'workNumber' | CreateDriverMutationTypeKeySpecifier)[];
export type CreateDriverMutationTypeFieldPolicy = {
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	driverCard?: FieldPolicy<any> | FieldReadFunction<any>,
	driverIdentificationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	pin?: FieldPolicy<any> | FieldReadFunction<any>,
	username?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	workNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateEtaLightTaskMutationTypeKeySpecifier = ('createdAt' | 'eta' | 'id' | 'plannedArrivalTime' | 'status' | 'target' | 'updateAt' | 'vehicleId' | CreateEtaLightTaskMutationTypeKeySpecifier)[];
export type CreateEtaLightTaskMutationTypeFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	eta?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	plannedArrivalTime?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	target?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAt?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateGboxAuthorizationAccountMutationTypeKeySpecifier = ('id' | 'login' | 'password' | 'type' | CreateGboxAuthorizationAccountMutationTypeKeySpecifier)[];
export type CreateGboxAuthorizationAccountMutationTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	login?: FieldPolicy<any> | FieldReadFunction<any>,
	password?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreatePartnerAccountMutationTypeKeySpecifier = ('id' | 'login' | 'password' | 'type' | CreatePartnerAccountMutationTypeKeySpecifier)[];
export type CreatePartnerAccountMutationTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	login?: FieldPolicy<any> | FieldReadFunction<any>,
	password?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CruiseControlKeySpecifier = ('distance' | 'duration' | 'percent' | CruiseControlKeySpecifier)[];
export type CruiseControlFieldPolicy = {
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	percent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerKeySpecifier = ('companyName' | CustomerKeySpecifier)[];
export type CustomerFieldPolicy = {
	companyName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerAreaKeySpecifier = ('contracts' | 'payments' | CustomerAreaKeySpecifier)[];
export type CustomerAreaFieldPolicy = {
	contracts?: FieldPolicy<any> | FieldReadFunction<any>,
	payments?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerAreaContractKeySpecifier = ('features' | 'licence' | 'registrationNumber' | 'state' | 'type' | 'vehicleId' | CustomerAreaContractKeySpecifier)[];
export type CustomerAreaContractFieldPolicy = {
	features?: FieldPolicy<any> | FieldReadFunction<any>,
	licence?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerAreaContractLicenceKeySpecifier = ('amount' | 'currency' | 'name' | CustomerAreaContractLicenceKeySpecifier)[];
export type CustomerAreaContractLicenceFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerAreaContractsResponseKeySpecifier = ('data' | CustomerAreaContractsResponseKeySpecifier)[];
export type CustomerAreaContractsResponseFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerAreaPaymentKeySpecifier = ('amount' | 'date' | 'number' | 'status' | 'term' | CustomerAreaPaymentKeySpecifier)[];
export type CustomerAreaPaymentFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	term?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerAreaPaymentAmountKeySpecifier = ('currency' | 'gross' | 'net' | CustomerAreaPaymentAmountKeySpecifier)[];
export type CustomerAreaPaymentAmountFieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	gross?: FieldPolicy<any> | FieldReadFunction<any>,
	net?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DailyDataKeySpecifier = ('acceleratePressed' | 'accelerateReleased' | 'accelerateUnknown' | 'avgFuelConsumption' | 'avgRPM' | 'avgSpeed' | 'cruiseControl' | 'date' | 'distance' | 'fuelConsumption' | 'speedExceeds' | 'stopOnEngine' | DailyDataKeySpecifier)[];
export type DailyDataFieldPolicy = {
	acceleratePressed?: FieldPolicy<any> | FieldReadFunction<any>,
	accelerateReleased?: FieldPolicy<any> | FieldReadFunction<any>,
	accelerateUnknown?: FieldPolicy<any> | FieldReadFunction<any>,
	avgFuelConsumption?: FieldPolicy<any> | FieldReadFunction<any>,
	avgRPM?: FieldPolicy<any> | FieldReadFunction<any>,
	avgSpeed?: FieldPolicy<any> | FieldReadFunction<any>,
	cruiseControl?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	fuelConsumption?: FieldPolicy<any> | FieldReadFunction<any>,
	speedExceeds?: FieldPolicy<any> | FieldReadFunction<any>,
	stopOnEngine?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DateRangeDataKeySpecifier = ('from' | 'to' | DateRangeDataKeySpecifier)[];
export type DateRangeDataFieldPolicy = {
	from?: FieldPolicy<any> | FieldReadFunction<any>,
	to?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeactivateDriverAppMutationTypeKeySpecifier = ('id' | DeactivateDriverAppMutationTypeKeySpecifier)[];
export type DeactivateDriverAppMutationTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeactivateDriverMutationTypeKeySpecifier = ('id' | DeactivateDriverMutationTypeKeySpecifier)[];
export type DeactivateDriverMutationTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeprecatedEcoDrivingSettingsKeySpecifier = ('fuelUsageNorm' | 'maxAllowedSpeed' | 'maxRPM' | 'minRPM' | DeprecatedEcoDrivingSettingsKeySpecifier)[];
export type DeprecatedEcoDrivingSettingsFieldPolicy = {
	fuelUsageNorm?: FieldPolicy<any> | FieldReadFunction<any>,
	maxAllowedSpeed?: FieldPolicy<any> | FieldReadFunction<any>,
	maxRPM?: FieldPolicy<any> | FieldReadFunction<any>,
	minRPM?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DriverKeySpecifier = ('applicationLinkStatus' | 'clientId' | 'driverCard' | 'driverIdentificationNumber' | 'driverState' | 'ecoDriving' | 'firstName' | 'fullName' | 'id' | 'identificationId' | 'isActive' | 'isAuthorized' | 'lastName' | 'phone' | 'pin' | 'username' | 'uuid' | 'vehicle' | 'workNumber' | DriverKeySpecifier)[];
export type DriverFieldPolicy = {
	applicationLinkStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	driverCard?: FieldPolicy<any> | FieldReadFunction<any>,
	driverIdentificationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	driverState?: FieldPolicy<any> | FieldReadFunction<any>,
	ecoDriving?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	identificationId?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isAuthorized?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	pin?: FieldPolicy<any> | FieldReadFunction<any>,
	username?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicle?: FieldPolicy<any> | FieldReadFunction<any>,
	workNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DriverAppModuleKeySpecifier = ('enabled' | DriverAppModuleKeySpecifier)[];
export type DriverAppModuleFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DriverCardKeySpecifier = ('countryCode' | 'countryCodeLabel' | 'number' | DriverCardKeySpecifier)[];
export type DriverCardFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCodeLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DriverMutationTypeKeySpecifier = ('activateDriverApp' | 'create' | 'deactivate' | 'deactivateDriverApp' | 'update' | DriverMutationTypeKeySpecifier)[];
export type DriverMutationTypeFieldPolicy = {
	activateDriverApp?: FieldPolicy<any> | FieldReadFunction<any>,
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	deactivate?: FieldPolicy<any> | FieldReadFunction<any>,
	deactivateDriverApp?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DriverPhoneKeySpecifier = ('number' | 'prefix' | DriverPhoneKeySpecifier)[];
export type DriverPhoneFieldPolicy = {
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	prefix?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DriverStatusTypeKeySpecifier = ('date' | 'name' | DriverStatusTypeKeySpecifier)[];
export type DriverStatusTypeFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DriverUnknownKeySpecifier = ('driverCardNumber' | 'driverState' | 'identificationId' | 'isAuthorized' | DriverUnknownKeySpecifier)[];
export type DriverUnknownFieldPolicy = {
	driverCardNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	driverState?: FieldPolicy<any> | FieldReadFunction<any>,
	identificationId?: FieldPolicy<any> | FieldReadFunction<any>,
	isAuthorized?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DriverVehicleInfoKeySpecifier = ('boxId' | 'registerNumber' | DriverVehicleInfoKeySpecifier)[];
export type DriverVehicleInfoFieldPolicy = {
	boxId?: FieldPolicy<any> | FieldReadFunction<any>,
	registerNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ETOLLModuleKeySpecifier = ('enabled' | ETOLLModuleKeySpecifier)[];
export type ETOLLModuleFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EcoDrivingAttachVehiclesToVehiclesGroupMutationTypeKeySpecifier = ('vehiclesIds' | EcoDrivingAttachVehiclesToVehiclesGroupMutationTypeKeySpecifier)[];
export type EcoDrivingAttachVehiclesToVehiclesGroupMutationTypeFieldPolicy = {
	vehiclesIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EcoDrivingCompanyMonthlyDataTypeKeySpecifier = ('avgFuelConsumption' | 'date' | 'distance' | 'fuelConsumption' | EcoDrivingCompanyMonthlyDataTypeKeySpecifier)[];
export type EcoDrivingCompanyMonthlyDataTypeFieldPolicy = {
	avgFuelConsumption?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	fuelConsumption?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EcoDrivingCompanyStatisticsTypeKeySpecifier = ('avgFuelConsumption' | 'monthlyData' | 'rpmDistribution' | 'totalDistance' | 'totalFuelConsumption' | EcoDrivingCompanyStatisticsTypeKeySpecifier)[];
export type EcoDrivingCompanyStatisticsTypeFieldPolicy = {
	avgFuelConsumption?: FieldPolicy<any> | FieldReadFunction<any>,
	monthlyData?: FieldPolicy<any> | FieldReadFunction<any>,
	rpmDistribution?: FieldPolicy<any> | FieldReadFunction<any>,
	totalDistance?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFuelConsumption?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EcoDrivingCreateVehiclesGroupMutationTypeKeySpecifier = ('clientId' | 'fuelUsageNorm' | 'fuelUsageNormForEmpty' | 'id' | 'maxAllowedSpeed' | 'maxRPM' | 'minRPM' | 'name' | 'stepFuelConsumptionPerTon' | 'tractorWeight' | 'vehiclesIds' | EcoDrivingCreateVehiclesGroupMutationTypeKeySpecifier)[];
export type EcoDrivingCreateVehiclesGroupMutationTypeFieldPolicy = {
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	fuelUsageNorm?: FieldPolicy<any> | FieldReadFunction<any>,
	fuelUsageNormForEmpty?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maxAllowedSpeed?: FieldPolicy<any> | FieldReadFunction<any>,
	maxRPM?: FieldPolicy<any> | FieldReadFunction<any>,
	minRPM?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	stepFuelConsumptionPerTon?: FieldPolicy<any> | FieldReadFunction<any>,
	tractorWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	vehiclesIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EcoDrivingDeleteVehiclesGroupMutationTypeKeySpecifier = ('id' | EcoDrivingDeleteVehiclesGroupMutationTypeKeySpecifier)[];
export type EcoDrivingDeleteVehiclesGroupMutationTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EcoDrivingDetachVehiclesToVehiclesGroupMutationTypeKeySpecifier = ('vehiclesIds' | EcoDrivingDetachVehiclesToVehiclesGroupMutationTypeKeySpecifier)[];
export type EcoDrivingDetachVehiclesToVehiclesGroupMutationTypeFieldPolicy = {
	vehiclesIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EcoDrivingDriverRankingTypeKeySpecifier = ('avgFuelConsumption' | 'cruiseControl' | 'distance' | 'driver' | 'driverIdentification' | 'fuelSaving' | 'grade' | 'loadPart' | 'vehicles' | EcoDrivingDriverRankingTypeKeySpecifier)[];
export type EcoDrivingDriverRankingTypeFieldPolicy = {
	avgFuelConsumption?: FieldPolicy<any> | FieldReadFunction<any>,
	cruiseControl?: FieldPolicy<any> | FieldReadFunction<any>,
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	driver?: FieldPolicy<any> | FieldReadFunction<any>,
	driverIdentification?: FieldPolicy<any> | FieldReadFunction<any>,
	fuelSaving?: FieldPolicy<any> | FieldReadFunction<any>,
	grade?: FieldPolicy<any> | FieldReadFunction<any>,
	loadPart?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EcoDrivingDriverStatisticsKeySpecifier = ('avgFuelConsumption' | 'avgRPM' | 'avgSpeed' | 'dailyData' | 'fuelSaving' | 'rpmDistribution' | 'totalAcceleratePressed' | 'totalAccelerateReleased' | 'totalAccelerateUnknown' | 'totalCruiseControl' | 'totalDistance' | 'totalFuelConsumption' | 'totalSpeedExceeds' | 'totalStopOnEngine' | 'vehicleData' | EcoDrivingDriverStatisticsKeySpecifier)[];
export type EcoDrivingDriverStatisticsFieldPolicy = {
	avgFuelConsumption?: FieldPolicy<any> | FieldReadFunction<any>,
	avgRPM?: FieldPolicy<any> | FieldReadFunction<any>,
	avgSpeed?: FieldPolicy<any> | FieldReadFunction<any>,
	dailyData?: FieldPolicy<any> | FieldReadFunction<any>,
	fuelSaving?: FieldPolicy<any> | FieldReadFunction<any>,
	rpmDistribution?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAcceleratePressed?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAccelerateReleased?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAccelerateUnknown?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCruiseControl?: FieldPolicy<any> | FieldReadFunction<any>,
	totalDistance?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFuelConsumption?: FieldPolicy<any> | FieldReadFunction<any>,
	totalSpeedExceeds?: FieldPolicy<any> | FieldReadFunction<any>,
	totalStopOnEngine?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleData?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EcoDrivingGroupKeySpecifier = ('id' | 'name' | EcoDrivingGroupKeySpecifier)[];
export type EcoDrivingGroupFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EcoDrivingModuleKeySpecifier = ('cruiseControl' | 'enabled' | 'groups' | 'pdfExport' | 'ranking' | 'retarder' | 'tonnage' | EcoDrivingModuleKeySpecifier)[];
export type EcoDrivingModuleFieldPolicy = {
	cruiseControl?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	pdfExport?: FieldPolicy<any> | FieldReadFunction<any>,
	ranking?: FieldPolicy<any> | FieldReadFunction<any>,
	retarder?: FieldPolicy<any> | FieldReadFunction<any>,
	tonnage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EcoDrivingMutationTypeKeySpecifier = ('attachVehiclesToVehiclesGroup' | 'createVehiclesGroup' | 'deleteVehiclesGroup' | 'detachVehiclesFromVehiclesGroup' | 'updateSettings' | 'updateVehiclesGroup' | EcoDrivingMutationTypeKeySpecifier)[];
export type EcoDrivingMutationTypeFieldPolicy = {
	attachVehiclesToVehiclesGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	createVehiclesGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteVehiclesGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	detachVehiclesFromVehiclesGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVehiclesGroup?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EcoDrivingSettingsTypeKeySpecifier = ('fuelUsageNorm' | 'fuelUsageNormForEmpty' | 'maxAllowedSpeed' | 'maxRPM' | 'minRPM' | 'stepFuelConsumptionPerTon' | 'tractorWeight' | EcoDrivingSettingsTypeKeySpecifier)[];
export type EcoDrivingSettingsTypeFieldPolicy = {
	fuelUsageNorm?: FieldPolicy<any> | FieldReadFunction<any>,
	fuelUsageNormForEmpty?: FieldPolicy<any> | FieldReadFunction<any>,
	maxAllowedSpeed?: FieldPolicy<any> | FieldReadFunction<any>,
	maxRPM?: FieldPolicy<any> | FieldReadFunction<any>,
	minRPM?: FieldPolicy<any> | FieldReadFunction<any>,
	stepFuelConsumptionPerTon?: FieldPolicy<any> | FieldReadFunction<any>,
	tractorWeight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EcoDrivingTypeKeySpecifier = ('driversRanking' | 'settings' | 'statistics' | 'vehiclesGroups' | EcoDrivingTypeKeySpecifier)[];
export type EcoDrivingTypeFieldPolicy = {
	driversRanking?: FieldPolicy<any> | FieldReadFunction<any>,
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	vehiclesGroups?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EcoDrivingUpdateSettingsMutationTypeKeySpecifier = ('fuelUsageNorm' | 'maxAllowedSpeed' | 'maxRPM' | 'minRPM' | EcoDrivingUpdateSettingsMutationTypeKeySpecifier)[];
export type EcoDrivingUpdateSettingsMutationTypeFieldPolicy = {
	fuelUsageNorm?: FieldPolicy<any> | FieldReadFunction<any>,
	maxAllowedSpeed?: FieldPolicy<any> | FieldReadFunction<any>,
	maxRPM?: FieldPolicy<any> | FieldReadFunction<any>,
	minRPM?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EcoDrivingUpdateVehiclesGroupMutationTypeKeySpecifier = ('clientId' | 'fuelUsageNorm' | 'fuelUsageNormForEmpty' | 'id' | 'maxAllowedSpeed' | 'maxRPM' | 'minRPM' | 'name' | 'stepFuelConsumptionPerTon' | 'tractorWeight' | 'vehiclesIds' | EcoDrivingUpdateVehiclesGroupMutationTypeKeySpecifier)[];
export type EcoDrivingUpdateVehiclesGroupMutationTypeFieldPolicy = {
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	fuelUsageNorm?: FieldPolicy<any> | FieldReadFunction<any>,
	fuelUsageNormForEmpty?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maxAllowedSpeed?: FieldPolicy<any> | FieldReadFunction<any>,
	maxRPM?: FieldPolicy<any> | FieldReadFunction<any>,
	minRPM?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	stepFuelConsumptionPerTon?: FieldPolicy<any> | FieldReadFunction<any>,
	tractorWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	vehiclesIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EcoDrivingVehicleGroupTypeKeySpecifier = ('clientId' | 'fuelUsageNorm' | 'fuelUsageNormForEmpty' | 'id' | 'maxAllowedSpeed' | 'maxRPM' | 'minRPM' | 'name' | 'stepFuelConsumptionPerTon' | 'tractorWeight' | 'vehiclesIds' | EcoDrivingVehicleGroupTypeKeySpecifier)[];
export type EcoDrivingVehicleGroupTypeFieldPolicy = {
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	fuelUsageNorm?: FieldPolicy<any> | FieldReadFunction<any>,
	fuelUsageNormForEmpty?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maxAllowedSpeed?: FieldPolicy<any> | FieldReadFunction<any>,
	maxRPM?: FieldPolicy<any> | FieldReadFunction<any>,
	minRPM?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	stepFuelConsumptionPerTon?: FieldPolicy<any> | FieldReadFunction<any>,
	tractorWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	vehiclesIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EtaKeySpecifier = ('arrival' | 'boxId' | 'calculatedAt' | 'createdAt' | 'currentRest' | 'departure' | 'distance' | 'restsTaken' | 'status' | 'updatedAt' | 'workTimeActivities' | EtaKeySpecifier)[];
export type EtaFieldPolicy = {
	arrival?: FieldPolicy<any> | FieldReadFunction<any>,
	boxId?: FieldPolicy<any> | FieldReadFunction<any>,
	calculatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currentRest?: FieldPolicy<any> | FieldReadFunction<any>,
	departure?: FieldPolicy<any> | FieldReadFunction<any>,
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	restsTaken?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	workTimeActivities?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EtaArrivalKeySpecifier = ('fromRouting' | 'withWorkTime' | EtaArrivalKeySpecifier)[];
export type EtaArrivalFieldPolicy = {
	fromRouting?: FieldPolicy<any> | FieldReadFunction<any>,
	withWorkTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EtaCurrentRestKeySpecifier = ('period' | 'startedAt' | EtaCurrentRestKeySpecifier)[];
export type EtaCurrentRestFieldPolicy = {
	period?: FieldPolicy<any> | FieldReadFunction<any>,
	startedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EtaDistanceKeySpecifier = ('left' | 'total' | EtaDistanceKeySpecifier)[];
export type EtaDistanceFieldPolicy = {
	left?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EtaLightModuleKeySpecifier = ('enabled' | 'vehicles' | EtaLightModuleKeySpecifier)[];
export type EtaLightModuleFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EtaLightTaskKeySpecifier = ('cancelReason' | 'createdAt' | 'eta' | 'etaTimeStatus' | 'id' | 'isCalculated' | 'isCanceled' | 'isEndangered' | 'isEtaLightSource' | 'isExceeded' | 'isOk' | 'isOrderTaskSource' | 'isUnknown' | 'plannedArrivalTime' | 'sourceId' | 'status' | 'target' | 'updateAt' | 'vehicleId' | EtaLightTaskKeySpecifier)[];
export type EtaLightTaskFieldPolicy = {
	cancelReason?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	eta?: FieldPolicy<any> | FieldReadFunction<any>,
	etaTimeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isCalculated?: FieldPolicy<any> | FieldReadFunction<any>,
	isCanceled?: FieldPolicy<any> | FieldReadFunction<any>,
	isEndangered?: FieldPolicy<any> | FieldReadFunction<any>,
	isEtaLightSource?: FieldPolicy<any> | FieldReadFunction<any>,
	isExceeded?: FieldPolicy<any> | FieldReadFunction<any>,
	isOk?: FieldPolicy<any> | FieldReadFunction<any>,
	isOrderTaskSource?: FieldPolicy<any> | FieldReadFunction<any>,
	isUnknown?: FieldPolicy<any> | FieldReadFunction<any>,
	plannedArrivalTime?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	target?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAt?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EtaLightTaskMutationTypeKeySpecifier = ('cancel' | 'create' | EtaLightTaskMutationTypeKeySpecifier)[];
export type EtaLightTaskMutationTypeFieldPolicy = {
	cancel?: FieldPolicy<any> | FieldReadFunction<any>,
	create?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EtaLightTypeKeySpecifier = ('tasks' | 'usage' | EtaLightTypeKeySpecifier)[];
export type EtaLightTypeFieldPolicy = {
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EtaMonitorKeySpecifier = ('etaTimeStatus' | 'isCalculated' | 'isCanceled' | 'isEndangered' | 'isEtaLightSource' | 'isExceeded' | 'isOk' | 'isOrderTaskSource' | 'isUnknown' | 'sourceId' | 'target' | EtaMonitorKeySpecifier)[];
export type EtaMonitorFieldPolicy = {
	etaTimeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	isCalculated?: FieldPolicy<any> | FieldReadFunction<any>,
	isCanceled?: FieldPolicy<any> | FieldReadFunction<any>,
	isEndangered?: FieldPolicy<any> | FieldReadFunction<any>,
	isEtaLightSource?: FieldPolicy<any> | FieldReadFunction<any>,
	isExceeded?: FieldPolicy<any> | FieldReadFunction<any>,
	isOk?: FieldPolicy<any> | FieldReadFunction<any>,
	isOrderTaskSource?: FieldPolicy<any> | FieldReadFunction<any>,
	isUnknown?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceId?: FieldPolicy<any> | FieldReadFunction<any>,
	target?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EtaRestTakenTypeKeySpecifier = ('period' | 'questionable' | 'startedAt' | EtaRestTakenTypeKeySpecifier)[];
export type EtaRestTakenTypeFieldPolicy = {
	period?: FieldPolicy<any> | FieldReadFunction<any>,
	questionable?: FieldPolicy<any> | FieldReadFunction<any>,
	startedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FeatureFlagsTypeKeySpecifier = ('batteryVoltage' | 'tachoRemote' | FeatureFlagsTypeKeySpecifier)[];
export type FeatureFlagsTypeFieldPolicy = {
	batteryVoltage?: FieldPolicy<any> | FieldReadFunction<any>,
	tachoRemote?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FireTmsKeySpecifier = ('boxes' | 'driverApp' | 'enabled' | 'hereMaps' | FireTmsKeySpecifier)[];
export type FireTmsFieldPolicy = {
	boxes?: FieldPolicy<any> | FieldReadFunction<any>,
	driverApp?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	hereMaps?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FireTmsDriverAppKeySpecifier = ('hereMaps' | 'licenses' | FireTmsDriverAppKeySpecifier)[];
export type FireTmsDriverAppFieldPolicy = {
	hereMaps?: FieldPolicy<any> | FieldReadFunction<any>,
	licenses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FleetKeySpecifier = ('hadAssist' | 'hasAssist' | 'type' | FleetKeySpecifier)[];
export type FleetFieldPolicy = {
	hadAssist?: FieldPolicy<any> | FieldReadFunction<any>,
	hasAssist?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FuelTankProbeTypeKeySpecifier = ('voltage' | 'volume' | FuelTankProbeTypeKeySpecifier)[];
export type FuelTankProbeTypeFieldPolicy = {
	voltage?: FieldPolicy<any> | FieldReadFunction<any>,
	volume?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FuelTankTypeKeySpecifier = ('bottom' | 'capacity' | 'top' | FuelTankTypeKeySpecifier)[];
export type FuelTankTypeFieldPolicy = {
	bottom?: FieldPolicy<any> | FieldReadFunction<any>,
	capacity?: FieldPolicy<any> | FieldReadFunction<any>,
	top?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FuelTanksTypeKeySpecifier = ('boxId' | 'tank1' | 'tank2' | 'type' | FuelTanksTypeKeySpecifier)[];
export type FuelTanksTypeFieldPolicy = {
	boxId?: FieldPolicy<any> | FieldReadFunction<any>,
	tank1?: FieldPolicy<any> | FieldReadFunction<any>,
	tank2?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GboxAuthorizationAccountKeySpecifier = ('id' | 'login' | 'type' | GboxAuthorizationAccountKeySpecifier)[];
export type GboxAuthorizationAccountFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	login?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GboxAuthorizationAccountMutationTypeKeySpecifier = ('create' | 'resetPassword' | GboxAuthorizationAccountMutationTypeKeySpecifier)[];
export type GboxAuthorizationAccountMutationTypeFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	resetPassword?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IncidentKeySpecifier = ('geoLat' | 'geoLong' | 'nrDrogi' | 'objazd' | 'position' | 'rodzaj' | 'type' | IncidentKeySpecifier)[];
export type IncidentFieldPolicy = {
	geoLat?: FieldPolicy<any> | FieldReadFunction<any>,
	geoLong?: FieldPolicy<any> | FieldReadFunction<any>,
	nrDrogi?: FieldPolicy<any> | FieldReadFunction<any>,
	objazd?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	rodzaj?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IncidentTypeKeySpecifier = ('poz' | IncidentTypeKeySpecifier)[];
export type IncidentTypeFieldPolicy = {
	poz?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KeyValueTypeKeySpecifier = ('key' | 'value' | KeyValueTypeKeySpecifier)[];
export type KeyValueTypeFieldPolicy = {
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LegacyKeySpecifier = ('fleetType' | 'hasAssist' | 'licencePlan' | LegacyKeySpecifier)[];
export type LegacyFieldPolicy = {
	fleetType?: FieldPolicy<any> | FieldReadFunction<any>,
	hasAssist?: FieldPolicy<any> | FieldReadFunction<any>,
	licencePlan?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LegacyAlertsModuleKeySpecifier = ('enabled' | LegacyAlertsModuleKeySpecifier)[];
export type LegacyAlertsModuleFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LegacyAssistModuleKeySpecifier = ('enabled' | LegacyAssistModuleKeySpecifier)[];
export type LegacyAssistModuleFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LegacyHistoryModuleKeySpecifier = ('availabilityTime' | 'enabled' | LegacyHistoryModuleKeySpecifier)[];
export type LegacyHistoryModuleFieldPolicy = {
	availabilityTime?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LegacyReportsModuleKeySpecifier = ('enabled' | LegacyReportsModuleKeySpecifier)[];
export type LegacyReportsModuleFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LegacyTemporaryLinksModuleKeySpecifier = ('enabled' | LegacyTemporaryLinksModuleKeySpecifier)[];
export type LegacyTemporaryLinksModuleFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LoadPartKeySpecifier = ('avgAxleLoad' | 'avgTotalLoad' | LoadPartKeySpecifier)[];
export type LoadPartFieldPolicy = {
	avgAxleLoad?: FieldPolicy<any> | FieldReadFunction<any>,
	avgTotalLoad?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MapModuleClientSettingsKeySpecifier = ('hiSpeedBig' | 'hiSpeedSmall' | 'layingLabels' | 'lowSpeedBig' | 'lowSpeedSmall' | 'rosaVentorum' | 'showStopAfter' | 'transparentLblBgColor' | 'unifyLabelsColor' | MapModuleClientSettingsKeySpecifier)[];
export type MapModuleClientSettingsFieldPolicy = {
	hiSpeedBig?: FieldPolicy<any> | FieldReadFunction<any>,
	hiSpeedSmall?: FieldPolicy<any> | FieldReadFunction<any>,
	layingLabels?: FieldPolicy<any> | FieldReadFunction<any>,
	lowSpeedBig?: FieldPolicy<any> | FieldReadFunction<any>,
	lowSpeedSmall?: FieldPolicy<any> | FieldReadFunction<any>,
	rosaVentorum?: FieldPolicy<any> | FieldReadFunction<any>,
	showStopAfter?: FieldPolicy<any> | FieldReadFunction<any>,
	transparentLblBgColor?: FieldPolicy<any> | FieldReadFunction<any>,
	unifyLabelsColor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MapModuleClientSettingsResponseKeySpecifier = ('configuration' | MapModuleClientSettingsResponseKeySpecifier)[];
export type MapModuleClientSettingsResponseFieldPolicy = {
	configuration?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MapModuleIncidentsListResponseKeySpecifier = ('trafficCongestion' | MapModuleIncidentsListResponseKeySpecifier)[];
export type MapModuleIncidentsListResponseFieldPolicy = {
	trafficCongestion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MapModuleUserPointGroupsResponseKeySpecifier = ('userPointGroups' | MapModuleUserPointGroupsResponseKeySpecifier)[];
export type MapModuleUserPointGroupsResponseFieldPolicy = {
	userPointGroups?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MapModuleUserPointsResponseKeySpecifier = ('userPointGroup' | MapModuleUserPointsResponseKeySpecifier)[];
export type MapModuleUserPointsResponseFieldPolicy = {
	userPointGroup?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MapModuleUserSettingsKeySpecifier = ('list' | MapModuleUserSettingsKeySpecifier)[];
export type MapModuleUserSettingsFieldPolicy = {
	list?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MapModuleUserSettingsListKeySpecifier = ('vehicleDetails' | 'vehicleInfo' | 'vehicleTitle' | MapModuleUserSettingsListKeySpecifier)[];
export type MapModuleUserSettingsListFieldPolicy = {
	vehicleDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleTitle?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MapModuleUserSettingsListVehicleDetailsKeySpecifier = ('address' | 'currentEtaMonitor' | 'driverName' | MapModuleUserSettingsListVehicleDetailsKeySpecifier)[];
export type MapModuleUserSettingsListVehicleDetailsFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	currentEtaMonitor?: FieldPolicy<any> | FieldReadFunction<any>,
	driverName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MapModuleUserSettingsListVehicleInfoKeySpecifier = ('batteryVoltage' | 'fuel' | 'speed' | 'totalLoad' | MapModuleUserSettingsListVehicleInfoKeySpecifier)[];
export type MapModuleUserSettingsListVehicleInfoFieldPolicy = {
	batteryVoltage?: FieldPolicy<any> | FieldReadFunction<any>,
	fuel?: FieldPolicy<any> | FieldReadFunction<any>,
	speed?: FieldPolicy<any> | FieldReadFunction<any>,
	totalLoad?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MapModuleUserSettingsListVehicleTitleKeySpecifier = ('name' | 'registration' | MapModuleUserSettingsListVehicleTitleKeySpecifier)[];
export type MapModuleUserSettingsListVehicleTitleFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	registration?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MapModuleUserSettingsResponseKeySpecifier = ('userSettings' | MapModuleUserSettingsResponseKeySpecifier)[];
export type MapModuleUserSettingsResponseFieldPolicy = {
	userSettings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MeKeySpecifier = ('apiAccounts' | 'auth' | 'customerArea' | 'drivers' | 'ecoDriving' | 'etaLight' | 'etaLightTasks' | 'featureFlags' | 'fullName' | 'id' | 'isInternal' | 'isJoint' | 'name' | 'orderTasks' | 'settings' | 'tachoRemote' | 'tasks' | 'vehicle' | 'vehicleTypes' | 'vehicles' | 'vehiclesGroups' | MeKeySpecifier)[];
export type MeFieldPolicy = {
	apiAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	auth?: FieldPolicy<any> | FieldReadFunction<any>,
	customerArea?: FieldPolicy<any> | FieldReadFunction<any>,
	drivers?: FieldPolicy<any> | FieldReadFunction<any>,
	ecoDriving?: FieldPolicy<any> | FieldReadFunction<any>,
	etaLight?: FieldPolicy<any> | FieldReadFunction<any>,
	etaLightTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	featureFlags?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isInternal?: FieldPolicy<any> | FieldReadFunction<any>,
	isJoint?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	orderTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	tachoRemote?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicle?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicles?: FieldPolicy<any> | FieldReadFunction<any>,
	vehiclesGroups?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MobilityPackageModuleKeySpecifier = ('enabled' | 'foreignWage' | MobilityPackageModuleKeySpecifier)[];
export type MobilityPackageModuleFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	foreignWage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('cargo' | 'clientId' | 'driver' | 'ecoDriving' | 'etaLightTask' | 'gboxAuthorizationAccount' | 'mapModuleSettings' | 'mapModuleUserPoints' | 'partnerAccount' | 'tachoRemote' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	cargo?: FieldPolicy<any> | FieldReadFunction<any>,
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	driver?: FieldPolicy<any> | FieldReadFunction<any>,
	ecoDriving?: FieldPolicy<any> | FieldReadFunction<any>,
	etaLightTask?: FieldPolicy<any> | FieldReadFunction<any>,
	gboxAuthorizationAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	mapModuleSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	mapModuleUserPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	tachoRemote?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NullResponseKeySpecifier = ('content' | NullResponseKeySpecifier)[];
export type NullResponseFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderKeySpecifier = ('clientId' | 'customer' | 'driverId' | 'id' | 'legacyId' | 'number' | 'vehicle' | 'vehicleId' | OrderKeySpecifier)[];
export type OrderFieldPolicy = {
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	customer?: FieldPolicy<any> | FieldReadFunction<any>,
	driverId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyId?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicle?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderTaskKeySpecifier = ('arriveTimeEnd' | 'attachments' | 'attachmentsCount' | 'clientId' | 'createdAt' | 'eta' | 'etaTimeStatus' | 'finishNote' | 'finishedAt' | 'id' | 'isCalculated' | 'isCanceled' | 'isEndangered' | 'isEtaLightSource' | 'isExceeded' | 'isOk' | 'isOrderTaskSource' | 'isUnknown' | 'legacyId' | 'name' | 'note' | 'order' | 'orderId' | 'payloads' | 'sourceId' | 'state' | 'status' | 'target' | 'type' | OrderTaskKeySpecifier)[];
export type OrderTaskFieldPolicy = {
	arriveTimeEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	attachments?: FieldPolicy<any> | FieldReadFunction<any>,
	attachmentsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	eta?: FieldPolicy<any> | FieldReadFunction<any>,
	etaTimeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	finishNote?: FieldPolicy<any> | FieldReadFunction<any>,
	finishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isCalculated?: FieldPolicy<any> | FieldReadFunction<any>,
	isCanceled?: FieldPolicy<any> | FieldReadFunction<any>,
	isEndangered?: FieldPolicy<any> | FieldReadFunction<any>,
	isEtaLightSource?: FieldPolicy<any> | FieldReadFunction<any>,
	isExceeded?: FieldPolicy<any> | FieldReadFunction<any>,
	isOk?: FieldPolicy<any> | FieldReadFunction<any>,
	isOrderTaskSource?: FieldPolicy<any> | FieldReadFunction<any>,
	isUnknown?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderId?: FieldPolicy<any> | FieldReadFunction<any>,
	payloads?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceId?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	target?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrdersModuleKeySpecifier = ('archivePermissions' | 'archived' | 'calendar' | 'deprecated' | 'enabled' | 'eta' | 'etaVehicles' | OrdersModuleKeySpecifier)[];
export type OrdersModuleFieldPolicy = {
	archivePermissions?: FieldPolicy<any> | FieldReadFunction<any>,
	archived?: FieldPolicy<any> | FieldReadFunction<any>,
	calendar?: FieldPolicy<any> | FieldReadFunction<any>,
	deprecated?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	eta?: FieldPolicy<any> | FieldReadFunction<any>,
	etaVehicles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginationResultTypeKeySpecifier = ('itemsCount' | 'page' | 'pageCount' | 'pageSize' | PaginationResultTypeKeySpecifier)[];
export type PaginationResultTypeFieldPolicy = {
	itemsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCount?: FieldPolicy<any> | FieldReadFunction<any>,
	pageSize?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PartnerAccountKeySpecifier = ('id' | 'login' | 'type' | PartnerAccountKeySpecifier)[];
export type PartnerAccountFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	login?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PartnerAccountMutationTypeKeySpecifier = ('create' | 'resetPassword' | PartnerAccountMutationTypeKeySpecifier)[];
export type PartnerAccountMutationTypeFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	resetPassword?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadKeySpecifier = ('amount' | 'name' | 'unit' | PayloadKeySpecifier)[];
export type PayloadFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('client' | 'client4trans' | 'clientId' | 'mapModuleClientSettings' | 'mapModuleIncidentsList' | 'mapModuleUserPointGroups' | 'mapModuleUserPoints' | 'mapModuleUserSettings' | 'me' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	client?: FieldPolicy<any> | FieldReadFunction<any>,
	client4trans?: FieldPolicy<any> | FieldReadFunction<any>,
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	mapModuleClientSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	mapModuleIncidentsList?: FieldPolicy<any> | FieldReadFunction<any>,
	mapModuleUserPointGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	mapModuleUserPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	mapModuleUserSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	me?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RPMDistributionKeySpecifier = ('aboveNorm' | 'belowNorm' | 'inNorm' | RPMDistributionKeySpecifier)[];
export type RPMDistributionFieldPolicy = {
	aboveNorm?: FieldPolicy<any> | FieldReadFunction<any>,
	belowNorm?: FieldPolicy<any> | FieldReadFunction<any>,
	inNorm?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ResetGboxAuthorizationAccountPasswordMutationTypeKeySpecifier = ('id' | 'login' | 'password' | 'type' | ResetGboxAuthorizationAccountPasswordMutationTypeKeySpecifier)[];
export type ResetGboxAuthorizationAccountPasswordMutationTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	login?: FieldPolicy<any> | FieldReadFunction<any>,
	password?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ResetPartnerAccountPasswordMutationTypeKeySpecifier = ('id' | 'login' | 'password' | 'type' | ResetPartnerAccountPasswordMutationTypeKeySpecifier)[];
export type ResetPartnerAccountPasswordMutationTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	login?: FieldPolicy<any> | FieldReadFunction<any>,
	password?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SettingsKeySpecifier = ('ecoDriving' | 'legacy' | 'system' | SettingsKeySpecifier)[];
export type SettingsFieldPolicy = {
	ecoDriving?: FieldPolicy<any> | FieldReadFunction<any>,
	legacy?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StopOnEngineKeySpecifier = ('duration' | 'percent' | StopOnEngineKeySpecifier)[];
export type StopOnEngineFieldPolicy = {
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	percent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SystemKeySpecifier = ('apiAccounts' | 'driverApp' | 'ecoDriving' | 'etaLight' | 'etoll' | 'fireTms' | 'fleet' | 'legacyAlerts' | 'legacyAssist' | 'legacyHistory' | 'legacyReports' | 'legacyTemporaryLinks' | 'mobilityPackage' | 'orders' | 'tachoRemote' | 'tachoRemote2' | 'tasks' | 'workTime' | SystemKeySpecifier)[];
export type SystemFieldPolicy = {
	apiAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	driverApp?: FieldPolicy<any> | FieldReadFunction<any>,
	ecoDriving?: FieldPolicy<any> | FieldReadFunction<any>,
	etaLight?: FieldPolicy<any> | FieldReadFunction<any>,
	etoll?: FieldPolicy<any> | FieldReadFunction<any>,
	fireTms?: FieldPolicy<any> | FieldReadFunction<any>,
	fleet?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyAlerts?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyAssist?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyReports?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyTemporaryLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	mobilityPackage?: FieldPolicy<any> | FieldReadFunction<any>,
	orders?: FieldPolicy<any> | FieldReadFunction<any>,
	tachoRemote?: FieldPolicy<any> | FieldReadFunction<any>,
	tachoRemote2?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	workTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemote2ModuleKeySpecifier = ('configured' | 'enabled' | 'launched' | 'migrated' | TachoRemote2ModuleKeySpecifier)[];
export type TachoRemote2ModuleFieldPolicy = {
	configured?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	launched?: FieldPolicy<any> | FieldReadFunction<any>,
	migrated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteActionMessageMutationTypeKeySpecifier = ('code' | 'fullName' | 'id' | 'message' | TachoRemoteActionMessageMutationTypeKeySpecifier)[];
export type TachoRemoteActionMessageMutationTypeFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteAuthorizationAppCompanyCardDataTypeKeySpecifier = ('countryCode' | 'countryCodeLabel' | 'name' | 'number' | 'serialNo' | TachoRemoteAuthorizationAppCompanyCardDataTypeKeySpecifier)[];
export type TachoRemoteAuthorizationAppCompanyCardDataTypeFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCodeLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	serialNo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteAuthorizationAppMutationTypeKeySpecifier = ('deactivateAuthorizationApp' | TachoRemoteAuthorizationAppMutationTypeKeySpecifier)[];
export type TachoRemoteAuthorizationAppMutationTypeFieldPolicy = {
	deactivateAuthorizationApp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteAuthorizationAppTypeKeySpecifier = ('companyCards' | 'id' | 'ip' | 'lastContact' | 'name' | 'server' | 'status' | TachoRemoteAuthorizationAppTypeKeySpecifier)[];
export type TachoRemoteAuthorizationAppTypeFieldPolicy = {
	companyCards?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	ip?: FieldPolicy<any> | FieldReadFunction<any>,
	lastContact?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	server?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteAuthorizationAppsResultTypeKeySpecifier = ('data' | TachoRemoteAuthorizationAppsResultTypeKeySpecifier)[];
export type TachoRemoteAuthorizationAppsResultTypeFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteClientMutationTypeKeySpecifier = ('supportForMultipleCompany' | TachoRemoteClientMutationTypeKeySpecifier)[];
export type TachoRemoteClientMutationTypeFieldPolicy = {
	supportForMultipleCompany?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteClientTypeKeySpecifier = ('hasSupportForMultipleCompany' | 'isConfigured' | 'isEnabled' | 'numberOfCompanies' | TachoRemoteClientTypeKeySpecifier)[];
export type TachoRemoteClientTypeFieldPolicy = {
	hasSupportForMultipleCompany?: FieldPolicy<any> | FieldReadFunction<any>,
	isConfigured?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfCompanies?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteCompaniesResultTypeKeySpecifier = ('data' | TachoRemoteCompaniesResultTypeKeySpecifier)[];
export type TachoRemoteCompaniesResultTypeFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteCompanyCardConnectionTypeKeySpecifier = ('ip' | 'reader' | 'server' | TachoRemoteCompanyCardConnectionTypeKeySpecifier)[];
export type TachoRemoteCompanyCardConnectionTypeFieldPolicy = {
	ip?: FieldPolicy<any> | FieldReadFunction<any>,
	reader?: FieldPolicy<any> | FieldReadFunction<any>,
	server?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteCompanyCardMutationTypeKeySpecifier = ('update' | TachoRemoteCompanyCardMutationTypeKeySpecifier)[];
export type TachoRemoteCompanyCardMutationTypeFieldPolicy = {
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteCompanyCardTypeKeySpecifier = ('active' | 'clientId' | 'companyId' | 'configuredAt' | 'connection' | 'countryCode' | 'countryCodeLabel' | 'expirationWarning' | 'expireDate' | 'expired' | 'generation' | 'name' | 'number' | 'serialNo' | 'status' | TachoRemoteCompanyCardTypeKeySpecifier)[];
export type TachoRemoteCompanyCardTypeFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	companyId?: FieldPolicy<any> | FieldReadFunction<any>,
	configuredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	connection?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCodeLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	expirationWarning?: FieldPolicy<any> | FieldReadFunction<any>,
	expireDate?: FieldPolicy<any> | FieldReadFunction<any>,
	expired?: FieldPolicy<any> | FieldReadFunction<any>,
	generation?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	serialNo?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteCompanyCardsResultTypeKeySpecifier = ('data' | TachoRemoteCompanyCardsResultTypeKeySpecifier)[];
export type TachoRemoteCompanyCardsResultTypeFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteCompanyMutationTypeKeySpecifier = ('assignVehicles' | 'create' | 'delete' | 'update' | TachoRemoteCompanyMutationTypeKeySpecifier)[];
export type TachoRemoteCompanyMutationTypeFieldPolicy = {
	assignVehicles?: FieldPolicy<any> | FieldReadFunction<any>,
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteCompanyTypeKeySpecifier = ('companyCardSerialNumbers' | 'id' | 'name' | 'numberOfVehicles' | TachoRemoteCompanyTypeKeySpecifier)[];
export type TachoRemoteCompanyTypeFieldPolicy = {
	companyCardSerialNumbers?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfVehicles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteCompanyVehiclesMutationTypeKeySpecifier = ('messages' | TachoRemoteCompanyVehiclesMutationTypeKeySpecifier)[];
export type TachoRemoteCompanyVehiclesMutationTypeFieldPolicy = {
	messages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteCreateCompanyMutationTypeKeySpecifier = ('companyCardSerialNumbers' | 'id' | 'name' | 'numberOfVehicles' | TachoRemoteCreateCompanyMutationTypeKeySpecifier)[];
export type TachoRemoteCreateCompanyMutationTypeFieldPolicy = {
	companyCardSerialNumbers?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfVehicles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteDeactivateAuthorizationAppMutationTypeKeySpecifier = ('messages' | TachoRemoteDeactivateAuthorizationAppMutationTypeKeySpecifier)[];
export type TachoRemoteDeactivateAuthorizationAppMutationTypeFieldPolicy = {
	messages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteDeleteCompanyMutationTypeKeySpecifier = ('status' | TachoRemoteDeleteCompanyMutationTypeKeySpecifier)[];
export type TachoRemoteDeleteCompanyMutationTypeFieldPolicy = {
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteDriverCardMetaTypeKeySpecifier = ('suspendedCount' | TachoRemoteDriverCardMetaTypeKeySpecifier)[];
export type TachoRemoteDriverCardMetaTypeFieldPolicy = {
	suspendedCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteDriverCardMutationTypeKeySpecifier = ('additionalReads' | 'suspendReads' | 'unsuspendReads' | TachoRemoteDriverCardMutationTypeKeySpecifier)[];
export type TachoRemoteDriverCardMutationTypeFieldPolicy = {
	additionalReads?: FieldPolicy<any> | FieldReadFunction<any>,
	suspendReads?: FieldPolicy<any> | FieldReadFunction<any>,
	unsuspendReads?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteDriverCardReadAdditionalReadOrdersMutationTypeKeySpecifier = ('messages' | TachoRemoteDriverCardReadAdditionalReadOrdersMutationTypeKeySpecifier)[];
export type TachoRemoteDriverCardReadAdditionalReadOrdersMutationTypeFieldPolicy = {
	messages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteDriverCardReadLastReadTypeKeySpecifier = ('date' | 'delayStatus' | 'status' | 'type' | TachoRemoteDriverCardReadLastReadTypeKeySpecifier)[];
export type TachoRemoteDriverCardReadLastReadTypeFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	delayStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteDriverCardReadNextReadTypeKeySpecifier = ('date' | 'type' | TachoRemoteDriverCardReadNextReadTypeKeySpecifier)[];
export type TachoRemoteDriverCardReadNextReadTypeFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteDriverCardReadStatusTypeKeySpecifier = ('driverCard' | 'firstName' | 'id' | 'lastContact' | 'lastName' | 'lastRead' | 'nextRead' | 'suspended' | 'warnings' | TachoRemoteDriverCardReadStatusTypeKeySpecifier)[];
export type TachoRemoteDriverCardReadStatusTypeFieldPolicy = {
	driverCard?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastContact?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastRead?: FieldPolicy<any> | FieldReadFunction<any>,
	nextRead?: FieldPolicy<any> | FieldReadFunction<any>,
	suspended?: FieldPolicy<any> | FieldReadFunction<any>,
	warnings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteDriverCardReadStatusesResultTypeKeySpecifier = ('data' | 'matched' | 'meta' | TachoRemoteDriverCardReadStatusesResultTypeKeySpecifier)[];
export type TachoRemoteDriverCardReadStatusesResultTypeFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	matched?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteDriverCardReadTypeKeySpecifier = ('driverCard' | 'driverFirstName' | 'driverLastName' | 'fileId' | 'generatedAt' | 'id' | 'reason' | 'source' | 'vehicleRegistrationNumber' | 'warnings' | TachoRemoteDriverCardReadTypeKeySpecifier)[];
export type TachoRemoteDriverCardReadTypeFieldPolicy = {
	driverCard?: FieldPolicy<any> | FieldReadFunction<any>,
	driverFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	driverLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	generatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleRegistrationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	warnings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteDriverCardReadsResultTypeKeySpecifier = ('data' | 'matched' | 'meta' | TachoRemoteDriverCardReadsResultTypeKeySpecifier)[];
export type TachoRemoteDriverCardReadsResultTypeFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	matched?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteDriverCardTypeKeySpecifier = ('meta' | 'reads' | 'statuses' | TachoRemoteDriverCardTypeKeySpecifier)[];
export type TachoRemoteDriverCardTypeFieldPolicy = {
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	reads?: FieldPolicy<any> | FieldReadFunction<any>,
	statuses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteFileTypeKeySpecifier = ('fileId' | 'id' | TachoRemoteFileTypeKeySpecifier)[];
export type TachoRemoteFileTypeFieldPolicy = {
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteModuleKeySpecifier = ('enabled' | 'hadEnabled' | TachoRemoteModuleKeySpecifier)[];
export type TachoRemoteModuleFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	hadEnabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteMutationTypeKeySpecifier = ('authorizationApp' | 'client' | 'company' | 'companyCard' | 'driverCardRead' | 'tachographRead' | TachoRemoteMutationTypeKeySpecifier)[];
export type TachoRemoteMutationTypeFieldPolicy = {
	authorizationApp?: FieldPolicy<any> | FieldReadFunction<any>,
	client?: FieldPolicy<any> | FieldReadFunction<any>,
	company?: FieldPolicy<any> | FieldReadFunction<any>,
	companyCard?: FieldPolicy<any> | FieldReadFunction<any>,
	driverCardRead?: FieldPolicy<any> | FieldReadFunction<any>,
	tachographRead?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteStatusMessageTypeKeySpecifier = ('code' | 'target' | TachoRemoteStatusMessageTypeKeySpecifier)[];
export type TachoRemoteStatusMessageTypeFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	target?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteStatusTypeKeySpecifier = ('messages' | 'state' | TachoRemoteStatusTypeKeySpecifier)[];
export type TachoRemoteStatusTypeFieldPolicy = {
	messages?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteSupportForMultipleCompanyMutationTypeKeySpecifier = ('messages' | TachoRemoteSupportForMultipleCompanyMutationTypeKeySpecifier)[];
export type TachoRemoteSupportForMultipleCompanyMutationTypeFieldPolicy = {
	messages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteSuspendReadsMutationTypeKeySpecifier = ('messages' | TachoRemoteSuspendReadsMutationTypeKeySpecifier)[];
export type TachoRemoteSuspendReadsMutationTypeFieldPolicy = {
	messages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteTachographMetaTypeKeySpecifier = ('maxAdditionalReadOrders' | 'suspendedCount' | TachoRemoteTachographMetaTypeKeySpecifier)[];
export type TachoRemoteTachographMetaTypeFieldPolicy = {
	maxAdditionalReadOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	suspendedCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteTachographMutationTypeKeySpecifier = ('additionalReads' | 'suspendReads' | 'unsuspendReads' | TachoRemoteTachographMutationTypeKeySpecifier)[];
export type TachoRemoteTachographMutationTypeFieldPolicy = {
	additionalReads?: FieldPolicy<any> | FieldReadFunction<any>,
	suspendReads?: FieldPolicy<any> | FieldReadFunction<any>,
	unsuspendReads?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteTachographReadAdditionalReadOrdersMutationTypeKeySpecifier = ('messages' | TachoRemoteTachographReadAdditionalReadOrdersMutationTypeKeySpecifier)[];
export type TachoRemoteTachographReadAdditionalReadOrdersMutationTypeFieldPolicy = {
	messages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteTachographReadLastReadTypeKeySpecifier = ('date' | 'delayStatus' | 'from' | 'status' | 'to' | 'type' | TachoRemoteTachographReadLastReadTypeKeySpecifier)[];
export type TachoRemoteTachographReadLastReadTypeFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	delayStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	from?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	to?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteTachographReadNextReadTypeKeySpecifier = ('date' | 'type' | TachoRemoteTachographReadNextReadTypeKeySpecifier)[];
export type TachoRemoteTachographReadNextReadTypeFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteTachographReadStatusTypeKeySpecifier = ('additionalReadOrdersCount' | 'id' | 'lastContact' | 'lastRead' | 'name' | 'nextRead' | 'registrationNumber' | 'suspended' | 'warnings' | TachoRemoteTachographReadStatusTypeKeySpecifier)[];
export type TachoRemoteTachographReadStatusTypeFieldPolicy = {
	additionalReadOrdersCount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastContact?: FieldPolicy<any> | FieldReadFunction<any>,
	lastRead?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nextRead?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	suspended?: FieldPolicy<any> | FieldReadFunction<any>,
	warnings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteTachographReadStatusesResultTypeKeySpecifier = ('data' | 'matched' | 'meta' | TachoRemoteTachographReadStatusesResultTypeKeySpecifier)[];
export type TachoRemoteTachographReadStatusesResultTypeFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	matched?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteTachographReadTypeKeySpecifier = ('fileId' | 'generatedAt' | 'id' | 'readFrom' | 'readTo' | 'reason' | 'source' | 'vehicleName' | 'vehicleRegistrationNumber' | 'warnings' | TachoRemoteTachographReadTypeKeySpecifier)[];
export type TachoRemoteTachographReadTypeFieldPolicy = {
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	generatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	readFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	readTo?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleName?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleRegistrationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	warnings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteTachographReadsResultTypeKeySpecifier = ('data' | 'matched' | 'meta' | TachoRemoteTachographReadsResultTypeKeySpecifier)[];
export type TachoRemoteTachographReadsResultTypeFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	matched?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteTachographTypeKeySpecifier = ('meta' | 'reads' | 'statuses' | TachoRemoteTachographTypeKeySpecifier)[];
export type TachoRemoteTachographTypeFieldPolicy = {
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	reads?: FieldPolicy<any> | FieldReadFunction<any>,
	statuses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteTypeKeySpecifier = ('authorizationApps' | 'client' | 'companies' | 'companyCards' | 'driverCard' | 'files' | 'status' | 'tachograph' | 'vehicles' | TachoRemoteTypeKeySpecifier)[];
export type TachoRemoteTypeFieldPolicy = {
	authorizationApps?: FieldPolicy<any> | FieldReadFunction<any>,
	client?: FieldPolicy<any> | FieldReadFunction<any>,
	companies?: FieldPolicy<any> | FieldReadFunction<any>,
	companyCards?: FieldPolicy<any> | FieldReadFunction<any>,
	driverCard?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tachograph?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteUnsuspendReadsMutationTypeKeySpecifier = ('messages' | TachoRemoteUnsuspendReadsMutationTypeKeySpecifier)[];
export type TachoRemoteUnsuspendReadsMutationTypeFieldPolicy = {
	messages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteUpdateCompanyCardMutationTypeKeySpecifier = ('active' | 'clientId' | 'companyId' | 'configuredAt' | 'connected' | 'countryCode' | 'expireDate' | 'generation' | 'name' | 'number' | 'serialNo' | TachoRemoteUpdateCompanyCardMutationTypeKeySpecifier)[];
export type TachoRemoteUpdateCompanyCardMutationTypeFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	companyId?: FieldPolicy<any> | FieldReadFunction<any>,
	configuredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	connected?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	expireDate?: FieldPolicy<any> | FieldReadFunction<any>,
	generation?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	serialNo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteUpdateCompanyMutationTypeKeySpecifier = ('companyCardSerialNumbers' | 'id' | 'name' | 'numberOfVehicles' | TachoRemoteUpdateCompanyMutationTypeKeySpecifier)[];
export type TachoRemoteUpdateCompanyMutationTypeFieldPolicy = {
	companyCardSerialNumbers?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfVehicles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteVehicleTypeKeySpecifier = ('companyId' | 'companyName' | 'id' | 'name' | 'registrationNumber' | TachoRemoteVehicleTypeKeySpecifier)[];
export type TachoRemoteVehicleTypeFieldPolicy = {
	companyId?: FieldPolicy<any> | FieldReadFunction<any>,
	companyName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteVehiclesTypeKeySpecifier = ('data' | TachoRemoteVehiclesTypeKeySpecifier)[];
export type TachoRemoteVehiclesTypeFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TachoRemoteWarningTypeKeySpecifier = ('code' | 'meta' | TachoRemoteWarningTypeKeySpecifier)[];
export type TachoRemoteWarningTypeFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TargetTypeKeySpecifier = ('address' | 'coords' | 'id' | TargetTypeKeySpecifier)[];
export type TargetTypeFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	coords?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskKeySpecifier = ('arriveTimeEnd' | 'attachments' | 'attachmentsCount' | 'clientId' | 'createdAt' | 'createdByUserId' | 'driver' | 'driverId' | 'eta' | 'finishNote' | 'finishedAt' | 'id' | 'name' | 'note' | 'state' | 'status' | 'target' | TaskKeySpecifier)[];
export type TaskFieldPolicy = {
	arriveTimeEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	attachments?: FieldPolicy<any> | FieldReadFunction<any>,
	attachmentsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	driver?: FieldPolicy<any> | FieldReadFunction<any>,
	driverId?: FieldPolicy<any> | FieldReadFunction<any>,
	eta?: FieldPolicy<any> | FieldReadFunction<any>,
	finishNote?: FieldPolicy<any> | FieldReadFunction<any>,
	finishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	target?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskAttachmentKeySpecifier = ('filename' | 'id' | 'size' | 'type' | 'uploadedAt' | TaskAttachmentKeySpecifier)[];
export type TaskAttachmentFieldPolicy = {
	filename?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TasksModuleKeySpecifier = ('enabled' | TasksModuleKeySpecifier)[];
export type TasksModuleFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDriverMutationTypeKeySpecifier = ('clientId' | 'driverCard' | 'driverIdentificationNumber' | 'firstName' | 'id' | 'lastName' | 'phone' | 'pin' | 'username' | 'uuid' | 'workNumber' | UpdateDriverMutationTypeKeySpecifier)[];
export type UpdateDriverMutationTypeFieldPolicy = {
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	driverCard?: FieldPolicy<any> | FieldReadFunction<any>,
	driverIdentificationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	pin?: FieldPolicy<any> | FieldReadFunction<any>,
	username?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	workNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsageTypeKeySpecifier = ('count' | 'monthlyLimit' | 'vehicleId' | UsageTypeKeySpecifier)[];
export type UsageTypeFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	monthlyLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserPointKeySpecifier = ('address' | 'filepath' | 'iconName' | 'name' | 'position' | UserPointKeySpecifier)[];
export type UserPointFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	filepath?: FieldPolicy<any> | FieldReadFunction<any>,
	iconName?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserPointGroupKeySpecifier = ('id' | 'name' | 'userPoints' | UserPointGroupKeySpecifier)[];
export type UserPointGroupFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	userPoints?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserPointPositionKeySpecifier = ('latitude' | 'longitude' | UserPointPositionKeySpecifier)[];
export type UserPointPositionFieldPolicy = {
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleKeySpecifier = ('appearance' | 'assistDevice' | 'authorizedDrivers' | 'boxId' | 'brand' | 'communication' | 'current' | 'currentDriver' | 'currentEtaMonitors' | 'defaultGroup' | 'devices' | 'driverCardReadingSource' | 'driverStatus' | 'drivers' | 'ecoDrivingGroup' | 'etaLightTasks' | 'etaMonitors' | 'etaOrderTasks' | 'fleetTypes' | 'groups' | 'hasAssist' | 'hasAuthorizedDrivers' | 'hasEtaLightMonitors' | 'hasOBU' | 'hasWorkingTimeSource' | 'id' | 'identifiedDrivers' | 'isBig' | 'isTrailer' | 'kind' | 'label' | 'model' | 'name' | 'profile' | 'registrationNumber' | 'translatorTacho' | 'type' | 'workingTimeSource' | 'yearOfProduction' | VehicleKeySpecifier)[];
export type VehicleFieldPolicy = {
	appearance?: FieldPolicy<any> | FieldReadFunction<any>,
	assistDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	authorizedDrivers?: FieldPolicy<any> | FieldReadFunction<any>,
	boxId?: FieldPolicy<any> | FieldReadFunction<any>,
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	communication?: FieldPolicy<any> | FieldReadFunction<any>,
	current?: FieldPolicy<any> | FieldReadFunction<any>,
	currentDriver?: FieldPolicy<any> | FieldReadFunction<any>,
	currentEtaMonitors?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	devices?: FieldPolicy<any> | FieldReadFunction<any>,
	driverCardReadingSource?: FieldPolicy<any> | FieldReadFunction<any>,
	driverStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	drivers?: FieldPolicy<any> | FieldReadFunction<any>,
	ecoDrivingGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	etaLightTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	etaMonitors?: FieldPolicy<any> | FieldReadFunction<any>,
	etaOrderTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	fleetTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	hasAssist?: FieldPolicy<any> | FieldReadFunction<any>,
	hasAuthorizedDrivers?: FieldPolicy<any> | FieldReadFunction<any>,
	hasEtaLightMonitors?: FieldPolicy<any> | FieldReadFunction<any>,
	hasOBU?: FieldPolicy<any> | FieldReadFunction<any>,
	hasWorkingTimeSource?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	identifiedDrivers?: FieldPolicy<any> | FieldReadFunction<any>,
	isBig?: FieldPolicy<any> | FieldReadFunction<any>,
	isTrailer?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	profile?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	translatorTacho?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	workingTimeSource?: FieldPolicy<any> | FieldReadFunction<any>,
	yearOfProduction?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleAppearanceTypeKeySpecifier = ('dynamicIcon' | 'iconId' | 'registrationNumberAsName' | VehicleAppearanceTypeKeySpecifier)[];
export type VehicleAppearanceTypeFieldPolicy = {
	dynamicIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	iconId?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationNumberAsName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleCurrentFuelKeySpecifier = ('tank1' | 'tank2' | 'total' | VehicleCurrentFuelKeySpecifier)[];
export type VehicleCurrentFuelFieldPolicy = {
	tank1?: FieldPolicy<any> | FieldReadFunction<any>,
	tank2?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleCurrentGpsKeySpecifier = ('address' | 'directionAngle' | 'lat' | 'lng' | VehicleCurrentGpsKeySpecifier)[];
export type VehicleCurrentGpsFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	directionAngle?: FieldPolicy<any> | FieldReadFunction<any>,
	lat?: FieldPolicy<any> | FieldReadFunction<any>,
	lng?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleCurrentTypeKeySpecifier = ('batteryVoltage' | 'engineOn' | 'fuel' | 'gps' | 'lastSignal' | 'press' | 'ride' | 'speed' | 'stopOnIgnitionDuration' | 'totalLoad' | VehicleCurrentTypeKeySpecifier)[];
export type VehicleCurrentTypeFieldPolicy = {
	batteryVoltage?: FieldPolicy<any> | FieldReadFunction<any>,
	engineOn?: FieldPolicy<any> | FieldReadFunction<any>,
	fuel?: FieldPolicy<any> | FieldReadFunction<any>,
	gps?: FieldPolicy<any> | FieldReadFunction<any>,
	lastSignal?: FieldPolicy<any> | FieldReadFunction<any>,
	press?: FieldPolicy<any> | FieldReadFunction<any>,
	ride?: FieldPolicy<any> | FieldReadFunction<any>,
	speed?: FieldPolicy<any> | FieldReadFunction<any>,
	stopOnIgnitionDuration?: FieldPolicy<any> | FieldReadFunction<any>,
	totalLoad?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleDataKeySpecifier = ('avgFuelConsumption' | 'dateRanges' | 'distance' | 'vehicle' | 'vehicleId' | VehicleDataKeySpecifier)[];
export type VehicleDataFieldPolicy = {
	avgFuelConsumption?: FieldPolicy<any> | FieldReadFunction<any>,
	dateRanges?: FieldPolicy<any> | FieldReadFunction<any>,
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicle?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleDeviceTypeKeySpecifier = ('boxId' | 'communicationStatus' | 'imei' | 'isOffline' | 'model' | 'obuName' | VehicleDeviceTypeKeySpecifier)[];
export type VehicleDeviceTypeFieldPolicy = {
	boxId?: FieldPolicy<any> | FieldReadFunction<any>,
	communicationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	imei?: FieldPolicy<any> | FieldReadFunction<any>,
	isOffline?: FieldPolicy<any> | FieldReadFunction<any>,
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	obuName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleExtendedKeySpecifier = ('appearance' | 'assistDevice' | 'authorizedDrivers' | 'boxId' | 'brand' | 'current' | 'currentDriver' | 'currentEtaMonitors' | 'defaultGroup' | 'devices' | 'driverCardReadingSource' | 'driverStatus' | 'drivers' | 'ecoDrivingGroup' | 'etaLightTasks' | 'etaMonitors' | 'etaOrderTasks' | 'fleetTypes' | 'fuelTanks' | 'groups' | 'hasAssist' | 'hasAuthorizedDrivers' | 'hasEtaLightMonitors' | 'hasOBU' | 'hasWorkingTimeSource' | 'id' | 'identifiedDrivers' | 'isBig' | 'isTrailer' | 'kind' | 'label' | 'model' | 'name' | 'profile' | 'registrationNumber' | 'translatorTacho' | 'type' | 'workingTimeSource' | 'yearOfProduction' | VehicleExtendedKeySpecifier)[];
export type VehicleExtendedFieldPolicy = {
	appearance?: FieldPolicy<any> | FieldReadFunction<any>,
	assistDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	authorizedDrivers?: FieldPolicy<any> | FieldReadFunction<any>,
	boxId?: FieldPolicy<any> | FieldReadFunction<any>,
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	current?: FieldPolicy<any> | FieldReadFunction<any>,
	currentDriver?: FieldPolicy<any> | FieldReadFunction<any>,
	currentEtaMonitors?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	devices?: FieldPolicy<any> | FieldReadFunction<any>,
	driverCardReadingSource?: FieldPolicy<any> | FieldReadFunction<any>,
	driverStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	drivers?: FieldPolicy<any> | FieldReadFunction<any>,
	ecoDrivingGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	etaLightTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	etaMonitors?: FieldPolicy<any> | FieldReadFunction<any>,
	etaOrderTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	fleetTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	fuelTanks?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	hasAssist?: FieldPolicy<any> | FieldReadFunction<any>,
	hasAuthorizedDrivers?: FieldPolicy<any> | FieldReadFunction<any>,
	hasEtaLightMonitors?: FieldPolicy<any> | FieldReadFunction<any>,
	hasOBU?: FieldPolicy<any> | FieldReadFunction<any>,
	hasWorkingTimeSource?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	identifiedDrivers?: FieldPolicy<any> | FieldReadFunction<any>,
	isBig?: FieldPolicy<any> | FieldReadFunction<any>,
	isTrailer?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	profile?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	translatorTacho?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	workingTimeSource?: FieldPolicy<any> | FieldReadFunction<any>,
	yearOfProduction?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleGroupTypeKeySpecifier = ('color' | 'description' | 'hexColor' | 'hexInvertedColor' | 'id' | 'name' | VehicleGroupTypeKeySpecifier)[];
export type VehicleGroupTypeFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	hexColor?: FieldPolicy<any> | FieldReadFunction<any>,
	hexInvertedColor?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleTypeKeySpecifier = ('axleLoad' | 'grossWeight' | 'height' | 'id' | 'length' | 'name' | 'trailersCount' | 'width' | VehicleTypeKeySpecifier)[];
export type VehicleTypeFieldPolicy = {
	axleLoad?: FieldPolicy<any> | FieldReadFunction<any>,
	grossWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	length?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	trailersCount?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WorkTimeActivityKeySpecifier = ('begin' | 'end' | 'type' | WorkTimeActivityKeySpecifier)[];
export type WorkTimeActivityFieldPolicy = {
	begin?: FieldPolicy<any> | FieldReadFunction<any>,
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WorkingTimeModuleKeySpecifier = ('enabled' | WorkingTimeModuleKeySpecifier)[];
export type WorkingTimeModuleFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	AcceleratePress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AcceleratePressKeySpecifier | (() => undefined | AcceleratePressKeySpecifier),
		fields?: AcceleratePressFieldPolicy,
	},
	ActivateDriverAppMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivateDriverAppMutationTypeKeySpecifier | (() => undefined | ActivateDriverAppMutationTypeKeySpecifier),
		fields?: ActivateDriverAppMutationTypeFieldPolicy,
	},
	ApiAccounts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ApiAccountsKeySpecifier | (() => undefined | ApiAccountsKeySpecifier),
		fields?: ApiAccountsFieldPolicy,
	},
	ApiAccountsModule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ApiAccountsModuleKeySpecifier | (() => undefined | ApiAccountsModuleKeySpecifier),
		fields?: ApiAccountsModuleFieldPolicy,
	},
	Auth?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuthKeySpecifier | (() => undefined | AuthKeySpecifier),
		fields?: AuthFieldPolicy,
	},
	AuthHereTokenType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuthHereTokenTypeKeySpecifier | (() => undefined | AuthHereTokenTypeKeySpecifier),
		fields?: AuthHereTokenTypeFieldPolicy,
	},
	CancelEtaLightTaskMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CancelEtaLightTaskMutationTypeKeySpecifier | (() => undefined | CancelEtaLightTaskMutationTypeKeySpecifier),
		fields?: CancelEtaLightTaskMutationTypeFieldPolicy,
	},
	CargoEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CargoEventKeySpecifier | (() => undefined | CargoEventKeySpecifier),
		fields?: CargoEventFieldPolicy,
	},
	CargoEventListPageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CargoEventListPageInfoKeySpecifier | (() => undefined | CargoEventListPageInfoKeySpecifier),
		fields?: CargoEventListPageInfoFieldPolicy,
	},
	CargoEvents?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CargoEventsKeySpecifier | (() => undefined | CargoEventsKeySpecifier),
		fields?: CargoEventsFieldPolicy,
	},
	CargoMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CargoMutationTypeKeySpecifier | (() => undefined | CargoMutationTypeKeySpecifier),
		fields?: CargoMutationTypeFieldPolicy,
	},
	Client?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClientKeySpecifier | (() => undefined | ClientKeySpecifier),
		fields?: ClientFieldPolicy,
	},
	Client4Trans?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | Client4TransKeySpecifier | (() => undefined | Client4TransKeySpecifier),
		fields?: Client4TransFieldPolicy,
	},
	Coordinate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CoordinateKeySpecifier | (() => undefined | CoordinateKeySpecifier),
		fields?: CoordinateFieldPolicy,
	},
	CreateCargoLoadingMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateCargoLoadingMutationTypeKeySpecifier | (() => undefined | CreateCargoLoadingMutationTypeKeySpecifier),
		fields?: CreateCargoLoadingMutationTypeFieldPolicy,
	},
	CreateCargoUnloadingMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateCargoUnloadingMutationTypeKeySpecifier | (() => undefined | CreateCargoUnloadingMutationTypeKeySpecifier),
		fields?: CreateCargoUnloadingMutationTypeFieldPolicy,
	},
	CreateDriverMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateDriverMutationTypeKeySpecifier | (() => undefined | CreateDriverMutationTypeKeySpecifier),
		fields?: CreateDriverMutationTypeFieldPolicy,
	},
	CreateEtaLightTaskMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateEtaLightTaskMutationTypeKeySpecifier | (() => undefined | CreateEtaLightTaskMutationTypeKeySpecifier),
		fields?: CreateEtaLightTaskMutationTypeFieldPolicy,
	},
	CreateGboxAuthorizationAccountMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateGboxAuthorizationAccountMutationTypeKeySpecifier | (() => undefined | CreateGboxAuthorizationAccountMutationTypeKeySpecifier),
		fields?: CreateGboxAuthorizationAccountMutationTypeFieldPolicy,
	},
	CreatePartnerAccountMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreatePartnerAccountMutationTypeKeySpecifier | (() => undefined | CreatePartnerAccountMutationTypeKeySpecifier),
		fields?: CreatePartnerAccountMutationTypeFieldPolicy,
	},
	CruiseControl?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CruiseControlKeySpecifier | (() => undefined | CruiseControlKeySpecifier),
		fields?: CruiseControlFieldPolicy,
	},
	Customer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerKeySpecifier | (() => undefined | CustomerKeySpecifier),
		fields?: CustomerFieldPolicy,
	},
	CustomerArea?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerAreaKeySpecifier | (() => undefined | CustomerAreaKeySpecifier),
		fields?: CustomerAreaFieldPolicy,
	},
	CustomerAreaContract?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerAreaContractKeySpecifier | (() => undefined | CustomerAreaContractKeySpecifier),
		fields?: CustomerAreaContractFieldPolicy,
	},
	CustomerAreaContractLicence?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerAreaContractLicenceKeySpecifier | (() => undefined | CustomerAreaContractLicenceKeySpecifier),
		fields?: CustomerAreaContractLicenceFieldPolicy,
	},
	CustomerAreaContractsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerAreaContractsResponseKeySpecifier | (() => undefined | CustomerAreaContractsResponseKeySpecifier),
		fields?: CustomerAreaContractsResponseFieldPolicy,
	},
	CustomerAreaPayment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerAreaPaymentKeySpecifier | (() => undefined | CustomerAreaPaymentKeySpecifier),
		fields?: CustomerAreaPaymentFieldPolicy,
	},
	CustomerAreaPaymentAmount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerAreaPaymentAmountKeySpecifier | (() => undefined | CustomerAreaPaymentAmountKeySpecifier),
		fields?: CustomerAreaPaymentAmountFieldPolicy,
	},
	DailyData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DailyDataKeySpecifier | (() => undefined | DailyDataKeySpecifier),
		fields?: DailyDataFieldPolicy,
	},
	DateRangeData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DateRangeDataKeySpecifier | (() => undefined | DateRangeDataKeySpecifier),
		fields?: DateRangeDataFieldPolicy,
	},
	DeactivateDriverAppMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeactivateDriverAppMutationTypeKeySpecifier | (() => undefined | DeactivateDriverAppMutationTypeKeySpecifier),
		fields?: DeactivateDriverAppMutationTypeFieldPolicy,
	},
	DeactivateDriverMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeactivateDriverMutationTypeKeySpecifier | (() => undefined | DeactivateDriverMutationTypeKeySpecifier),
		fields?: DeactivateDriverMutationTypeFieldPolicy,
	},
	DeprecatedEcoDrivingSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeprecatedEcoDrivingSettingsKeySpecifier | (() => undefined | DeprecatedEcoDrivingSettingsKeySpecifier),
		fields?: DeprecatedEcoDrivingSettingsFieldPolicy,
	},
	Driver?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DriverKeySpecifier | (() => undefined | DriverKeySpecifier),
		fields?: DriverFieldPolicy,
	},
	DriverAppModule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DriverAppModuleKeySpecifier | (() => undefined | DriverAppModuleKeySpecifier),
		fields?: DriverAppModuleFieldPolicy,
	},
	DriverCard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DriverCardKeySpecifier | (() => undefined | DriverCardKeySpecifier),
		fields?: DriverCardFieldPolicy,
	},
	DriverMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DriverMutationTypeKeySpecifier | (() => undefined | DriverMutationTypeKeySpecifier),
		fields?: DriverMutationTypeFieldPolicy,
	},
	DriverPhone?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DriverPhoneKeySpecifier | (() => undefined | DriverPhoneKeySpecifier),
		fields?: DriverPhoneFieldPolicy,
	},
	DriverStatusType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DriverStatusTypeKeySpecifier | (() => undefined | DriverStatusTypeKeySpecifier),
		fields?: DriverStatusTypeFieldPolicy,
	},
	DriverUnknown?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DriverUnknownKeySpecifier | (() => undefined | DriverUnknownKeySpecifier),
		fields?: DriverUnknownFieldPolicy,
	},
	DriverVehicleInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DriverVehicleInfoKeySpecifier | (() => undefined | DriverVehicleInfoKeySpecifier),
		fields?: DriverVehicleInfoFieldPolicy,
	},
	ETOLLModule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ETOLLModuleKeySpecifier | (() => undefined | ETOLLModuleKeySpecifier),
		fields?: ETOLLModuleFieldPolicy,
	},
	EcoDrivingAttachVehiclesToVehiclesGroupMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EcoDrivingAttachVehiclesToVehiclesGroupMutationTypeKeySpecifier | (() => undefined | EcoDrivingAttachVehiclesToVehiclesGroupMutationTypeKeySpecifier),
		fields?: EcoDrivingAttachVehiclesToVehiclesGroupMutationTypeFieldPolicy,
	},
	EcoDrivingCompanyMonthlyDataType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EcoDrivingCompanyMonthlyDataTypeKeySpecifier | (() => undefined | EcoDrivingCompanyMonthlyDataTypeKeySpecifier),
		fields?: EcoDrivingCompanyMonthlyDataTypeFieldPolicy,
	},
	EcoDrivingCompanyStatisticsType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EcoDrivingCompanyStatisticsTypeKeySpecifier | (() => undefined | EcoDrivingCompanyStatisticsTypeKeySpecifier),
		fields?: EcoDrivingCompanyStatisticsTypeFieldPolicy,
	},
	EcoDrivingCreateVehiclesGroupMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EcoDrivingCreateVehiclesGroupMutationTypeKeySpecifier | (() => undefined | EcoDrivingCreateVehiclesGroupMutationTypeKeySpecifier),
		fields?: EcoDrivingCreateVehiclesGroupMutationTypeFieldPolicy,
	},
	EcoDrivingDeleteVehiclesGroupMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EcoDrivingDeleteVehiclesGroupMutationTypeKeySpecifier | (() => undefined | EcoDrivingDeleteVehiclesGroupMutationTypeKeySpecifier),
		fields?: EcoDrivingDeleteVehiclesGroupMutationTypeFieldPolicy,
	},
	EcoDrivingDetachVehiclesToVehiclesGroupMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EcoDrivingDetachVehiclesToVehiclesGroupMutationTypeKeySpecifier | (() => undefined | EcoDrivingDetachVehiclesToVehiclesGroupMutationTypeKeySpecifier),
		fields?: EcoDrivingDetachVehiclesToVehiclesGroupMutationTypeFieldPolicy,
	},
	EcoDrivingDriverRankingType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EcoDrivingDriverRankingTypeKeySpecifier | (() => undefined | EcoDrivingDriverRankingTypeKeySpecifier),
		fields?: EcoDrivingDriverRankingTypeFieldPolicy,
	},
	EcoDrivingDriverStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EcoDrivingDriverStatisticsKeySpecifier | (() => undefined | EcoDrivingDriverStatisticsKeySpecifier),
		fields?: EcoDrivingDriverStatisticsFieldPolicy,
	},
	EcoDrivingGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EcoDrivingGroupKeySpecifier | (() => undefined | EcoDrivingGroupKeySpecifier),
		fields?: EcoDrivingGroupFieldPolicy,
	},
	EcoDrivingModule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EcoDrivingModuleKeySpecifier | (() => undefined | EcoDrivingModuleKeySpecifier),
		fields?: EcoDrivingModuleFieldPolicy,
	},
	EcoDrivingMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EcoDrivingMutationTypeKeySpecifier | (() => undefined | EcoDrivingMutationTypeKeySpecifier),
		fields?: EcoDrivingMutationTypeFieldPolicy,
	},
	EcoDrivingSettingsType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EcoDrivingSettingsTypeKeySpecifier | (() => undefined | EcoDrivingSettingsTypeKeySpecifier),
		fields?: EcoDrivingSettingsTypeFieldPolicy,
	},
	EcoDrivingType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EcoDrivingTypeKeySpecifier | (() => undefined | EcoDrivingTypeKeySpecifier),
		fields?: EcoDrivingTypeFieldPolicy,
	},
	EcoDrivingUpdateSettingsMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EcoDrivingUpdateSettingsMutationTypeKeySpecifier | (() => undefined | EcoDrivingUpdateSettingsMutationTypeKeySpecifier),
		fields?: EcoDrivingUpdateSettingsMutationTypeFieldPolicy,
	},
	EcoDrivingUpdateVehiclesGroupMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EcoDrivingUpdateVehiclesGroupMutationTypeKeySpecifier | (() => undefined | EcoDrivingUpdateVehiclesGroupMutationTypeKeySpecifier),
		fields?: EcoDrivingUpdateVehiclesGroupMutationTypeFieldPolicy,
	},
	EcoDrivingVehicleGroupType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EcoDrivingVehicleGroupTypeKeySpecifier | (() => undefined | EcoDrivingVehicleGroupTypeKeySpecifier),
		fields?: EcoDrivingVehicleGroupTypeFieldPolicy,
	},
	Eta?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EtaKeySpecifier | (() => undefined | EtaKeySpecifier),
		fields?: EtaFieldPolicy,
	},
	EtaArrival?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EtaArrivalKeySpecifier | (() => undefined | EtaArrivalKeySpecifier),
		fields?: EtaArrivalFieldPolicy,
	},
	EtaCurrentRest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EtaCurrentRestKeySpecifier | (() => undefined | EtaCurrentRestKeySpecifier),
		fields?: EtaCurrentRestFieldPolicy,
	},
	EtaDistance?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EtaDistanceKeySpecifier | (() => undefined | EtaDistanceKeySpecifier),
		fields?: EtaDistanceFieldPolicy,
	},
	EtaLightModule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EtaLightModuleKeySpecifier | (() => undefined | EtaLightModuleKeySpecifier),
		fields?: EtaLightModuleFieldPolicy,
	},
	EtaLightTask?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EtaLightTaskKeySpecifier | (() => undefined | EtaLightTaskKeySpecifier),
		fields?: EtaLightTaskFieldPolicy,
	},
	EtaLightTaskMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EtaLightTaskMutationTypeKeySpecifier | (() => undefined | EtaLightTaskMutationTypeKeySpecifier),
		fields?: EtaLightTaskMutationTypeFieldPolicy,
	},
	EtaLightType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EtaLightTypeKeySpecifier | (() => undefined | EtaLightTypeKeySpecifier),
		fields?: EtaLightTypeFieldPolicy,
	},
	EtaMonitor?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EtaMonitorKeySpecifier | (() => undefined | EtaMonitorKeySpecifier),
		fields?: EtaMonitorFieldPolicy,
	},
	EtaRestTakenType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EtaRestTakenTypeKeySpecifier | (() => undefined | EtaRestTakenTypeKeySpecifier),
		fields?: EtaRestTakenTypeFieldPolicy,
	},
	FeatureFlagsType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FeatureFlagsTypeKeySpecifier | (() => undefined | FeatureFlagsTypeKeySpecifier),
		fields?: FeatureFlagsTypeFieldPolicy,
	},
	FireTms?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FireTmsKeySpecifier | (() => undefined | FireTmsKeySpecifier),
		fields?: FireTmsFieldPolicy,
	},
	FireTmsDriverApp?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FireTmsDriverAppKeySpecifier | (() => undefined | FireTmsDriverAppKeySpecifier),
		fields?: FireTmsDriverAppFieldPolicy,
	},
	Fleet?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FleetKeySpecifier | (() => undefined | FleetKeySpecifier),
		fields?: FleetFieldPolicy,
	},
	FuelTankProbeType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FuelTankProbeTypeKeySpecifier | (() => undefined | FuelTankProbeTypeKeySpecifier),
		fields?: FuelTankProbeTypeFieldPolicy,
	},
	FuelTankType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FuelTankTypeKeySpecifier | (() => undefined | FuelTankTypeKeySpecifier),
		fields?: FuelTankTypeFieldPolicy,
	},
	FuelTanksType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FuelTanksTypeKeySpecifier | (() => undefined | FuelTanksTypeKeySpecifier),
		fields?: FuelTanksTypeFieldPolicy,
	},
	GboxAuthorizationAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GboxAuthorizationAccountKeySpecifier | (() => undefined | GboxAuthorizationAccountKeySpecifier),
		fields?: GboxAuthorizationAccountFieldPolicy,
	},
	GboxAuthorizationAccountMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GboxAuthorizationAccountMutationTypeKeySpecifier | (() => undefined | GboxAuthorizationAccountMutationTypeKeySpecifier),
		fields?: GboxAuthorizationAccountMutationTypeFieldPolicy,
	},
	Incident?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IncidentKeySpecifier | (() => undefined | IncidentKeySpecifier),
		fields?: IncidentFieldPolicy,
	},
	IncidentType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IncidentTypeKeySpecifier | (() => undefined | IncidentTypeKeySpecifier),
		fields?: IncidentTypeFieldPolicy,
	},
	KeyValueType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KeyValueTypeKeySpecifier | (() => undefined | KeyValueTypeKeySpecifier),
		fields?: KeyValueTypeFieldPolicy,
	},
	Legacy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LegacyKeySpecifier | (() => undefined | LegacyKeySpecifier),
		fields?: LegacyFieldPolicy,
	},
	LegacyAlertsModule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LegacyAlertsModuleKeySpecifier | (() => undefined | LegacyAlertsModuleKeySpecifier),
		fields?: LegacyAlertsModuleFieldPolicy,
	},
	LegacyAssistModule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LegacyAssistModuleKeySpecifier | (() => undefined | LegacyAssistModuleKeySpecifier),
		fields?: LegacyAssistModuleFieldPolicy,
	},
	LegacyHistoryModule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LegacyHistoryModuleKeySpecifier | (() => undefined | LegacyHistoryModuleKeySpecifier),
		fields?: LegacyHistoryModuleFieldPolicy,
	},
	LegacyReportsModule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LegacyReportsModuleKeySpecifier | (() => undefined | LegacyReportsModuleKeySpecifier),
		fields?: LegacyReportsModuleFieldPolicy,
	},
	LegacyTemporaryLinksModule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LegacyTemporaryLinksModuleKeySpecifier | (() => undefined | LegacyTemporaryLinksModuleKeySpecifier),
		fields?: LegacyTemporaryLinksModuleFieldPolicy,
	},
	LoadPart?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LoadPartKeySpecifier | (() => undefined | LoadPartKeySpecifier),
		fields?: LoadPartFieldPolicy,
	},
	MapModuleClientSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MapModuleClientSettingsKeySpecifier | (() => undefined | MapModuleClientSettingsKeySpecifier),
		fields?: MapModuleClientSettingsFieldPolicy,
	},
	MapModuleClientSettingsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MapModuleClientSettingsResponseKeySpecifier | (() => undefined | MapModuleClientSettingsResponseKeySpecifier),
		fields?: MapModuleClientSettingsResponseFieldPolicy,
	},
	MapModuleIncidentsListResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MapModuleIncidentsListResponseKeySpecifier | (() => undefined | MapModuleIncidentsListResponseKeySpecifier),
		fields?: MapModuleIncidentsListResponseFieldPolicy,
	},
	MapModuleUserPointGroupsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MapModuleUserPointGroupsResponseKeySpecifier | (() => undefined | MapModuleUserPointGroupsResponseKeySpecifier),
		fields?: MapModuleUserPointGroupsResponseFieldPolicy,
	},
	MapModuleUserPointsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MapModuleUserPointsResponseKeySpecifier | (() => undefined | MapModuleUserPointsResponseKeySpecifier),
		fields?: MapModuleUserPointsResponseFieldPolicy,
	},
	MapModuleUserSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MapModuleUserSettingsKeySpecifier | (() => undefined | MapModuleUserSettingsKeySpecifier),
		fields?: MapModuleUserSettingsFieldPolicy,
	},
	MapModuleUserSettingsList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MapModuleUserSettingsListKeySpecifier | (() => undefined | MapModuleUserSettingsListKeySpecifier),
		fields?: MapModuleUserSettingsListFieldPolicy,
	},
	MapModuleUserSettingsListVehicleDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MapModuleUserSettingsListVehicleDetailsKeySpecifier | (() => undefined | MapModuleUserSettingsListVehicleDetailsKeySpecifier),
		fields?: MapModuleUserSettingsListVehicleDetailsFieldPolicy,
	},
	MapModuleUserSettingsListVehicleInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MapModuleUserSettingsListVehicleInfoKeySpecifier | (() => undefined | MapModuleUserSettingsListVehicleInfoKeySpecifier),
		fields?: MapModuleUserSettingsListVehicleInfoFieldPolicy,
	},
	MapModuleUserSettingsListVehicleTitle?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MapModuleUserSettingsListVehicleTitleKeySpecifier | (() => undefined | MapModuleUserSettingsListVehicleTitleKeySpecifier),
		fields?: MapModuleUserSettingsListVehicleTitleFieldPolicy,
	},
	MapModuleUserSettingsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MapModuleUserSettingsResponseKeySpecifier | (() => undefined | MapModuleUserSettingsResponseKeySpecifier),
		fields?: MapModuleUserSettingsResponseFieldPolicy,
	},
	Me?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MeKeySpecifier | (() => undefined | MeKeySpecifier),
		fields?: MeFieldPolicy,
	},
	MobilityPackageModule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MobilityPackageModuleKeySpecifier | (() => undefined | MobilityPackageModuleKeySpecifier),
		fields?: MobilityPackageModuleFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	NullResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NullResponseKeySpecifier | (() => undefined | NullResponseKeySpecifier),
		fields?: NullResponseFieldPolicy,
	},
	Order?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderKeySpecifier | (() => undefined | OrderKeySpecifier),
		fields?: OrderFieldPolicy,
	},
	OrderTask?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderTaskKeySpecifier | (() => undefined | OrderTaskKeySpecifier),
		fields?: OrderTaskFieldPolicy,
	},
	OrdersModule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrdersModuleKeySpecifier | (() => undefined | OrdersModuleKeySpecifier),
		fields?: OrdersModuleFieldPolicy,
	},
	PaginationResultType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginationResultTypeKeySpecifier | (() => undefined | PaginationResultTypeKeySpecifier),
		fields?: PaginationResultTypeFieldPolicy,
	},
	PartnerAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PartnerAccountKeySpecifier | (() => undefined | PartnerAccountKeySpecifier),
		fields?: PartnerAccountFieldPolicy,
	},
	PartnerAccountMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PartnerAccountMutationTypeKeySpecifier | (() => undefined | PartnerAccountMutationTypeKeySpecifier),
		fields?: PartnerAccountMutationTypeFieldPolicy,
	},
	Payload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadKeySpecifier | (() => undefined | PayloadKeySpecifier),
		fields?: PayloadFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	RPMDistribution?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RPMDistributionKeySpecifier | (() => undefined | RPMDistributionKeySpecifier),
		fields?: RPMDistributionFieldPolicy,
	},
	ResetGboxAuthorizationAccountPasswordMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ResetGboxAuthorizationAccountPasswordMutationTypeKeySpecifier | (() => undefined | ResetGboxAuthorizationAccountPasswordMutationTypeKeySpecifier),
		fields?: ResetGboxAuthorizationAccountPasswordMutationTypeFieldPolicy,
	},
	ResetPartnerAccountPasswordMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ResetPartnerAccountPasswordMutationTypeKeySpecifier | (() => undefined | ResetPartnerAccountPasswordMutationTypeKeySpecifier),
		fields?: ResetPartnerAccountPasswordMutationTypeFieldPolicy,
	},
	Settings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SettingsKeySpecifier | (() => undefined | SettingsKeySpecifier),
		fields?: SettingsFieldPolicy,
	},
	StopOnEngine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StopOnEngineKeySpecifier | (() => undefined | StopOnEngineKeySpecifier),
		fields?: StopOnEngineFieldPolicy,
	},
	System?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SystemKeySpecifier | (() => undefined | SystemKeySpecifier),
		fields?: SystemFieldPolicy,
	},
	TachoRemote2Module?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemote2ModuleKeySpecifier | (() => undefined | TachoRemote2ModuleKeySpecifier),
		fields?: TachoRemote2ModuleFieldPolicy,
	},
	TachoRemoteActionMessageMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteActionMessageMutationTypeKeySpecifier | (() => undefined | TachoRemoteActionMessageMutationTypeKeySpecifier),
		fields?: TachoRemoteActionMessageMutationTypeFieldPolicy,
	},
	TachoRemoteAuthorizationAppCompanyCardDataType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteAuthorizationAppCompanyCardDataTypeKeySpecifier | (() => undefined | TachoRemoteAuthorizationAppCompanyCardDataTypeKeySpecifier),
		fields?: TachoRemoteAuthorizationAppCompanyCardDataTypeFieldPolicy,
	},
	TachoRemoteAuthorizationAppMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteAuthorizationAppMutationTypeKeySpecifier | (() => undefined | TachoRemoteAuthorizationAppMutationTypeKeySpecifier),
		fields?: TachoRemoteAuthorizationAppMutationTypeFieldPolicy,
	},
	TachoRemoteAuthorizationAppType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteAuthorizationAppTypeKeySpecifier | (() => undefined | TachoRemoteAuthorizationAppTypeKeySpecifier),
		fields?: TachoRemoteAuthorizationAppTypeFieldPolicy,
	},
	TachoRemoteAuthorizationAppsResultType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteAuthorizationAppsResultTypeKeySpecifier | (() => undefined | TachoRemoteAuthorizationAppsResultTypeKeySpecifier),
		fields?: TachoRemoteAuthorizationAppsResultTypeFieldPolicy,
	},
	TachoRemoteClientMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteClientMutationTypeKeySpecifier | (() => undefined | TachoRemoteClientMutationTypeKeySpecifier),
		fields?: TachoRemoteClientMutationTypeFieldPolicy,
	},
	TachoRemoteClientType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteClientTypeKeySpecifier | (() => undefined | TachoRemoteClientTypeKeySpecifier),
		fields?: TachoRemoteClientTypeFieldPolicy,
	},
	TachoRemoteCompaniesResultType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteCompaniesResultTypeKeySpecifier | (() => undefined | TachoRemoteCompaniesResultTypeKeySpecifier),
		fields?: TachoRemoteCompaniesResultTypeFieldPolicy,
	},
	TachoRemoteCompanyCardConnectionType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteCompanyCardConnectionTypeKeySpecifier | (() => undefined | TachoRemoteCompanyCardConnectionTypeKeySpecifier),
		fields?: TachoRemoteCompanyCardConnectionTypeFieldPolicy,
	},
	TachoRemoteCompanyCardMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteCompanyCardMutationTypeKeySpecifier | (() => undefined | TachoRemoteCompanyCardMutationTypeKeySpecifier),
		fields?: TachoRemoteCompanyCardMutationTypeFieldPolicy,
	},
	TachoRemoteCompanyCardType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteCompanyCardTypeKeySpecifier | (() => undefined | TachoRemoteCompanyCardTypeKeySpecifier),
		fields?: TachoRemoteCompanyCardTypeFieldPolicy,
	},
	TachoRemoteCompanyCardsResultType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteCompanyCardsResultTypeKeySpecifier | (() => undefined | TachoRemoteCompanyCardsResultTypeKeySpecifier),
		fields?: TachoRemoteCompanyCardsResultTypeFieldPolicy,
	},
	TachoRemoteCompanyMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteCompanyMutationTypeKeySpecifier | (() => undefined | TachoRemoteCompanyMutationTypeKeySpecifier),
		fields?: TachoRemoteCompanyMutationTypeFieldPolicy,
	},
	TachoRemoteCompanyType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteCompanyTypeKeySpecifier | (() => undefined | TachoRemoteCompanyTypeKeySpecifier),
		fields?: TachoRemoteCompanyTypeFieldPolicy,
	},
	TachoRemoteCompanyVehiclesMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteCompanyVehiclesMutationTypeKeySpecifier | (() => undefined | TachoRemoteCompanyVehiclesMutationTypeKeySpecifier),
		fields?: TachoRemoteCompanyVehiclesMutationTypeFieldPolicy,
	},
	TachoRemoteCreateCompanyMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteCreateCompanyMutationTypeKeySpecifier | (() => undefined | TachoRemoteCreateCompanyMutationTypeKeySpecifier),
		fields?: TachoRemoteCreateCompanyMutationTypeFieldPolicy,
	},
	TachoRemoteDeactivateAuthorizationAppMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteDeactivateAuthorizationAppMutationTypeKeySpecifier | (() => undefined | TachoRemoteDeactivateAuthorizationAppMutationTypeKeySpecifier),
		fields?: TachoRemoteDeactivateAuthorizationAppMutationTypeFieldPolicy,
	},
	TachoRemoteDeleteCompanyMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteDeleteCompanyMutationTypeKeySpecifier | (() => undefined | TachoRemoteDeleteCompanyMutationTypeKeySpecifier),
		fields?: TachoRemoteDeleteCompanyMutationTypeFieldPolicy,
	},
	TachoRemoteDriverCardMetaType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteDriverCardMetaTypeKeySpecifier | (() => undefined | TachoRemoteDriverCardMetaTypeKeySpecifier),
		fields?: TachoRemoteDriverCardMetaTypeFieldPolicy,
	},
	TachoRemoteDriverCardMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteDriverCardMutationTypeKeySpecifier | (() => undefined | TachoRemoteDriverCardMutationTypeKeySpecifier),
		fields?: TachoRemoteDriverCardMutationTypeFieldPolicy,
	},
	TachoRemoteDriverCardReadAdditionalReadOrdersMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteDriverCardReadAdditionalReadOrdersMutationTypeKeySpecifier | (() => undefined | TachoRemoteDriverCardReadAdditionalReadOrdersMutationTypeKeySpecifier),
		fields?: TachoRemoteDriverCardReadAdditionalReadOrdersMutationTypeFieldPolicy,
	},
	TachoRemoteDriverCardReadLastReadType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteDriverCardReadLastReadTypeKeySpecifier | (() => undefined | TachoRemoteDriverCardReadLastReadTypeKeySpecifier),
		fields?: TachoRemoteDriverCardReadLastReadTypeFieldPolicy,
	},
	TachoRemoteDriverCardReadNextReadType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteDriverCardReadNextReadTypeKeySpecifier | (() => undefined | TachoRemoteDriverCardReadNextReadTypeKeySpecifier),
		fields?: TachoRemoteDriverCardReadNextReadTypeFieldPolicy,
	},
	TachoRemoteDriverCardReadStatusType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteDriverCardReadStatusTypeKeySpecifier | (() => undefined | TachoRemoteDriverCardReadStatusTypeKeySpecifier),
		fields?: TachoRemoteDriverCardReadStatusTypeFieldPolicy,
	},
	TachoRemoteDriverCardReadStatusesResultType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteDriverCardReadStatusesResultTypeKeySpecifier | (() => undefined | TachoRemoteDriverCardReadStatusesResultTypeKeySpecifier),
		fields?: TachoRemoteDriverCardReadStatusesResultTypeFieldPolicy,
	},
	TachoRemoteDriverCardReadType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteDriverCardReadTypeKeySpecifier | (() => undefined | TachoRemoteDriverCardReadTypeKeySpecifier),
		fields?: TachoRemoteDriverCardReadTypeFieldPolicy,
	},
	TachoRemoteDriverCardReadsResultType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteDriverCardReadsResultTypeKeySpecifier | (() => undefined | TachoRemoteDriverCardReadsResultTypeKeySpecifier),
		fields?: TachoRemoteDriverCardReadsResultTypeFieldPolicy,
	},
	TachoRemoteDriverCardType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteDriverCardTypeKeySpecifier | (() => undefined | TachoRemoteDriverCardTypeKeySpecifier),
		fields?: TachoRemoteDriverCardTypeFieldPolicy,
	},
	TachoRemoteFileType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteFileTypeKeySpecifier | (() => undefined | TachoRemoteFileTypeKeySpecifier),
		fields?: TachoRemoteFileTypeFieldPolicy,
	},
	TachoRemoteModule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteModuleKeySpecifier | (() => undefined | TachoRemoteModuleKeySpecifier),
		fields?: TachoRemoteModuleFieldPolicy,
	},
	TachoRemoteMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteMutationTypeKeySpecifier | (() => undefined | TachoRemoteMutationTypeKeySpecifier),
		fields?: TachoRemoteMutationTypeFieldPolicy,
	},
	TachoRemoteStatusMessageType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteStatusMessageTypeKeySpecifier | (() => undefined | TachoRemoteStatusMessageTypeKeySpecifier),
		fields?: TachoRemoteStatusMessageTypeFieldPolicy,
	},
	TachoRemoteStatusType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteStatusTypeKeySpecifier | (() => undefined | TachoRemoteStatusTypeKeySpecifier),
		fields?: TachoRemoteStatusTypeFieldPolicy,
	},
	TachoRemoteSupportForMultipleCompanyMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteSupportForMultipleCompanyMutationTypeKeySpecifier | (() => undefined | TachoRemoteSupportForMultipleCompanyMutationTypeKeySpecifier),
		fields?: TachoRemoteSupportForMultipleCompanyMutationTypeFieldPolicy,
	},
	TachoRemoteSuspendReadsMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteSuspendReadsMutationTypeKeySpecifier | (() => undefined | TachoRemoteSuspendReadsMutationTypeKeySpecifier),
		fields?: TachoRemoteSuspendReadsMutationTypeFieldPolicy,
	},
	TachoRemoteTachographMetaType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteTachographMetaTypeKeySpecifier | (() => undefined | TachoRemoteTachographMetaTypeKeySpecifier),
		fields?: TachoRemoteTachographMetaTypeFieldPolicy,
	},
	TachoRemoteTachographMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteTachographMutationTypeKeySpecifier | (() => undefined | TachoRemoteTachographMutationTypeKeySpecifier),
		fields?: TachoRemoteTachographMutationTypeFieldPolicy,
	},
	TachoRemoteTachographReadAdditionalReadOrdersMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteTachographReadAdditionalReadOrdersMutationTypeKeySpecifier | (() => undefined | TachoRemoteTachographReadAdditionalReadOrdersMutationTypeKeySpecifier),
		fields?: TachoRemoteTachographReadAdditionalReadOrdersMutationTypeFieldPolicy,
	},
	TachoRemoteTachographReadLastReadType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteTachographReadLastReadTypeKeySpecifier | (() => undefined | TachoRemoteTachographReadLastReadTypeKeySpecifier),
		fields?: TachoRemoteTachographReadLastReadTypeFieldPolicy,
	},
	TachoRemoteTachographReadNextReadType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteTachographReadNextReadTypeKeySpecifier | (() => undefined | TachoRemoteTachographReadNextReadTypeKeySpecifier),
		fields?: TachoRemoteTachographReadNextReadTypeFieldPolicy,
	},
	TachoRemoteTachographReadStatusType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteTachographReadStatusTypeKeySpecifier | (() => undefined | TachoRemoteTachographReadStatusTypeKeySpecifier),
		fields?: TachoRemoteTachographReadStatusTypeFieldPolicy,
	},
	TachoRemoteTachographReadStatusesResultType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteTachographReadStatusesResultTypeKeySpecifier | (() => undefined | TachoRemoteTachographReadStatusesResultTypeKeySpecifier),
		fields?: TachoRemoteTachographReadStatusesResultTypeFieldPolicy,
	},
	TachoRemoteTachographReadType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteTachographReadTypeKeySpecifier | (() => undefined | TachoRemoteTachographReadTypeKeySpecifier),
		fields?: TachoRemoteTachographReadTypeFieldPolicy,
	},
	TachoRemoteTachographReadsResultType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteTachographReadsResultTypeKeySpecifier | (() => undefined | TachoRemoteTachographReadsResultTypeKeySpecifier),
		fields?: TachoRemoteTachographReadsResultTypeFieldPolicy,
	},
	TachoRemoteTachographType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteTachographTypeKeySpecifier | (() => undefined | TachoRemoteTachographTypeKeySpecifier),
		fields?: TachoRemoteTachographTypeFieldPolicy,
	},
	TachoRemoteType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteTypeKeySpecifier | (() => undefined | TachoRemoteTypeKeySpecifier),
		fields?: TachoRemoteTypeFieldPolicy,
	},
	TachoRemoteUnsuspendReadsMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteUnsuspendReadsMutationTypeKeySpecifier | (() => undefined | TachoRemoteUnsuspendReadsMutationTypeKeySpecifier),
		fields?: TachoRemoteUnsuspendReadsMutationTypeFieldPolicy,
	},
	TachoRemoteUpdateCompanyCardMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteUpdateCompanyCardMutationTypeKeySpecifier | (() => undefined | TachoRemoteUpdateCompanyCardMutationTypeKeySpecifier),
		fields?: TachoRemoteUpdateCompanyCardMutationTypeFieldPolicy,
	},
	TachoRemoteUpdateCompanyMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteUpdateCompanyMutationTypeKeySpecifier | (() => undefined | TachoRemoteUpdateCompanyMutationTypeKeySpecifier),
		fields?: TachoRemoteUpdateCompanyMutationTypeFieldPolicy,
	},
	TachoRemoteVehicleType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteVehicleTypeKeySpecifier | (() => undefined | TachoRemoteVehicleTypeKeySpecifier),
		fields?: TachoRemoteVehicleTypeFieldPolicy,
	},
	TachoRemoteVehiclesType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteVehiclesTypeKeySpecifier | (() => undefined | TachoRemoteVehiclesTypeKeySpecifier),
		fields?: TachoRemoteVehiclesTypeFieldPolicy,
	},
	TachoRemoteWarningType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TachoRemoteWarningTypeKeySpecifier | (() => undefined | TachoRemoteWarningTypeKeySpecifier),
		fields?: TachoRemoteWarningTypeFieldPolicy,
	},
	TargetType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TargetTypeKeySpecifier | (() => undefined | TargetTypeKeySpecifier),
		fields?: TargetTypeFieldPolicy,
	},
	Task?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskKeySpecifier | (() => undefined | TaskKeySpecifier),
		fields?: TaskFieldPolicy,
	},
	TaskAttachment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskAttachmentKeySpecifier | (() => undefined | TaskAttachmentKeySpecifier),
		fields?: TaskAttachmentFieldPolicy,
	},
	TasksModule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TasksModuleKeySpecifier | (() => undefined | TasksModuleKeySpecifier),
		fields?: TasksModuleFieldPolicy,
	},
	UpdateDriverMutationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDriverMutationTypeKeySpecifier | (() => undefined | UpdateDriverMutationTypeKeySpecifier),
		fields?: UpdateDriverMutationTypeFieldPolicy,
	},
	UsageType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsageTypeKeySpecifier | (() => undefined | UsageTypeKeySpecifier),
		fields?: UsageTypeFieldPolicy,
	},
	UserPoint?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserPointKeySpecifier | (() => undefined | UserPointKeySpecifier),
		fields?: UserPointFieldPolicy,
	},
	UserPointGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserPointGroupKeySpecifier | (() => undefined | UserPointGroupKeySpecifier),
		fields?: UserPointGroupFieldPolicy,
	},
	UserPointPosition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserPointPositionKeySpecifier | (() => undefined | UserPointPositionKeySpecifier),
		fields?: UserPointPositionFieldPolicy,
	},
	Vehicle?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleKeySpecifier | (() => undefined | VehicleKeySpecifier),
		fields?: VehicleFieldPolicy,
	},
	VehicleAppearanceType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleAppearanceTypeKeySpecifier | (() => undefined | VehicleAppearanceTypeKeySpecifier),
		fields?: VehicleAppearanceTypeFieldPolicy,
	},
	VehicleCurrentFuel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleCurrentFuelKeySpecifier | (() => undefined | VehicleCurrentFuelKeySpecifier),
		fields?: VehicleCurrentFuelFieldPolicy,
	},
	VehicleCurrentGps?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleCurrentGpsKeySpecifier | (() => undefined | VehicleCurrentGpsKeySpecifier),
		fields?: VehicleCurrentGpsFieldPolicy,
	},
	VehicleCurrentType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleCurrentTypeKeySpecifier | (() => undefined | VehicleCurrentTypeKeySpecifier),
		fields?: VehicleCurrentTypeFieldPolicy,
	},
	VehicleData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleDataKeySpecifier | (() => undefined | VehicleDataKeySpecifier),
		fields?: VehicleDataFieldPolicy,
	},
	VehicleDeviceType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleDeviceTypeKeySpecifier | (() => undefined | VehicleDeviceTypeKeySpecifier),
		fields?: VehicleDeviceTypeFieldPolicy,
	},
	VehicleExtended?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleExtendedKeySpecifier | (() => undefined | VehicleExtendedKeySpecifier),
		fields?: VehicleExtendedFieldPolicy,
	},
	VehicleGroupType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleGroupTypeKeySpecifier | (() => undefined | VehicleGroupTypeKeySpecifier),
		fields?: VehicleGroupTypeFieldPolicy,
	},
	VehicleType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleTypeKeySpecifier | (() => undefined | VehicleTypeKeySpecifier),
		fields?: VehicleTypeFieldPolicy,
	},
	WorkTimeActivity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WorkTimeActivityKeySpecifier | (() => undefined | WorkTimeActivityKeySpecifier),
		fields?: WorkTimeActivityFieldPolicy,
	},
	WorkingTimeModule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WorkingTimeModuleKeySpecifier | (() => undefined | WorkingTimeModuleKeySpecifier),
		fields?: WorkingTimeModuleFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;